/* eslint-disable no-unused-vars */
/* eslint-disable no-throw-literal */
// @flow weak
import React, { Component } from "react";
import { Prompt } from "react-router";
import { connect } from "react-redux";
import { Calendar } from "react-date-range";
import {
  Button,
  Col,
  Row,
  Icon,
  FormControl,
  PanelContainer,
  Panel,
  PanelHeader,
  PanelBody,
} from "@sketchpixy/rubix";
import * as _ from "lodash";
import moment from "moment";

//question types
import MultiCheckBoxField from "../Questions/multiCheckbox";

import { PatientActions } from "../reducers/patient/index";
import PlayRomVideo from "../components/playRomVideo";
import MuscleStrengthScale from "../components/MuscleStrengthScale";
import ReflexExamScale from "../components/ReflexExamScale";
import MiniDocumentViewer from "../components/MiniDocumentViewer";
import NotificationSystem from "react-notification-system";
import QuestionDisclaimer from "../components/QuestionDisclaimer";
import WeightTextField from "../components/Disabilities/WeightTextField";

import back_questions from "../DBQs/back";
import neck_questions from "../DBQs/neck";
import ankle_questions from "../DBQs/ankle";
import wrist_questions from "../DBQs/wrist";
import hip_questions from "../DBQs/hip";
import knee_questions from "../DBQs/knee";
import shoulder_questions from "../DBQs/shoulder";
import elbow_questions from "../DBQs/elbow";
import mental_questions from "../DBQs/mental";
import ptsd_questions from "../DBQs/ptsd";
import kidney_questions from "../DBQs/kidney";
import kidney_old_questions from "../DBQs/kidney-old-criteria";
import ibs_questions from "../DBQs/ibs";
import nerves_questions from "../DBQs/nerves";
import sinusitis_questions from "../DBQs/sinusitis";
import veins_questions from "../DBQs/veins";
import tmj_questions from "../DBQs/tmj";
import sleep_questions from "../DBQs/sleep";
import headache_questions from "../DBQs/headache";
import heart_questions from "../DBQs/heart";
import hepatitis_questions from "../DBQs/hepatitis";
import prostateCancer_questions from "../DBQs/prostateCancer";
import seizure_questions from "../DBQs/seizure";
import foot_questions from "../DBQs/foot";
import asthma_questions from "../DBQs/asthma";
import handFingers_questions from "../DBQs/handFingers";
import bladder_questions from "../DBQs/bladder";
import fibromyalgia_questions from "../DBQs/fibromyalgia";
import arthritis_questions from "../DBQs/arthritis";
import skin_questions from "../DBQs/skin";
import gerd_questions from "../DBQs/gerd";
import hemorrhoids_questions from "../DBQs/hemorrhoids";
import diabeticNeuro_questions from "../DBQs/diabeticNeuro";
import diabetes_questions from "../DBQs/diabetes";
import ed_questions from "../DBQs/erectileDysfunction";
import scars_questions from "../DBQs/scars";
import ms_questions from "../DBQs/multiSclerosis";
import hiv_questions from "../DBQs/hiv";
import eat_questions from "../DBQs/eating";

import back_ssn from "../ssn/back";
import neck_ssn from "../ssn/neck";
import ankle_ssn from "../ssn/ankle";
import wrist_ssn from "../ssn/wrist";
import knee_ssn from "../ssn/knee";
import shoulder_ssn from "../ssn/shoulder";
import hip_ssn from "../ssn/hip";
import elbow_ssn from "../ssn/elbow";
import mental_ssn from "../ssn/mental";
import ptsd_ssn from "../ssn/ptsd";
import kidney_ssn from "../ssn/kidney";
import ibs_ssn from "../ssn/ibs";
import sinusitis_ssn from "../ssn/sinusitis";
import veins_ssn from "../ssn/veins";
import tmj_ssn from "../ssn/tmj";
import sleep_ssn from "../ssn/sleep";
import headache_ssn from "../ssn/headache";
import heart_ssn from "../ssn/heart";
import nerves_ssn from "../ssn/nerves";
import hepatitis_ssn from "../ssn/hepatitis";
import prostateCancer_ssn from "../ssn/prostateCancer";
import seizure_ssn from "../ssn/seizure";
import skin_ssn from "../ssn/skin";
import foot_ssn from "../ssn/foot";
import asthma_ssn from "../ssn/asthma";
import handFingers_ssn from "../ssn/handFingers";
import bladder_ssn from "../ssn/bladder";
import fibromyalgia_ssn from "../ssn/fibromyalgia";
import arthritis_ssn from "../ssn/arthritis";
import gerd_ssn from "../ssn/gerd";
import hemorrhoids_ssn from "../ssn/hemorrhoids";
import diabeticNeuro_ssn from "../ssn/diabeticNeuro";
import diabetes_ssn from "../ssn/diabetes";
import ed_ssn from "../ssn/erectileDysfunction";
import scars_ssn from "../ssn/scars";
import ms_ssn from "../ssn/multiSclerosis";
import hiv_ssn from "../DBQs/hiv";
import eat_ssn from "../DBQs/eating";

//Disability Logic Imports
import { filterByRelatedExtremity } from "../disabilityLogic/filterByRelatedExtremity"
import { kneeLigamentSkip } from "../disabilityLogic/kneeLigamentSkip";
import {
  syncScarQuestionSummary,
  updateScarQuestionSelection,
} from "../disabilityLogic/scars";
import {
  getAdditionalRemarksContext,
  getDiagnosisRemarksPrefillContext,
  getDiagnosisRemarksPrefillSelection,
  initializeDiagnosisRemarksTracking,
  markDiagnosisRemarksCompleted,
  syncDiagnosisRemarksForAddedDiagnoses,
  syncDiagnosisRemarksPrefillSelection,
  validateRequiredRemarksForAddedDiagnoses,
} from "../examLogic/diagnosisRemarks";
import {
  getVisibleTextItems,
  syncConditionalTextQuestions,
} from "../examLogic/conditionalTextQuestions";
import { syncControlledSelectQuestions } from "../examLogic/controlledSelectQuestions";
import { validateAnswerValueRules } from "../examLogic/answerValueValidation";
import { validateAnswerConsistency } from "../examLogic/answerConsistencyValidation";
import { validateCrossQuestionValues } from "../examLogic/crossQuestionValueValidation";
import { validateLinkedSelectionDependency } from "../examLogic/linkedSelectionValidation";
import {
  isResponseBlocked,
  sanitizeBlockedResponses,
} from "../examLogic/responseBlocking";
import {
  clearInvalidDependentSelectAnswers,
  getSelectOptionValues,
  getSelectPlaceholder,
  getSelectValue,
  hasSelectAnswer,
  isCloneOnlySelectQuestion,
  isDependentSelect,
  isSelectDisabled,
  syncClonedSelectAnswers,
} from "../examLogic/selectDependencies";
import { normalizeExamQuestions } from "../examLogic/normalizeExamQuestions";
import { applyFinalAnswerDefaults } from "../examLogic/finalAnswerDefaults";
import { getTextareaPresidence } from "../examLogic/yesNo";
import { getQuestionConfirmation } from "../examLogic/unansweredConfirmation";
import {
  clearDropdownTextFields,
  getDropdownTextFieldConfig,
  getDropdownTextFieldOptionLabel,
  getDropdownTextFieldOptionValue,
  getDropdownTextFieldOtherField,
  getDropdownTextFieldSelectionField,
  isDropdownTextFieldOtherSelected,
  syncDropdownTextFieldValue,
  validateDropdownTextFields,
} from "../examLogic/dropdownTextField";
import {
  getIndexedVisibleExamItems,
  getVisibleExamItems,
  isExamItemVisible,
} from "../examLogic/disabilityExtremityVisibility";

import { intToRoman } from "../utils/intToRoman";

const getDbqSrc = (currentDbq) => {
  let src = currentDbq && currentDbq.src ? currentDbq.src : "";
  if (src) return src;

  let dbqText = `${(currentDbq && currentDbq.name) || ""} ${
    (currentDbq && currentDbq.name_fv) || ""
  }`.toLowerCase();
  if (dbqText.includes("knee")) return "knee";

  return "";
};

const getDiagnosesAndExtremities = (currentDbq, patient) => {
  if (!currentDbq || !patient || !patient.disabilities) return null;

  for (let disab of patient.disabilities) {
    if (disab.dbqId === currentDbq.id) {
      return disab.diagnosesAndExtremities || null;
    }
  }

  return null;
};

function getDropdownTextFieldRows(question, fieldName) {
  const rowFieldByTextField = {
    text1: "rows1",
    text2: "rows2",
    text3: "rows3",
    textOther: "rowsOther",
    textOther2: "rowsOther2",
    textOther3: "rowsOther3",
  };
  const rowField = rowFieldByTextField[fieldName];

  return (rowField && question[rowField]) || "2";
}

function DropdownTextField(props) {
  const { question, fieldName, name, position, index, onTyping, placeholder } =
    props;
  const config = getDropdownTextFieldConfig(question, fieldName);
  const selectedField = getDropdownTextFieldSelectionField(fieldName);
  const otherField = getDropdownTextFieldOtherField(fieldName);

  if (!config) {
    return (
      <textarea
        name={fieldName + name + position + index}
        id={fieldName + name + position + index}
        placeholder={placeholder || "Please specify"}
        rows={getDropdownTextFieldRows(question, fieldName)}
        value={question[fieldName]}
        style={{
          border: "1px solid #079EDA",
          borderRadius: 20,
          marginTop: 10,
          padding: "5px 10px 5px 10px",
        }}
        onChange={(e) =>
          onTyping({
            questionIndex: position,
            index,
            value: e.target.value,
            field: fieldName,
          })
        }
        className="required textarea-modal"
      ></textarea>
    );
  }

  return (
    <div className="radio-modal-dropdown-text">
      <select
        id={selectedField + name + position + index}
        aria-label={config.label || config.placeholder || "Select an option"}
        className="radio-modal-dropdown-text__select"
        value={question[selectedField] || ""}
        onChange={(e) =>
          onTyping({
            questionIndex: position,
            index,
            value: e.target.value,
            field: selectedField,
            dropdownTextField: fieldName,
          })
        }
      >
        <option value="" disabled>
          {config.placeholder || "Select an option"}
        </option>
        {(config.options || []).map((option) => {
          const value = getDropdownTextFieldOptionValue(option);
          return (
            <option key={value} value={value}>
              {getDropdownTextFieldOptionLabel(option)}
            </option>
          );
        })}
      </select>
      {isDropdownTextFieldOtherSelected(question, fieldName) && (
        <textarea
          name={otherField + name + position + index}
          id={otherField + name + position + index}
          placeholder={
            config.otherPlaceholder || placeholder || "Please specify"
          }
          rows={getDropdownTextFieldRows(question, fieldName)}
          value={question[otherField] || ""}
          onChange={(e) =>
            onTyping({
              questionIndex: position,
              index,
              value: e.target.value,
              field: otherField,
              dropdownTextField: fieldName,
            })
          }
          className="required textarea-modal radio-modal-dropdown-text__other"
        ></textarea>
      )}
    </div>
  );
}

export function TextArea(props) {
  const {
    name,
    placeholder,
    position,
    onChangeValue,
    answer,
    optional,
    hasVeteranResponse,
    fieldName,
    setAdditionalResponse,
    questions,
  } = props;
  let { maxLength } = props;
  let maxLen = maxLength ? maxLength : null;
  const specificQuestion = questions.filter(
    (item) => item.dbqName === fieldName
  );
  const diagnosisRemarksPrefillContext = getDiagnosisRemarksPrefillContext(
    questions[position],
    questions
  );
  const additionalRemarksContext = getAdditionalRemarksContext(
    questions[position],
    questions
  );
  const diagnosisRemarksPrefillOptions = diagnosisRemarksPrefillContext.options;
  const addedDiagnosisNames = diagnosisRemarksPrefillContext.addedDiagnoses.map(
    (diagnosis) => diagnosis.name
  );
  const shouldShowAdditionalRemarks =
    diagnosisRemarksPrefillOptions.length > 0 || additionalRemarksContext.required;
  const diagnosisRemarksAnswer =
    questions[position].diagnosisRemarksAnswer || "";
  const textareaQuestion = questions[position] || {};
  const answerDropdownConfig = getDropdownTextFieldConfig(
    textareaQuestion,
    "answer"
  );
  const answerDropdownSelectionField =
    getDropdownTextFieldSelectionField("answer");
  return (
    <div
      style={{ marginBottom: "25px" }}
      key={props.position}
      className="show-with-ease"
    >
      {answerDropdownConfig && (
        <div className="diagnosis-remarks-prefill textarea-dropdown-prefill">
          {answerDropdownConfig.label && (
            <label
              className="diagnosis-remarks-prefill__label"
              htmlFor={`textareaAnswerDropdown${position}`}
            >
              {answerDropdownConfig.label}
            </label>
          )}
          <select
            id={`textareaAnswerDropdown${position}`}
            className="diagnosis-remarks-prefill__select"
            disabled={hasVeteranResponse}
            value={textareaQuestion[answerDropdownSelectionField] || ""}
            onChange={(e) =>
              onChangeValue({
                questionIndex: position,
                value: e.target.value,
                field: answerDropdownSelectionField,
                dropdownTextField: "answer",
              })
            }
          >
            <option value="" disabled>
              {answerDropdownConfig.placeholder ||
                "Choose a template to prefill the response"}
            </option>
            {(answerDropdownConfig.options || []).map((option) => {
              const value = getDropdownTextFieldOptionValue(option);
              return (
                <option key={value} value={value}>
                  {getDropdownTextFieldOptionLabel(option)}
                </option>
              );
            })}
          </select>
        </div>
      )}
      <textarea
        name={"textarea" + name + position}
        id={"textarea" + name + position}
        placeholder={placeholder || ""}
        rows="6"
        value={answer}
        onChange={(e) =>
          onChangeValue({ questionIndex: position, value: e.target.value })
        }
        onBlur={(e) =>
          onChangeValue({ questionIndex: position, value: e.target.value })
        }
        className="required textarea-blue text-area"
        title={hasVeteranResponse ? "Read only" : ""}
        disabled={hasVeteranResponse}
      ></textarea>
      {maxLength || !optional ? (
        <div
          style={
            maxLen - answer.length < 30
              ? { color: "red", fontSize: 16 }
              : { fontSize: 16 }
          }
        >
          {answer && answer.length ? answer.length : 0}/{maxLen}
        </div>
      ) : (
        ""
      )}
      {hasVeteranResponse === true ? (
        <div style={{ marginTop: "1rem" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <button
              style={{
                padding: "1rem",
                color: "white",
                backgroundColor: "black",
                borderRadius: "10px",
                fontSize: "16px",
                marginRight: "30px",
              }}
              type="button"
              onClick={() => setAdditionalResponse(fieldName, "", true, false)}
            >
              Add comment
            </button>
            <button
              style={{
                padding: "1rem",
                color: "white",
                backgroundColor: "black",
                borderRadius: "10px",
                fontSize: "16px",
              }}
              type="button"
              onClick={() =>
                setAdditionalResponse(fieldName, answer || "", true, true)
              }
            >
              Override comment
            </button>
          </div>
          <br />
          <textarea
            className="required textarea-blue text-area animate__animated animate__fadeInDown"
            style={{
              display:
                specificQuestion &&
                specificQuestion[0] &&
                specificQuestion[0].hasAdditionalResponse
                  ? "block"
                  : "none",
              width: "90%",
              margin: "0 auto 2rem auto",
            }}
            rows={6}
            placeholder={specificQuestion[0].isOverwritten ? "This comment will override the original answer" :"Add provider comment here. Please note this comment will be appended to the original answer and it will be displayed on the final DBQ"}
            value={
              (specificQuestion &&
                specificQuestion[0] &&
                specificQuestion[0].additionalResponse) ||
              ""
            }
            onChange={(e) => setAdditionalResponse(fieldName, e.target.value)}
          />
          {specificQuestion &&
                specificQuestion[0] &&
                specificQuestion[0].hasAdditionalResponse && (
            <button
              style={{
                padding: "1rem",
                color: "white",
                backgroundColor: "black",
                borderRadius: "10px",
                fontSize: "16px",
                marginRight: "10px",
              }}
              type="button"
              onClick={() => setAdditionalResponse(fieldName, "", true, false, true)}
            >
              Remove comment
            </button>
          )}
        </div>
      ) : null}
      {shouldShowAdditionalRemarks && (
        <div className="diagnosis-remarks-prefill">
          <label
            className="diagnosis-remarks-prefill__label"
            htmlFor={`diagnosisRemarksPrefill${position}`}
          >
            {diagnosisRemarksPrefillOptions.length > 0
              ? "Statement Template (use of the template is optional, not the statement itself)"
              : additionalRemarksContext.label}
          </label>
          {addedDiagnosisNames.length > 0 && (
            <div className="diagnosis-remarks-prefill__added-diagnoses">
              <strong>Diagnoses added during this exam:</strong>{" "}
              {addedDiagnosisNames.join(", ")}
            </div>
          )}
          {additionalRemarksContext.required &&
            additionalRemarksContext.labels.length > 0 && (
              <div className="diagnosis-remarks-prefill__added-diagnoses">
                <strong>Additional explanation required for:</strong>{" "}
                {additionalRemarksContext.labels.join(", ")}
              </div>
            )}
          {diagnosisRemarksPrefillOptions.length > 0 && (
            <select
              id={`diagnosisRemarksPrefill${position}`}
              className="diagnosis-remarks-prefill__select"
              value={getDiagnosisRemarksPrefillSelection(questions[position])}
              onChange={(e) =>
                onChangeValue({
                  questionIndex: position,
                  value: e.target.value,
                  field: "diagnosisRemarksPrefillSelection",
                })
              }
            >
              <option value="">Choose a template to prefill the remarks</option>
              {diagnosisRemarksPrefillOptions.map((option, index) => (
                <option key={option.label} value={String(index)}>
                  {option.label}
                </option>
              ))}
            </select>
          )}
          {questions[position].diagnosisRemarksPrefillDisclaimer && (
            <div className="diagnosis-remarks-prefill__disclaimer">
              <strong>Review required:</strong>{" "}
              {questions[position].diagnosisRemarksPrefillDisclaimer}
            </div>
          )}
          <textarea
            name={"diagnosisRemarksTextarea" + name + position}
            id={"diagnosisRemarksTextarea" + name + position}
            placeholder={
              additionalRemarksContext.required
                ? additionalRemarksContext.placeholder
                : "Provide a diagnosis remarks statement."
            }
            rows="6"
            value={diagnosisRemarksAnswer}
            onChange={(e) =>
              onChangeValue({
                questionIndex: position,
                value: e.target.value,
                field: "diagnosisRemarksAnswer",
              })
            }
            onBlur={(e) =>
              onChangeValue({
                questionIndex: position,
                value: e.target.value,
                field: "diagnosisRemarksAnswer",
              })
            }
            className="required textarea-blue text-area diagnosis-remarks-prefill__textarea"
          ></textarea>
        </div>
      )}
      {
          questions[position].showDisclaimer && questions[position].answer === questions[position].defaultanswer && (
          <div>
            <br />
            <h3
              style={{
                color: "red",
                paddingBottom: "1rem",
                width: "80%",
                margin: "0 auto",
                fontWeight: "bold"
              }}
            >
              {
                questions[position].disclaimerLabel
              }
            </h3>
            <br />
          </div>
        )
      }
    </div>
  );
}

export function TextField(props) {
  const {
    name,
    questions,
    placeholder,
    position,
    onChangeValue,
    onClickPlayVideo,
    videoFirstColumn,
    videoSecondColumn,
    onClickCloseVideo,
    selectedVideo,
    selectedValue,
  } = props;
  let firstVideo = false;
  let secondVideo = false;
  let videoplay = new Array(questions.length);
  const selectQuestion = { options: questions };
  const visibleQuestionEntries = questions
    .map((optn, index) => ({ optn, index }))
    .filter(({ optn }) => optn.show !== false);
  const splitIndex =
    visibleQuestionEntries.length > 1
      ? visibleQuestionEntries.length / 2
      : visibleQuestionEntries.length;
  const renderTextFieldControl = ({
    optn,
    optionIndex,
    fieldName,
    fieldId,
    onChange,
    style,
  }) => {
    const commonProps = {
      autoFocus: true,
      disabled: isSelectDisabled(selectQuestion, optn),
      key: "textfield" + fieldId,
      className:
        optn.type === "textarea"
          ? "text-field text-field-textarea required"
          : "text-field required",
      name: fieldName,
      maxLength: optn.maxLength ? optn.maxLength : "",
      onChange,
      id: fieldId,
      placeholder: optn.placeholder || placeholder || "",
    };

    if (optn.type === "textarea") {
      return (
        <FormControl
          {...commonProps}
          componentClass="textarea"
          rows={optn.rows || 5}
          value={optn.answer}
          style={style}
        />
      );
    }

    if (optn.type === "select") {
      return (
        <FormControl
          {...commonProps}
          type=""
          componentClass="select"
          value={getSelectValue(selectQuestion, optn)}
          style={style}
        >
          {(optn.placeholder || isDependentSelect(optn)) && (
            <option value="" disabled>
              {getSelectPlaceholder(selectQuestion, optn)}
            </option>
          )}
          {getSelectOptionValues(selectQuestion, optn).map((val, j) => (
            <option
              className="select-option"
              key={"selectOption" + fieldId + j + optionIndex}
              value={val}
              label={val}
            />
          ))}
        </FormControl>
      );
    }

    return (
      <FormControl
        {...commonProps}
        type={optn.type}
        value={optn.answer}
        style={style}
      />
    );
  };

  return (
    <div key={props.position} className="show-with-ease">
      {props.controlledSelectNote && (
        <div className="controlled-select-note">
          {props.controlledSelectNote}
        </div>
      )}
      {/* <div className='col-sm-6 col-md-6' style={{display: !videoFirstColumn ? "block": "none"}}> */}
      <div
        className={
          visibleQuestionEntries.length > 1
            ? "col-sm-6 col-md-6"
            : "col-sm-12 col-md-12"
        }
      >
        {visibleQuestionEntries
          .slice(0, splitIndex)
          .map(({ optn, index }) => (
            <PanelContainer
              key={"panelContainer" + name + position + index}
              containerClasses="rubix-panel-container-with-bottom-shadow border-radius25"
            >
              <Panel>
                <PanelBody
                  className={`textfield-2col ${
                    optn.type === "textarea" ? "textfield-2col-textarea" : ""
                  } ${
                    optn.video && optn.video === selectedVideo
                      ? "rom-panel-active"
                      : "rom-panel-not-active"
                  }`}
                >
                  <div className="row">
                    <div
                      key={"textfieldDiv" + name + position + index}
                      className="row col-md-12"
                    >
                      {optn.video || optn.image ? (
                        <div>
                          <div
                            className="col-md-4 col-xs-4 textfield-image-container"
                            style={{ height: "187px" }}
                          >
                            {optn.video ? (
                              <video
                                ref={(video) => {
                                  videoplay[index] = video;
                                }}
                                key={optn.video}
                                style={{ width: "180px", cursor: "zoom-in" }}
                                onClick={(e) =>
                                  onClickPlayVideo(optn.video, optn.answer)
                                }
                              >
                                <source src={optn.video} type="video/mp4" />
                              </video>
                            ) : (
                              <img
                                className="textfield-image"
                                src={optn.image}
                              />
                            )}
                          </div>
                          <div className="col-md-8 col-xs-8 textfield-mt40">
                            <div className="col-xs-12 col-md-12">
                              <label className="fg-black textfield-heading">
                                {optn.main}
                              </label>
                              <label className="textfield-subheading">
                                {optn.subMain}
                              </label>
                            </div>
                            <div className="col-xs-12 col-md-12 p-0">
                              <label className="textfield-label">
                                {optn.sub}
                              </label>
                              {renderTextFieldControl({
                                optn,
                                optionIndex: index,
                                fieldName: name + index,
                                fieldId: name + index,
                                onChange: (e) => {
                                  let args = {
                                    questionIndex: position,
                                    index: index,
                                    value: e.target.value,
                                  }
                                  if (optn.video) {
                                    args = {
                                      ...args,
                                      videoTag: videoplay[index],
                                      col: "first",
                                      videoTagLeft: secondVideo,
                                    }
                                  }
                                  onChangeValue(args)
                                },
                                style:
                                  optn.defaultVal &&
                                  hasSelectAnswer(optn.answer) &&
                                  optn.answer != optn.defaultVal
                                    ? {
                                        backgroundColor: "#F12F39",
                                        color: "white",
                                      }
                                    : {},
                              })}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div
                            className={
                              optn.type === "textarea"
                                ? "col-sm-12 col-md-12"
                                : "col-sm-8 col-md-8"
                            }
                          >
                            <label className="fg-black textfield-heading">
                              {optn.main}
                            </label>
                            <label className="textfield-subheading">
                              {optn.subMain}
                            </label>
                          </div>
                          <div
                            className={
                              optn.type === "textarea"
                                ? "col-sm-12 col-md-12 p-0"
                                : "col-sm-4 col-md-4 p-0"
                            }
                          >
                            {optn.type !== "textarea" && optn.sub ? (
                              <label className="textfield-label">
                                {optn.sub}
                              </label>
                            ) : null}
                            {renderTextFieldControl({
                              optn,
                              optionIndex: index,
                              fieldName: name + index + position,
                              fieldId: name + index + position,
                              onChange: (e) =>
                                onChangeValue({
                                  questionIndex: position,
                                  index: index,
                                  value: e.target.value,
                                }),
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </PanelBody>
              </Panel>
            </PanelContainer>
          ))}
      </div>
      {/* <div className='col-sm-6 col-md-6' style={{display: videoFirstColumn ? "block": "none"}}>
                <PanelContainer key={"panelContainerOther"+name+position} containerClasses="rubix-panel-container-with-bottom-shadow border-radius25">
                    <Panel>
                        <PanelBody className="textfield-2col">
                            <div style={{height: '709px'}}>
                                <div>
                                    <span style={{fontSize: '72px', color: '#079EDA'}}>{selectedValue}<sup>o</sup></span>
                                    <button className='rom-panel-close-btn rom-panel-close-btn-mr pull-right' onClick={e => {onClickCloseVideo({side: "left"})}}>
                                        X
                                </button>
                                </div>
                                <div className="col-sm-12">
                                <video ref={(video) => {firstVideo = video}} key="video1" style={{width: '100%'}} >
                                                <source src='' type="video/mp4" />    
                                            </video>
                                </div>
                        </div>
                        </PanelBody>
                    </Panel>
                </PanelContainer>
            </div> */}

{/* This is used by the second question in knee Initial Range of Motion (ROM) Measurements (Extension question) */}
      {
        // questions.length > 1 && <div className='col-sm-6 col-md-6' style={{display: !videoSecondColumn ? "block": "none"}}>
        visibleQuestionEntries.length > 1 && (
          <div className="col-sm-6 col-md-6">
            {visibleQuestionEntries
              .slice(splitIndex)
              .map(({ optn, index }) => (
                <PanelContainer
                  key={"panelContainerOtherSide" + name + position + index}
                  containerClasses="rubix-panel-container-with-bottom-shadow border-radius25"
                >
                  <Panel>
                    <PanelBody
                      className={`textfield-2col ${
                        optn.type === "textarea"
                          ? "textfield-2col-textarea"
                          : ""
                      } ${
                        optn.video && optn.video === selectedVideo
                          ? "rom-panel-active"
                          : "rom-panel-not-active"
                      }`}
                    >
                      <div className="row">
                        <div
                          key={
                            "textfieldDiv" + name + position + index
                          }
                          className="row col-md-12"
                        >
                          {optn.video || optn.image ? (
                            <div>
                              <div
                                className="col-md-4 col-xs-4 textfield-image-container"
                                style={{ height: "187px" }}
                              >
                                {optn.video ? (
                                  <video
                                    ref={(video) => {
                                      videoplay[index] = video;
                                    }}
                                    key={optn.video}
                                    style={{ width: "180px", cursor: "zoom-in" }}
                                    onClick={(e) =>
                                      onClickPlayVideo(optn.video, optn.answer)
                                    }
                                  >
                                    <source src={optn.video} type="video/mp4" />
                                  </video>
                                ) : (
                                  <img
                                    className="textfield-image"
                                    src={optn.image}
                                  />
                                )}
                              </div>
                              <div className="col-md-8 col-xs-8 textfield-mt40">
                                <div className="col-xs-12 col-md-12">
                                  <label className="fg-black textfield-heading">
                                    {optn.main}
                                  </label>
                                  <label className="textfield-subheading">
                                    {optn.subMain}
                                  </label>
                                </div>
                                <div className="col-xs-12 col-md-12 p-0">
                                  <label className="textfield-label">
                                    {optn.sub}
                                  </label>
                                  {renderTextFieldControl({
                                    optn,
                                    optionIndex: index,
                                    fieldName: name + index,
                                    fieldId: name + index,
                                    onChange: (e) => {
                                      let args = {
                                        questionIndex: position,
                                        index,
                                        value: e.target.value,
                                      }
                                      if (optn.video) {
                                        args = {
                                          ...args,
                                          videoTag: videoplay[index],
                                          col: "second",
                                          videoTagLeft: firstVideo,
                                        }
                                      }
                                      onChangeValue(args)
                                    },
                                    style:
                                      optn.defaultVal &&
                                      hasSelectAnswer(optn.answer) &&
                                      optn.answer !== optn.defaultVal
                                        ? {
                                            backgroundColor: "#F12F39",
                                            color: "white",
                                          }
                                        : {},
                                  })}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div
                                className={
                                  optn.type === "textarea"
                                    ? "col-sm-12 col-md-12"
                                    : "col-sm-8 col-md-8"
                                }
                              >
                                <label className="fg-black textfield-heading">
                                  {optn.main}
                                </label>
                                <label className="textfield-subheading">
                                  {optn.subMain}
                                </label>
                              </div>
                              <div
                                className={
                                  optn.type === "textarea"
                                    ? "col-sm-12 col-md-12 p-0"
                                    : "col-sm-4 col-md-4 p-0"
                                }
                              >
                                {optn.type !== "textarea" && optn.sub ? (
                                  <label className="textfield-label">
                                    {optn.sub}
                                  </label>
                                ) : null}
                                {renderTextFieldControl({
                                  optn,
                                  optionIndex: index,
                                  fieldName: name + index,
                                  fieldId: name + index,
                                  onChange: (e) =>
                                    onChangeValue({
                                      questionIndex: position,
                                      index,
                                      value: e.target.value,
                                    }),
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </PanelBody>
                  </Panel>
                </PanelContainer>
              ))}
          </div>
        )
      }
      {/* {questions.length > 1 && <div className='col-sm-6 col-md-6' style={{display: videoSecondColumn ? "block": "none"}}>
                <PanelContainer key={"panelContainerOtherSide"+name+position} containerClasses="rubix-panel-container-with-bottom-shadow border-radius25">
                    <Panel>
                        <PanelBody className="textfield-2col">
                            <div style={{height: '709px'}}>
                            <div>
                                    <span style={{fontSize: '72px', color: '#079EDA'}}>{selectedValue}<sup>o</sup></span>
                                    <button className='rom-panel-close-btn rom-panel-close-btn-mr pull-right' onClick={e => {onClickCloseVideo({side: "right"})}}>
                                        X
                                </button>
                                <div className="col-sm-12">
                                <video ref={(video) => {secondVideo = video}} key="video2" style={{width: '100%'}} >
                                                <source src='' type="video/mp4" />    
                                            </video>
                                </div>
                                </div>
                        </div>
                        </PanelBody>
                    </Panel>
                </PanelContainer>
            </div>
            } */}
    </div>
  );
}

export function SelectField(props) {
  const {
    name,
    questions,
    rules,
    position,
    onChangeValue,
    onClickLegend,
    isLegendViewing,
  } = props;
  const pillsColors = [
    "#092433",
    "#023855",
    "#005A8C",
    "#0072B0",
    "#008DDB",
    "#02A4FF",
  ];

  const components = {
    muscleStrengthScale: MuscleStrengthScale,
    reflexExamScale: ReflexExamScale,
  };
  const Legend = rules ? components[rules[0].legend] : "";

  return (
    <div key={props.position} className="show-with-ease">
      {props.controlledSelectNote && (
        <div className="controlled-select-note">
          {props.controlledSelectNote}
        </div>
      )}
      {rules ? (
        <div className="row col-sm-12">
          <div className="col-sm-5 col-md-5"></div>
          <div
            className="col-sm-4 col-md-3 legend-position"
            onClick={(e) => onClickLegend()}
          >
            Rate Strength Scale{" "}
            <span>
              <img src="/imgs/app/legend-view.svg" alt="Legend icon" />
            </span>
          </div>
          <div className="col-sm-4"></div>
        </div>
      ) : (
        ""
      )}

      {rules && isLegendViewing && (
        <Legend rules={rules} onClose={(e) => onClickLegend()} />
      )}

      {questions.map((question, i) => (
        <div
          key={"selectFieldfirstDiv" + name + position + i}
          className="col-sm-6"
          style={{ float: question.float ? "right" : "left" }}
        >
          <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
            <Panel>
              <PanelHeader className="row selectbox-header">
                <div
                  style={{ color: question.title !== "." ? "#079EDA" : "#fff" }}
                  className="text-left col-sm-12 selectbox-heading"
                >
                  {question.title}{" "}
                </div>
                <div className="fg-black text-center col-xs-offset-1 col-xs-7 selectbox-subheading1">
                  {question.label}
                </div>
                <div className="fg-black text-center col-xs-4 selectbox-subheading2">
                  {question.subMain}
                </div>
              </PanelHeader>
              <PanelBody className="selectbox-body">
                <PanelContainer>
                  <Panel>
                    <PanelBody className="selectbox-bodyinner">
                      <div className="row select-question-padding-left">
                        {question.options.map((optn, index) => (
                          <div
                            key={"selectFieldDiv" + name + position + index}
                            className={
                              optn.values
                                ? "col-md-12 selectbox-single"
                                : "col-md-12 mp-0 text-left"
                            }
                          >
                            {optn.values ? (
                              <label className="col-sm-7 selectbox-label mp-0">
                                {optn.main}
                              </label>
                            ) : (
                              <label className="col-sm-9 selectbox-label mp-0">
                                {optn.main}
                              </label>
                            )}

                            {optn.subMain ? (
                              <label className="col-sm-7 mp-0">
                                {optn.subMain}
                              </label>
                            ) : (
                              ""
                            )}
                            {optn.values ? (
                              <div className="col-sm-5 mp-0">
                                <FormControl
                                  id={optn.main + position + index + i}
                                  name={optn.main + position + index + i}
                                  key={
                                    "selectField" + name + position + index + i
                                  }
                                  componentClass="select"
                                  placeholder="select"
                                  disabled={isSelectDisabled(question, optn)}
                                  value={getSelectValue(question, optn)}
                                  onChange={(e) =>
                                    onChangeValue({
                                      questionIndex: position,
                                      index: i,
                                      indexSecond: index,
                                      value: e.target.value,
                                    })
                                  }
                                  className={
                                    !hasSelectAnswer(optn.answer) || optn.answer == optn.defaultVal
                                      ? "select-box"
                                      : "select-box-abnormal"
                                  }
                                >
                                  {(!hasSelectAnswer(optn.answer) ||
                                    optn.placeholder ||
                                    isDependentSelect(optn)) && (
                                    <option value="" disabled>
                                      {getSelectPlaceholder(question, optn)}
                                    </option>
                                  )}
                                  {getSelectOptionValues(question, optn)
                                    .map((val, j) => (
                                      <option
                                        className="select-option"
                                        key={
                                          "selectOption" +
                                          name +
                                          position +
                                          j +
                                          index
                                        }
                                        value={val}
                                        label={val}
                                      />
                                    ))}
                                </FormControl>
                              </div>
                            ) : (
                              <div
                                className="col-sm-2 muscle-strength-rate rules-pill"
                                style={{
                                  backgroundColor: pillsColors[optn.sub[0]],
                                }}
                              >
                                {optn.sub}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    {
                      question.questionType === "Neck muscle strength" && (
                        <Button onClick={(e) => setDefaultValues({index: i, position, onChangeValue, question})}>All Normal</Button>
                      )
                    }
                    </PanelBody>
                  </Panel>
                </PanelContainer>
              </PanelBody>
            </Panel>
          </PanelContainer>
        </div>
      ))}
    </div>
  );
}

function setDefaultValues ({index, position, onChangeValue, question}) {
  question.options.forEach((opt, i) => {
    onChangeValue({
      questionIndex: position,
      index: index,
      indexSecond: i,
      value: "5",
    })
  })
}

export function CalendarField(props) {
  const {
    name,
    questions,
    rules,
    position,
    onChangeValue,
    onClickLegend,
    isLegendViewing,
  } = props;

  let offsetDiv = "col-sm-";
  offsetDiv += questions.length > 1 ? "0" : "3";

  let questionDiv = "col-sm-";
  questionDiv +=
    questions.length === 1 ? "6" : questions.length === 2 ? "6" : "4";

  return (
    <div key={props.position} className="show-with-ease">
      {questions.map((question, i) => (
        <div>
          <div className={offsetDiv}></div>
          <div
            key={"selectFieldfirstDiv" + name + position + i}
            className={questionDiv}
          >
            <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
              <Panel>
                <PanelHeader className="row selectbox-header">
                  <div
                    style={{
                      color: question.title !== "." ? "#079EDA" : "#fff",
                    }}
                    className="text-left col-sm-12 selectbox-heading"
                  >
                    {question.title}{" "}
                  </div>
                  {/* <div className='fg-black text-center col-xs-offset-1 col-xs-7 selectbox-subheading1'>{question.label}</div>    
                                    <div className='fg-black text-center col-xs-4 selectbox-subheading2'>{question.subMain}</div>                          */}
                </PanelHeader>
                <PanelBody className="selectbox-body">
                  <PanelContainer>
                    <Panel>
                      <PanelBody className="selectbox-bodyinner">
                        <div className="row"> 
                          {question.options.map((optn, index) => (
                            <div
                              key={"selectFieldDiv" + name + position + index}
                              style={{
                                paddingLeft: "10%",
                                paddingRight: "10%",
                              }}
                            >
                              <div>
                                <FormControl
                                  id={optn.main + position + index + i}
                                  name={optn.main + position + index + i}
                                  key={
                                    "selectField" + name + position + index + i
                                  }
                                  componentClass="select"
                                  placeholder="select"
                                  value={optn.answer}
                                  onChange={(e) =>
                                    onChangeValue({
                                      questionIndex: position,
                                      index: i,
                                      indexSecond: index,
                                      value: e.target.value,
                                    })
                                  }
                                  className="select-box"
                                >
                                  {/* <option value="" >Choose...</option> */}
                                  {optn.values &&
                                    optn.values.map((val, j) => (
                                      <option
                                        className="select-option"
                                        key={
                                          "selectOption" +
                                          name +
                                          position +
                                          j +
                                          index
                                        }
                                        value={val}
                                        label={val}
                                      />
                                    ))}
                                </FormControl>
                              </div>
                            </div>
                          ))}
                        </div>
                      </PanelBody>
                    </Panel>
                  </PanelContainer>
                </PanelBody>
              </Panel>
            </PanelContainer>
          </div>
        </div>
      ))}
    </div>
  );
}

export function RadioField(props) {
  const {
    name,
    questions,
    left = true,
    position,
    onChangeValue,
    refValue,
    diagnosesAndExtremities,
  } = props;
  const visibleQuestions = getIndexedVisibleExamItems(questions);

  // New Params for radio questions
  let mainDiv = "col-sm-";
  mainDiv +=
    visibleQuestions.length === 1
      ? "10"
      : visibleQuestions.length === 3
      ? "4"
      : "6";

  let offsetDiv = "col-sm-";
  offsetDiv += visibleQuestions.length === 1 ? "4" : "1";

  let questionDiv = "col-sm-";
  questionDiv +=
    visibleQuestions.length === 1
      ? "6"
      : visibleQuestions.length === 3
      ? "12"
      : "10";


  const checkServiceConnected = ( disabilitySide ) => {

    let isServiceConnected = false
    if(diagnosesAndExtremities) {

      switch (disabilitySide){
        case "Right Knee":     
          diagnosesAndExtremities.forEach(diagnosis => {
            if (diagnosis.extremity === "Right Lower Extremity" || diagnosis.extremity === "Bilateral Lower Extremities"){
              if (diagnosis.initialRating !== "N/A" && diagnosis.initialRating !== "Not Service Connected") isServiceConnected = true
            }
          })
          break;
        case "Left Knee":
          diagnosesAndExtremities.forEach(diagnosis => {
            if (diagnosis.extremity === "Left Lower Extremity" || diagnosis.extremity === "Bilateral Lower Extremities"){
              if (diagnosis.initialRating !== "N/A" && diagnosis.initialRating !== "Not Service Connected") isServiceConnected = true
            }
          })
          break;
        default: break;
      }
    }
    return isServiceConnected ? "(Is Service Connected)" : null

  }

  return (
    <div key={props.position} className="show-with-ease">
      {visibleQuestions.map(({ item: question, index: i }) => (
        <div
          key={"radioDiv" + i + name + position}
          className={mainDiv}
          style={{ padding: 0 }}
        >
          <div className={offsetDiv}></div>

          <div className={questionDiv}>
            <div key={"divRadioField" + position + i} style={{ padding: "0" }}>
              <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
                <Panel>
                  <PanelHeader className="radio-right-box-heading">
                    <label
                      className="text-left radio-right-heading"
                      style={{ color: question.title ? "#079EDA" : "#022144" }}
                    >
                      {question.title}
                    </label>
                    <label
                      className=" text-center radio-right-sub-heading"
                      style={{ color: question.title ? "#022144" : "#079EDA" }}
                    >
                      {question.label}
                    </label>

                    {question.addServiceConnected
                      ? (<label className="text-center radio-right-box-subhead1" 
                          style={{color: "black"}}> 
                          {checkServiceConnected(question.label)}
                        </label>)
                      : (<label className="text-center radio-right-box-subhead1"> {question.subMain} </label>)}

                    {/* <label className='fg-black text-right radio-right-box-subhead2' >{question.sub}</label>                            */}
                  </PanelHeader>
                  <PanelBody className="radio-right-innerbox">
                    <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
                      <Panel>
                        <PanelBody className="radio-right-innerbox-body">
                          {question.options.map((optn, index) => (
                            <div key={"div" + position + index + i} >
                              <label className="text-center radio-right-innerbox-label">
                                <span className="text-left fg-black radio-right-innerbox-label-text" >
                                  {optn.main}
                                  {optn.disclaimer ?  (<QuestionDisclaimer disclaimer={optn.disclaimer}/>):("")}
                                </span>
                                <input
                                  type="radio"
                                  className={
                                    question.defaultVal &&
                                    optn.main !== question.defaultVal
                                      ? "abnormal-radio"
                                      : "custom-radio"
                                  }
                                  key={
                                    "radioField" + name + position + index + i
                                  }
                                  name={name + position + i}
                                  checked={optn.main === question.answer}
                                  value={optn.main}
                                  disabled={
                                    !refValue
                                      ? false
                                      : refValue === "Both"
                                      ? false
                                      : refValue === "Right" && question.right
                                      ? false
                                      : refValue === "Left" && !question.right
                                      ? false
                                      : true
                                  }
                                   onChange={(e) =>
                                    onChangeValue({
                                      questionIndex: position,
                                      index: i,
                                      indexSecond: index,
                                      value: e.target.value,
                                    })
                                  } 
                                  label={optn.main}
                                />
                              </label>
                            </div>
                          ))}
                        </PanelBody>
                      </Panel>
                    </PanelContainer>
                  </PanelBody>
                </Panel>
              </PanelContainer>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// Takes in the questions array from the kidney "JOINT INVOLVEMENT" section.
// Outputs array where inner arrays consist of questions with the same body parts
const groupQuestionsByBodyPart = questions => {
  const groupedByBodyPart = {}

  questions.forEach(question => {
      if (!groupedByBodyPart[question.bodyPart]) {
          groupedByBodyPart[question.bodyPart] = []
      }
      groupedByBodyPart[question.bodyPart].push(question)
  })

  return Object.values(groupedByBodyPart)
}

// A generic container for cards, providing a consistent style and layout.
function CardContainer({ children, style }) {
  return <div className="card-container" style={style}>{children}</div>;
}

// Represents an individual question item within the card.
// Triggers the onChangeHandler from questionConfig when clicked.
function QuestionItem({ questionConfig, question }) {
  return (
    <div onClick={() => {
      questionConfig.onChangeHandler({
        questionIndex: questionConfig.position,
        index: question.index,
        value: question.main
      })
    }} className={`question-item ${question.answer ? "selected-joints" : ""}`}>
      <span className="radio-selection">
        <img className={`sun-img-custom ${question.answer ? "checked" : ""}`} alt="radio" />
        <h6>{question.main}</h6>
      </span>
    </div>
  );
}

// Represents a card that displays questions for a specific body part.
// Used specifically for the "JOINT INVOLVEMENT" questions in the Kidney DBQ.
function QuestionCard({questionConfig, bodyPart, questions }) {
  return (
    <CardContainer style={{ margin: "5px" }}>
      <div className="card-body">
        <h5 className="card-title">{bodyPart}</h5>
        <div className="questions-container">
          {questions.map(question => <QuestionItem index={question.index} questionConfig={questionConfig} key={question.main} question={question} />)}
        </div>
      </div>
    </CardContainer>
  );
}

export function RadioTilesField(props) {
  const {
    name,
    questions,
    position,
    onChangeValue,
    cols,
    answer,
    textanswer,
    textAnswer,
    multi,
    height,
    placeholder,
    textarea,
    small,
  } = props;
  let offset = "col-sm-";
  // offset += 12 / cols;
  offset += !cols || cols == 1 ? 12 : 6;

  const questionConfig = {
    onChangeHandler: onChangeValue,
    position
  };

  // KIDNEY DBQ: For the "JOINT INVOLVEMENT" section, generate distinct cards for each body part based on the provided DBQ questions.
  if (props.sectionTitle === "JOINT INVOLVEMENT") {
    // Arrange the questions in a specific order:
    // 1. All questions related to the "Left" joints, sorted by their index.
    // 2. All questions related to the "Right" joints, similarly sorted.
    // 3. All remaining questions that don't specify "Left" or "Right", sorted as well.
    const leftQuestions = questions.filter(q => q.main.includes("Left")).sort((a, b) => a.index - b.index);
    const rightQuestions = questions.filter(q => q.main.includes("Right")).sort((a, b) => a.index - b.index);
    const neitherQuestions = questions.filter(q => !q.main.includes("Left") && !q.main.includes("Right")).sort((a, b) => a.index - b.index);
    const orderedQuestions = [...leftQuestions, ...rightQuestions, ...neitherQuestions];
    
    // Group the ordered questions by their 'bodyPart' for card generation.
    const reNestedQuestions = groupQuestionsByBodyPart(orderedQuestions)

    // Map through each grouped set of questions, generating a card for each body part.
    const cards = reNestedQuestions.map(q => <QuestionCard questionConfig={questionConfig} key={q[0].bodyPart} bodyPart={q[0].bodyPart} questions={q} />);

    return (
        <div className="cards-container">
            {cards}
        </div>
    );
  }


  return (
    <div key={props.position} className="show-with-ease">
      {/* <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
        <Panel>
        <PanelBody >        */}
      <div className={offset}>
        <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
          <Panel>
            <PanelBody className="radio-right-innerbox">
              {questions
                .slice(
                  0,
                  cols > 1 && questions.length > 1
                    ? questions.length / 2
                    : questions.length
                )
                .map((question, i) => (
                  <div key={"divMainRadioTilesField" + position + i}>
                    <div
                      key={"divRadioTilesField" + position + i}
                      className="col-sm-12"
                      style={{ padding: "0" }}
                    >
                      <PanelContainer
                        containerClasses={
                          multi
                            ? question.dbqName === question.answer
                              ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                              : "rubix-panel-container-with-bottom-shadow-inner"
                            : question.dbqName === answer
                            ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                            : "rubix-panel-container-with-bottom-shadow-inner"
                        }
                      >
                        <div style={{ display: "flex" }}>
                          <label style={{ width: "100%", marginBottom: 0 }}>
                            <Panel>
                              <PanelBody
                                className="radio-right-innerbox"
                                style={{
                                  height:
                                    textarea || small
                                      ? "auto"
                                      : height
                                      ? "auto"
                                      : multi
                                      ? "222px"
                                      : "193px",
                                  lineHeight: 0,
                                }}
                              >
                                <label className="text-center radio-right-innerbox-label" style={{ display: 'flex', justifyContent: question.disclaimer ? 'space-between' : 'start' }}>
                                  {/* { question.heading ? <div  className="" >{question.heading}</div> : ''} */}
                                  <span className="text-left fg-black radio-right-innerbox-label-text">
                                    {question.heading ? (
                                      <div className="tiles-opt-heading">
                                        {question.heading}
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {question.main}
                                    {question.redMain ? (
                                      <span style={{ color: "red" }}>
                                        {question.redMain}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </span>

                                  <FormControl
                                    type="radio"
                                    // className={
                                    //     !textarea && multi
                                    //     ? 'right-radio radio-right-input radio-size-small-screen radio-bottom-fixed-multi'
                                    //     :'right-radio radio-right-input radio-size-small-screen radio-bottom-fixed'
                                    // }
                                    className={"sun-radio-custom"}
                                    key={
                                      "radioFieldTiles" + name + position + i
                                    }
                                    name={
                                      multi
                                        ? name + position + i
                                        : name + position
                                    }
                                    checked={
                                      multi
                                        ? question.dbqName === question.answer
                                        : question.dbqName === answer
                                    }
                                    value={question.dbqName}
                                    onClick={(e) =>
                                      onChangeValue({
                                        questionIndex: position,
                                        index: i,
                                        value: e.target.value,
                                      })
                                    }
                                    //onChange={e => onChangeValue({questionIndex:position, index:i, value:e.target.value})}
                                    label={question.main}
                                  />
                                  <img className={"sun-img-custom"}></img>
                                </label>
                                {question.subMain ? (
                                  <p
                                    style={{
                                      textAlign: "left",
                                      lineHeight: 1.75,
                                      fontWeight: "normal",
                                    }}
                                  >
                                    {question.subMain}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </PanelBody>
                            </Panel>
                          </label>
                          {/* Adds disclaimer icon if it exists */}
                          {question.disclaimer ? (
                            <QuestionDisclaimer
                              disclaimer={question.disclaimer}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </PanelContainer>
                    </div>
                    {(textarea || question.textarea) &&
                      (question.dbqName === question.answer ||
                        question.dbqName === answer) && (
                        <div
                          key={"divRadioTilesTextAreaField" + position + i}
                          className="col-sm-12 animate__animated animate__fadeInDown"
                          style={{ padding: "0" }}
                        >
                          <PanelContainer
                            containerClasses={
                              multi
                                ? question.textAnswer
                                  ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                                  : "rubix-panel-container-with-bottom-shadow-inner"
                                : textanswer
                                ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                                : "rubix-panel-container-with-bottom-shadow-inner"
                            }
                          >
                            <Panel>
                              <PanelBody className="radio-right-innerbox ">
                                <textarea
                                  name={
                                    "textareaRadioTiles" + name + position + i
                                  }
                                  id={"textarea" + name + position + i}
                                  placeholder={
                                    question.placeholder || "Please describe"
                                  }
                                  rows="3"
                                  value={
                                    multi ? question.textAnswer : textAnswer
                                  }
                                  onChange={(e) =>
                                    onChangeValue({
                                      questionIndex: position,
                                      index: i,
                                      textValue: true,
                                      value: e.target.value,
                                    })
                                  }
                                  className="required textarea-radio "
                                ></textarea>
                              </PanelBody>
                            </Panel>
                          </PanelContainer>
                        </div>
                      )}
                  </div>
                ))}
            </PanelBody>
          </Panel>
        </PanelContainer>{" "}
      </div>

      {questions.length > 1 && cols > 1 && (
        <div className={offset}>
          <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
            <Panel>
              <PanelBody className="radio-right-innerbox">
                {questions
                  .slice(questions.length / 2, questions.length)
                  .map((question, i) => (
                    <div
                      key={
                        "divMainRadioTilesField" +
                        position +
                        i +
                        questions.length / 2
                      }
                    >
                      <div
                        key={
                          "divRadioTilesField" +
                          position +
                          i +
                          questions.length / 2
                        }
                        className="col-sm-12"
                        style={{ padding: "0" }}
                      >
                        <PanelContainer
                          containerClasses={
                            multi
                              ? question.dbqName === question.answer
                                ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                                : "rubix-panel-container-with-bottom-shadow-inner"
                              : question.dbqName === answer
                              ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                              : "rubix-panel-container-with-bottom-shadow-inner"
                          }
                        >
                          <div style={{ display: "flex" }}>
                            <label style={{ width: "100%", marginBottom: 0 }}>
                              <Panel>
                                <PanelBody
                                  className="radio-right-innerbox"
                                  style={{
                                    height:
                                      textarea || small
                                        ? "auto"
                                        : height
                                        ? "auto"
                                        : multi
                                        ? "222px"
                                        : "193px",
                                    lineHeight: 0,
                                  }}
                                >
                                  <label className="text-center radio-right-innerbox-label" style={{ display: 'flex', justifyContent: question.disclaimer ? 'space-between' : 'start' }}>
                                    <span className="text-left fg-black radio-right-innerbox-label-text">
                                      {question.heading ? (
                                        <div className="tiles-opt-heading">
                                          {question.heading}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {question.main}
                                      {question.redMain ? (
                                        <span style={{ color: "red" }}>
                                          {question.redMain}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </span>

                                    <FormControl
                                      type="radio"
                                      className={"sun-radio-custom"}
                                      key={
                                        "radioFieldTiles" +
                                        name +
                                        position +
                                        i +
                                        questions.length / 2
                                      }
                                      name={
                                        multi
                                          ? name +
                                            position +
                                            i +
                                            questions.length / 2
                                          : name + position
                                      }
                                      checked={
                                        multi
                                          ? question.dbqName === question.answer
                                          : question.dbqName === answer
                                      }
                                      value={question.dbqName}
                                      onClick={(e) =>
                                        onChangeValue({
                                          questionIndex: position,
                                          index: Math.floor(
                                            i + questions.length / 2
                                          ),
                                          value: e.target.value,
                                        })
                                      }
                                      label={question.main}
                                    />
                                    <img className={"sun-img-custom"}></img>
                                  </label>
                                  {question.subMain ? (
                                    <p
                                      style={{
                                        textAlign: "left",
                                        lineHeight: 1.75,
                                        fontWeight: "normal",
                                      }}
                                    >
                                      {question.subMain}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </PanelBody>
                              </Panel>
                            </label>
                            {/* Adds disclaimer icon if it exists */}
                            {question.disclaimer ? (
                              <QuestionDisclaimer
                                disclaimer={question.disclaimer}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </PanelContainer>
                      </div>
                      {(textarea || question.textarea) &&
                        (question.dbqName === question.answer ||
                          question.dbqName === answer) && (
                          <div
                            key={"divRadioTilesTextAreaField" + position + i}
                            className="col-sm-12 animate__animated animate__fadeInDown"
                            style={{ padding: "0" }}
                          >
                            <PanelContainer
                              containerClasses={
                                multi
                                  ? question.textAnswer
                                    ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                                    : "rubix-panel-container-with-bottom-shadow-inner"
                                  : textanswer
                                  ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                                  : "rubix-panel-container-with-bottom-shadow-inner"
                              }
                            >
                              <Panel>
                                <PanelBody className="radio-right-innerbox ">
                                  <textarea
                                    name={
                                      "textareaRadioTiles" +
                                      name +
                                      position +
                                      i +
                                      questions.length / 2
                                    }
                                    id={
                                      "textarea" +
                                      name +
                                      position +
                                      i +
                                      questions.length / 2
                                    }
                                    placeholder={
                                      question.placeholder || "Please describe"
                                    }
                                    rows="3"
                                    value={
                                      multi ? question.textAnswer : textAnswer
                                    }
                                    onChange={(e) =>
                                      onChangeValue({
                                        questionIndex: position,
                                        index: Math.floor(
                                          i + questions.length / 2
                                        ),
                                        textValue: true,
                                        value: e.target.value,
                                      })
                                    }
                                    className="required textarea-radio "
                                  ></textarea>
                                </PanelBody>
                              </Panel>
                            </PanelContainer>
                          </div>
                        )}
                    </div>
                  ))}
              </PanelBody>
            </Panel>
          </PanelContainer>
        </div>
      )}
      {/* </PanelBody>
            </Panel>
            </PanelContainer> */}
    </div>
  );
}

export function ScarsLoad(props) {
  const {
    name,
    questions,
    position,
    onChangeValue,
    addMore,
    deleteScar,
    cols,
    answer,
    textanswer,
    multi,
    height,
    placeholder,
    textarea,
    small,
  } = props;
  let offset = "col-sm-";
  // offset += 12 / cols;
  offset += !cols || cols == 1 ? 12 : 6;

  return (
    <div key={props.position} className="show-with-ease">
      <div className={offset}>
        <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
          <Panel>
            <PanelBody className="radio-right-innerbox">
              {" "}
              <br />
              <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
                <Panel>
                  <PanelBody className="radio-right-innerbox">
                    {questions.options.map((optn, index) => (
                      <div
                        className="col-sm-3 testHover"
                        key={"div" + position + index}
                      >
                        <label className="text-center radio-right-innerbox-label">
                          <span className="text-left fg-black radio-right-innerbox-label-text">
                            {optn.main}
                          </span>
                          <input
                            type="radio"
                            className="custom-radio"
                            key={"radioField" + name + position + index}
                            name={name + position}
                            checked={optn.main === questions.answer}
                            value={optn.main}
                            onChange={(e) =>
                              onChangeValue({
                                questionIndex: position,
                                index: index,
                                value: e.target.value,
                                field: "options",
                              })
                            }
                            label={optn.main}
                          />
                        </label>
                      </div>
                    ))}

                    {questions.hasOwnProperty("text1") && (
                      <span className="row col-sm-12" style={{ padding: 10 }}>
                        <span
                          className="col-sm-4"
                          style={{ textAlign: "left" }}
                        >
                          {questions.textLabel1}
                        </span>
                        <textarea
                          name={"text1" + name + position}
                          id={"text1" + name + position}
                          // placeholder={question.placeholder1 ? question.placeholder1 : "Please list medication(s)"}
                          rows="1"
                          disabled={
                            questions.answer === "Not affected" ? true : false
                          }
                          value={questions.text1}
                          style={{
                            border: "1px solid #079EDA",
                            borderRadius: 20,
                            marginTop: 10,
                            padding: "5px 10px 5px 10px",
                          }}
                          onChange={(e) =>
                            onChangeValue({
                              questionIndex: position,
                              value: e.target.value,
                              field: "text1",
                            })
                          }
                          className="required textarea-modal col-sm-8"
                        ></textarea>
                      </span>
                    )}
                  </PanelBody>
                </Panel>
              </PanelContainer>
              <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
                <Panel>
                  <PanelBody className="radio-right-innerbox">
                    <div className="row">
                      {questions.hasOwnProperty("scars") &&
                        questions.scars.map((subItem, j) => (
                          <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
                            <Panel>
                              <PanelBody className="radio-right-innerbox">
                                <span
                                  className="col-sm-12"
                                  style={{ padding: 10, marginBottom: 10 }}
                                >
                                  <span
                                    className="col-sm-2"
                                    style={{ textAlign: "left" }}
                                  >
                                    Scar # {subItem.main}
                                  </span>
                                  <span className="col-sm-4">
                                    <FormControl
                                      type="number"
                                      key={"textfield" + name + position + j}
                                      className="scar-int-field required"
                                      name={name + j}
                                      onChange={(e) =>
                                        onChangeValue({
                                          questionIndex: position,
                                          index: j,
                                          value: e.target.value,
                                          field: "length",
                                        })
                                      }
                                      value={subItem.answerLength}
                                      disabled={
                                        questions.answer === "Not affected"
                                          ? true
                                          : false
                                      }
                                      id={name + j}
                                      placeholder={placeholder || ""}
                                    ></FormControl>
                                  </span>
                                  <span
                                    className="col-sm-1"
                                    style={{ textAlign: "left" }}
                                  >
                                    cm
                                  </span>
                                  <span className="col-sm-4">
                                    <FormControl
                                      type="number"
                                      key={"textfield" + name + position + j}
                                      className="scar-int-field required"
                                      name={name + j}
                                      onChange={(e) =>
                                        onChangeValue({
                                          questionIndex: position,
                                          index: j,
                                          value: e.target.value,
                                          field: "width",
                                        })
                                      }
                                      value={subItem.answerWidth}
                                      disabled={
                                        questions.answer === "Not affected"
                                          ? true
                                          : false
                                      }
                                      id={name + j}
                                      placeholder={placeholder || ""}
                                    ></FormControl>
                                  </span>
                                  <span
                                    className="col-sm-1"
                                    style={{ textAlign: "left" }}
                                  >
                                    cm
                                  </span>
                                </span>
                              </PanelBody>
                            </Panel>
                          </PanelContainer>
                        ))}
                      <div className="col-sm-12">
                        <span
                          className="col-sm-6 scar-delete"
                          onClick={(e) =>
                            deleteScar({ questionIndex: position })
                          }
                        >
                          <Icon glyph="glyphicon glyphicon-remove" /> Delete
                        </span>
                        <span
                          className="col-sm-6 scar-add-more"
                          onClick={(e) => addMore({ questionIndex: position })}
                        >
                          <Icon glyph="glyphicon glyphicon-plus" /> Add more
                        </span>
                      </div>
                    </div>
                  </PanelBody>
                </Panel>
              </PanelContainer>
            </PanelBody>
          </Panel>
        </PanelContainer>
      </div>
    </div>
  );
}

export function ScarQuestions(props) {
  const {
    name,
    questions,
    position,
    onChangeValue,
    addMore,
    loadScarOptions,
    cols,
    answer,
    textanswer,
    multi,
    height,
    placeholder,
    textarea,
    scars,
  } = props;
  let offset = "col-sm-";
  // offset += 12 / cols;
  offset += !cols || cols == 1 ? 12 : 6;

  return (
    <div key={props.position} className="show-with-ease">
      <div className={offset}>
        <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
          <Panel>
            <PanelBody className="radio-right-innerbox">
              {questions.map((question, i) => (
                <div className="col-sm-12" key={"div" + position + i}>
                  <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
                    <Panel>
                      <PanelBody className="radio-right-innerbox">
                        {/* <label className="text-center radio-right-innerbox-label" > */}
                        <div
                          className="row col-sm-12"
                          style={{
                            textAlign: "left",
                            fontSize: 16,
                            fontWeight: "bold",
                            color: "#079EDA",
                          }}
                        >
                          {question.main}
                        </div>
                        <div
                          className="row col-sm-12"
                          style={{
                            border: "1px solid #079EDA",
                            borderRadius: 20,
                            marginTop: 10,
                            padding: "10px 0 10px 0",
                            marginBottom: 20,
                          }}
                        >
                          {scars &&
                            scars.map((subItem, j) => (
                              <div
                                key={"subItemDiv" + name + position + i + j}
                                className="col-sm-4 testHover"
                                style={{
                                  borderRadius: "inherit",
                                  padding: "0 5%",
                                }}
                              >
                                <label
                                  style={{
                                    margin: "5px 0 5px 0",
                                    cursor: "pointer",
                                  }}
                                  className="text-center radio-right-innerbox-label"
                                >
                                  <span
                                    className="text-left fg-black radio-right-innerbox-label-text"
                                    style={{ width: "95%" }}
                                  >
                                    Scar # {subItem.main}{" "}
                                    <span
                                      style={{ fontSize: 11, color: "#89949b" }}
                                    >
                                      {subItem.answerLength
                                        ? `(${subItem.answerLength} x ${subItem.answerWidth}) cm`
                                        : ""}
                                    </span>
                                  </span>

                                  <FormControl
                                    type="radio"
                                    className={"sun-radio-custom"}
                                    key={
                                      "scarQuestions" + name + position + i + j
                                    }
                                    name={"checkBox1" + name + position + i + j}
                                    checked={question.scars[j].answer === "X"}
                                    value={subItem.main}
                                    onClick={(e) =>
                                      onChangeValue({
                                        questionIndex: position,
                                        index: i,
                                        indexSecond: j,
                                        value: e.target.value,
                                        scars,
                                      })
                                    }
                                    label={subItem.main}
                                  />
                                  <img className={"sun-img-custom"}></img>
                                </label>
                              </div>
                            ))}
                        </div>
                        {/* </label> */}
                      </PanelBody>
                    </Panel>
                  </PanelContainer>
                </div>
              ))}
            </PanelBody>
          </Panel>
        </PanelContainer>
      </div>
    </div>
  );
}

export function DisfigureQuestions(props) {
  const {
    name,
    questions,
    position,
    onChangeValue,
    addMore,
    loadScarOptions,
    cols,
    answer,
    textanswer,
    multi,
    height,
    placeholder,
    textarea,
    scars,
  } = props;
  let offset = "col-sm-";
  // offset += 12 / cols;
  offset += !cols || cols == 1 ? 12 : 6;

  return (
    <div key={props.position} className="show-with-ease">
      <div className={offset}>
        <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
          <Panel>
            <PanelBody className="radio-right-innerbox">
              {questions.map((question, i) => (
                <div className="col-sm-12" key={"div" + position + i}>
                  <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
                    <Panel>
                      <PanelBody className="radio-right-innerbox">
                        {/* <label className="text-center radio-right-innerbox-label" > */}
                        <div
                          className="row col-sm-12"
                          style={{
                            textAlign: "left",
                            fontSize: 16,
                            fontWeight: "bold",
                            color: "#079EDA",
                          }}
                        >
                          {question.main}
                        </div>
                        <div
                          className="row col-sm-12"
                          style={{
                            border: "1px solid #079EDA",
                            borderRadius: 20,
                            marginTop: 10,
                            padding: "10px 0 10px 0",
                            marginBottom: 20,
                          }}
                        >
                          {scars &&
                            scars.map((subItem, j) => (
                              <div
                                key={"subItemDiv" + name + position + i + j}
                                className="col-sm-4 testHover"
                                style={{
                                  borderRadius: "inherit",
                                  padding: "0 5%",
                                }}
                              >
                                <label
                                  style={{
                                    margin: "5px 0 5px 0",
                                    cursor: "pointer",
                                  }}
                                  className="text-center radio-right-innerbox-label"
                                >
                                  <span
                                    className="text-left fg-black radio-right-innerbox-label-text"
                                    style={{ width: "95%" }}
                                  >
                                    Scar # {subItem.main}{" "}
                                    <span
                                      style={{ fontSize: 11, color: "#89949b" }}
                                    >
                                      {subItem.answerLength
                                        ? `(${subItem.answerLength} x ${subItem.answerWidth}) cm`
                                        : ""}
                                    </span>
                                  </span>

                                  <FormControl
                                    type="radio"
                                    className={"sun-radio-custom"}
                                    key={
                                      "disfigureQuestions" +
                                      name +
                                      position +
                                      i +
                                      j
                                    }
                                    name={"checkBox1" + name + position + i + j}
                                    checked={question.scars[j].answer === "X"}
                                    value={subItem.main}
                                    onClick={(e) =>
                                      onChangeValue({
                                        questionIndex: position,
                                        index: i,
                                        indexSecond: j,
                                        value: e.target.value,
                                        scars,
                                      })
                                    }
                                    label={subItem.main}
                                  />
                                  <img className={"sun-img-custom"}></img>
                                </label>
                              </div>
                            ))}
                        </div>
                        {/* </label> */}
                      </PanelBody>
                    </Panel>
                  </PanelContainer>
                </div>
              ))}
            </PanelBody>
          </Panel>
        </PanelContainer>
      </div>
    </div>
  );
}

export function DisfigurementLoad(props) {
  const {
    name,
    questions,
    position,
    onChangeValue,
    addMoreDisfigurement,
    deleteDisfigurement,
    cols,
    answer,
    textanswer,
    multi,
    height,
    placeholder,
    textarea,
    small,
  } = props;
  let offset = "col-sm-";
  // offset += 12 / cols;
  offset += !cols || cols == 1 ? 12 : 6;

  return (
    <div key={props.position} className="show-with-ease">
      <div className={offset}>
        <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
          <Panel>
            <PanelBody className="radio-right-innerbox">
              {" "}
              <br />
              {questions.hasOwnProperty("scars") &&
                questions.scars.map((scar, index) => (
                  <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
                    <Panel>
                      <PanelBody className="radio-right-innerbox">
                        <span>
                          {scar.options.map((optn, j) => (
                            <div
                              className="col-sm-3 testHover"
                              key={"div" + position + j}
                            >
                              <label className="text-center radio-right-innerbox-label">
                                <span className="text-left fg-black radio-right-innerbox-label-text">
                                  {optn.main}
                                </span>
                                <input
                                  type="radio"
                                  className="custom-radio"
                                  key={"radioField" + name + position + j}
                                  name={name + position + scar.main}
                                  checked={optn.main === scar.answer}
                                  value={optn.main}
                                  onChange={(e) =>
                                    onChangeValue({
                                      questionIndex: position,
                                      index: index,
                                      indexSecond: j,
                                      value: e.target.value,
                                      field: "options",
                                    })
                                  }
                                  label={optn.main}
                                />
                              </label>
                            </div>
                          ))}
                          {scar.hasOwnProperty("text1") && (
                            <span
                              className="row col-sm-12"
                              style={{ padding: 10 }}
                            >
                              <span
                                className="col-sm-4"
                                style={{ textAlign: "left" }}
                              >
                                {scar.textLabel1}
                              </span>
                              <textarea
                                name={"text1" + name + position}
                                id={"text1" + name + position}
                                // placeholder={question.placeholder1 ? question.placeholder1 : "Please list medication(s)"}
                                rows="1"
                                value={scar.text1}
                                style={{
                                  border: "1px solid #079EDA",
                                  borderRadius: 20,
                                  marginTop: 10,
                                  padding: "5px 10px 5px 10px",
                                }}
                                onChange={(e) =>
                                  onChangeValue({
                                    questionIndex: position,
                                    index: index,
                                    value: e.target.value,
                                    field: "text1",
                                  })
                                }
                                className="required textarea-modal col-sm-8"
                              ></textarea>
                            </span>
                          )}
                          <span
                            className="col-sm-12"
                            style={{ padding: 10, marginBottom: 10 }}
                          >
                            <span
                              className="col-sm-2"
                              style={{ textAlign: "left" }}
                            >
                              Scar # {scar.main}
                            </span>
                            <span className="col-sm-4">
                              <FormControl
                                type="number"
                                key={"textfield" + name + position + index}
                                className="scar-int-field required"
                                name={name + index}
                                onChange={(e) =>
                                  onChangeValue({
                                    questionIndex: position,
                                    index: index,
                                    value: e.target.value,
                                    field: "length",
                                  })
                                }
                                value={scar.answerLength}
                                id={name + index}
                                placeholder={placeholder || ""}
                              ></FormControl>
                            </span>
                            <span
                              className="col-sm-1"
                              style={{ textAlign: "left" }}
                            >
                              cm
                            </span>
                            <span className="col-sm-4">
                              <FormControl
                                type="number"
                                key={"textfield" + name + position + index}
                                className="scar-int-field required"
                                name={name + index}
                                onChange={(e) =>
                                  onChangeValue({
                                    questionIndex: position,
                                    index: index,
                                    value: e.target.value,
                                    field: "width",
                                  })
                                }
                                value={scar.answerWidth}
                                id={name + index}
                                placeholder={placeholder || ""}
                              ></FormControl>
                            </span>
                            <span
                              className="col-sm-1"
                              style={{ textAlign: "left" }}
                            >
                              cm
                            </span>
                          </span>
                        </span>
                      </PanelBody>
                    </Panel>
                  </PanelContainer>
                ))}
              <div className="row">
                <div className="col-sm-12">
                  <span
                    className="col-sm-6 scar-delete"
                    onClick={(e) =>
                      deleteDisfigurement({ questionIndex: position })
                    }
                  >
                    <Icon glyph="glyphicon glyphicon-remove" /> Delete
                  </span>
                  <span
                    className="col-sm-6 scar-add-more"
                    onClick={(e) =>
                      addMoreDisfigurement({ questionIndex: position })
                    }
                  >
                    <Icon glyph="glyphicon glyphicon-plus" /> Add more
                  </span>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </PanelContainer>
      </div>
    </div>
  );
}

export function YesNo(props) {
  const {
    name,
    position,
    placeholder,
    onChangeValue,
    answer,
    textarea,
    textanswer,
    istext,
    hasVeteranResponse,
    fieldName,
    questions,
    setAdditionalResponse,
    blockedResponses,
  } = props;
  let { maxLength } = props;
  maxLength = maxLength ? maxLength : null;
  const isYesBlocked = isResponseBlocked(
    questions,
    blockedResponses && blockedResponses.Yes
  );
  const isNoBlocked = isResponseBlocked(
    questions,
    blockedResponses && blockedResponses.No
  );

  const specificQuestion = questions.filter((item) =>
    item.dbqName ? item.dbqName === fieldName : item.textdbqName === fieldName
  );
  const textareaSub =
    specificQuestion && specificQuestion[0] && specificQuestion[0].textareaSub;

  return (
    <div key={props.position} className="show-with-ease">
      <Row
        className="yesno-btn-row"
        style={{ display: hasVeteranResponse ? "none" : "block" }}
      >
        {!isYesBlocked && (
        <Col md={isNoBlocked ? 12 : 6} className="text-left no-btn">
          <Button
            lg
            type="button"
            name={"yes" + name + position}
            bsStyle="primary"
            className={
              answer === "Yes"
                ? "list-btn yesno-btn yesno-btn-active"
                : "list-btn yesno-btn"
            }
            onClick={(e) =>
              onChangeValue({ questionIndex: position, value: "Yes" })
            }
          >
            Yes
          </Button>
        </Col>
        )}
        {!isNoBlocked && (
        <Col md={isYesBlocked ? 12 : 6} className="text-right yes-btn">
          <Button
            lg
            type="button"
            name={"no" + name + position}
            bsStyle="primary"
            onClick={(e) =>
              onChangeValue({ questionIndex: position, value: "No" })
            }
            className={
              answer === "No"
                ? "list-btn yesno-btn yesno-btn-active"
                : "list-btn yesno-btn"
            }
          >
            No
          </Button>
        </Col>
        )}
      </Row>
      {hasVeteranResponse || (textarea && istext) ? (
        <div style={{ marginBottom: "20px", marginTop: "35px" }}>
          {textareaSub ? (
            <h3 className="heading-main-sub" style={{ whiteSpace: "pre-line" }}>
              {textareaSub}
            </h3>
          ) : null}
          <textarea
            name={"textarea" + name + position}
            id={"textarea" + name + position}
            placeholder={placeholder || "Please describe"}
            value={textanswer}
            rows={5}
            onChange={(e) =>
              onChangeValue({
                questionIndex: position,
                value: answer,
                textValue: e.target.value,
              })
            }
            onBlur={(e) =>
              onChangeValue({
                questionIndex: position,
                value: answer,
                textValue: e.target.value,
              })
            }
            title={hasVeteranResponse ? "Read only" : undefined}
            readOnly={hasVeteranResponse}
            disabled={hasVeteranResponse}
            className="required textarea-blue text-area animate__animated animate__fadeInDown"
          ></textarea>
          {/* {maxLength ? <div style={textanswer && maxLength-textanswer.length<((maxLength*15)/100) ? {color: 'red', fontSize: 16}: {fontSize: 16}}>{textanswer && textanswer.length ? textanswer.length: 0}/{maxLength}</div>: ""} */}
          {maxLength ? (
            <div
              style={
                textanswer && maxLength - textanswer.length < 30
                  ? { color: "red", fontSize: 16 }
                  : { fontSize: 16 }
              }
            >
              {textanswer && textanswer.length ? textanswer.length : 0}/
              {maxLength}
            </div>
          ) : (
            ""
          )}
          {
            specificQuestion[0].showDisclaimer === true && specificQuestion[0].textanswer === specificQuestion[0].defaulttextanswer && (
              <div>
                <br />
                <h3
                  style={{
                    color: "red",
                    paddingBottom: "1rem",
                    width: "80%",
                    margin: "0 auto",
                    fontWeight: "bold"
                  }}
                >
                  {specificQuestion[0].disclaimerLabel}
                </h3>
                <br />
              </div>
            )
          }
        </div>
      ) : null}

      {hasVeteranResponse ? (
          <div style={{ marginTop: "1rem" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <button
              style={{
                padding: "1rem",
                color: "white",
                backgroundColor: "black",
                borderRadius: "10px",
                fontSize: "16px",
                marginRight: "30px",
              }}
              type="button"
              onClick={() => setAdditionalResponse(fieldName, "", true, false)}
            >
              Add comment
            </button>
            <button
              style={{
                padding: "1rem",
                color: "white",
                backgroundColor: "black",
                borderRadius: "10px",
                fontSize: "16px",
              }}
              type="button"
              onClick={() =>
                setAdditionalResponse(fieldName, textanswer || "", true, true)
              }
            >
              Override comment
            </button>
          </div>
          <br />
          {
            specificQuestion &&
            specificQuestion[0] &&
            specificQuestion[0].showDisclaimer && (
              <div>
                <h3
                  style={{
                    color: "red",
                    paddingBottom: "1rem",
                    width: "80%",
                    margin: "0 auto",
                    fontWeight: "bold"
                  }}
                >
                  What you are about to edit is information the Veteran provided to Veteran Benefits Guide on their mini DBQ. If you notice any inconsistencies, or this information is different than what you discuss with the Veteran during their exam, you can make the necessary edits. Please verify the information with the Veteran before making any edits or changes to ensure accuracy.
                </h3>
                <br />
              </div>
            )
          }
          <textarea
            className="required textarea-blue text-area animate__animated animate__fadeInDown"
            style={{
              display:
                specificQuestion &&
                specificQuestion[0] &&
                specificQuestion[0].hasAdditionalResponse
                  ? "block"
                  : "none",
              width: "90%",
              margin: "0 auto 2rem auto",
            }}
            placeholder={specificQuestion[0].isOverwritten ? "This comment will override the original answer" :"Add provider comment here. Please note this comment will be appended to the original answer and it will be displayed on the final DBQ"}
            value={
              (specificQuestion &&
                specificQuestion[0] &&
                specificQuestion[0].additionalResponse) ||
              ""
            }
            rows={6}
            onChange={(e) => setAdditionalResponse(fieldName, e.target.value)}
          />
          {specificQuestion &&
            specificQuestion[0] &&
            specificQuestion[0].hasAdditionalResponse && (
            <button
              style={{
                padding: "1rem",
                color: "white",
                backgroundColor: "black",
                borderRadius: "10px",
                fontSize: "16px",
                marginRight: "10px",
              }}
              type="button"
              onClick={() => setAdditionalResponse(fieldName, "", true, false, true)}
            >
              Remove comment
            </button>
          )}
        </div>
      ) : null}
    </div>
  );
}

export function YesNoOuter(props) {
  console.log(props);
  const {
    name,
    position,
    placeholder,
    onChangeValue,
    answer,
    textarea,
    textanswer,
    istext,
  } = props;

  return (
    <div key={props.position} className="show-with-ease">
      <Row className="yesno-btn-row">
        <Col md={6} className="text-left no-btn">
          <Button
            lg
            type="button"
            name={"yes" + name + position}
            bsStyle="primary"
            className={
              answer === "Yes"
                ? "list-btn yesno-btn yesno-btn-active"
                : "list-btn yesno-btn"
            }
            onClick={(e) =>
              onChangeValue({ questionIndex: position, value: "Yes" })
            }
          >
            Yes
          </Button>
        </Col>
        <Col md={6} className="text-right yes-btn">
          <Button
            lg
            type="button"
            name={"no" + name + position}
            bsStyle="primary"
            onClick={(e) =>
              onChangeValue({ questionIndex: position, value: "No" })
            }
            className={
              answer === "No"
                ? "list-btn yesno-btn yesno-btn-active"
                : "list-btn yesno-btn"
            }
          >
            No
          </Button>
        </Col>
      </Row>
      {/* {textarea && istext && <div style={{marginBottom:"25px", marginTop:"35px"}}>
                <textarea 
                name={'textarea'+name+position}
                id={'textarea'+name+position}
                placeholder={placeholder || "Please describe the location"} 
                rows="4"
                value={textanswer}
                onChange={e => onChangeValue({questionIndex:position, value:answer, textValue:e.target.value})}
                className='required textarea-blue text-area animate__animated animate__fadeInDown'
                ></textarea>
            </div>
            } */}
    </div>
  );
}

export function CheckBoxField(props) {
  const {
    name,
    questions,
    position,
    onChangeValue,
    onTyping,
    cols,
    answer,
    textanswer,
    multi,
    placeholder,
    textarea,
    small,
  } = props;
  let offset = "col-sm-12";
  // offset += 12 / cols;
  return (
    <div key={props.position} className="show-with-ease">
      <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
        <Panel>
          <PanelBody className="question-cards-container radio-right-innerbox">
            {questions.map((question, i) => (
              <div className={`question-card ${textarea && (i + 1) % 2 === 0 ? "row" : ""}`}>
                {/* {<div className={i%cols===0 ? 'row': ''}> */}
                <div
                  key={"divMainCheckboxField" + position + i}
                  className={offset}
                >
                  <div
                    key={"divCheckboxField" + position + i}
                    className="col-sm-12"
                    style={{ padding: "0" }}
                  >
                    <PanelContainer
                      containerClasses={
                        multi
                          ? question.main === question.answer
                            ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                            : "rubix-panel-container-with-bottom-shadow-inner"
                          : question.main === answer
                          ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                          : "rubix-panel-container-with-bottom-shadow-inner"
                      }
                    >
                      <label>
                        <Panel
                          key={"radioFieldTilesPanel" + name + position + i}
                          style={{ clear: "both" }}
                        >
                          <PanelBody
                            className="radio-right-innerbox"
                            style={{
                              height:
                                textarea || small
                                  ? "auto"
                                  : multi
                                  ? "222px"
                                  : "193px",
                              lineHeight: 0,
                              padding: 10,
                            }}
                          >
                            <div
                              className="text-center radio-right-innerbox-label"
                              style={{ cursor: "pointer" }}
                            >
                              {/* { question.heading ? <div  className="" >{question.heading}</div> : ''} */}
                              <span className="text-left fg-black radio-right-innerbox-label-text">
                                {question.heading ? (
                                  <div className="tiles-opt-heading">
                                    {question.heading}
                                  </div>
                                ) : (
                                  ""
                                )}
                                {/* Currently the only mainExtraText is found within IBS DBQ. */}
                                {question.mainExtraText ? (<p>{question.main} <i>{`(${question.mainExtraText})`}</i></p>) : question.main}
                                {question.redMain ? (
                                  <span style={{ color: "red" }}>
                                    {question.redMain}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </span>
                              <FormControl
                                type="radio"
                                // className={
                                //     !textarea && multi
                                //     ? 'right-radio radio-right-input radio-size-small-screen checkbox-bottom-fixed-multi'
                                //     :'right-radio radio-right-input radio-size-small-screen checkbox-bottom-fixed'
                                // }
                                className={"sun-radio-custom"}
                                key={"radioFieldTiles" + name + position + i}
                                name={
                                  multi ? name + position + i : name + position
                                }
                                checked={
                                  multi
                                    ? question.main === question.answer
                                    : question.main === answer
                                }
                                value={question.main}
                                onClick={(e) =>
                                  onChangeValue({
                                    questionIndex: position,
                                    index: i,
                                    value: e.target.value,
                                    ck: "outer",
                                  })
                                }
                                //onChange={e => onChangeValue({questionIndex:position, index:i, value:e.target.value})}
                                label={question.main}
                              />
                              <img className={"sun-img-custom"}></img>
                            </div>

                            {question.showSubItems &&
                              question.subItems &&
                              !question.textarea && (
                                <Panel
                                  style={{ marginTop: 10 }}
                                  key={
                                    "radioFieldTilesPanelInner" +
                                    name +
                                    position +
                                    i
                                  }
                                >
                                  <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
                                    {question.subLabel ? (
                                      <p
                                        style={{ marginTop: 20, lineHeight: 1, fontSize: "18px" }}
                                      >
                                        {question.subLabel}
                                      </p>
                                    ) : (
                                      ""
                                    )}

                                    <PanelBody className="radio-right-innerbox">
                                      {question.subItems.map((subItem, j) => (
                                        <label
                                          style={{
                                            marginTop: "10px",
                                            cursor: "pointer",
                                          }}
                                          className="text-center radio-right-innerbox-label"
                                        >
                                          <span className="text-left fg-black radio-right-innerbox-label-text">
                                            {subItem.heading ? (
                                              <div className="tiles-opt-heading">
                                                {subItem.heading}
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                            {subItem.main}
                                            {subItem.redMain ? (
                                              <span style={{ color: "red" }}>
                                                {subItem.redMain}
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </span>

                                          <FormControl
                                            type="radio"
                                            // className={
                                            //     !question.textarea && question.multi
                                            //     ? 'right-radio radio-right-input radio-size-small-screen checkbox-bottom-fixed-multi'
                                            //     :'right-radio radio-right-input radio-size-small-screen checkbox-bottom-fixed'
                                            // }
                                            className={"sun-radio-custom"}
                                            key={
                                              "radioFieldTiles" +
                                              name +
                                              position +
                                              i +
                                              j
                                            }
                                            name={
                                              question.multi
                                                ? "checkBox" +
                                                  name +
                                                  position +
                                                  i +
                                                  j
                                                : "checkBox" +
                                                  name +
                                                  position +
                                                  i
                                            }
                                            checked={
                                              question.multi
                                                ? subItem.main ===
                                                  subItem.answer
                                                : subItem.main ===
                                                  question.subAnswer
                                            }
                                            value={subItem.main}
                                            onClick={(e) =>
                                              onChangeValue({
                                                questionIndex: position,
                                                index: i,
                                                indexSecond: j,
                                                value: e.target.value,
                                                ck: "inner",
                                              })
                                            }
                                            label={subItem.main}
                                          />
                                          <img
                                            className={"sun-img-custom"}
                                          ></img>
                                        </label>
                                      ))}
                                    </PanelBody>
                                  </PanelContainer>
                                </Panel>
                              )}
                            {/* {question.subItems && question.textarea &&
                                                <div key={"divCheckboxTextAreaField"+position+i} className='col-sm-12 animate__animated animate__fadeInDown' style={{padding: '0'}}>
                                                    <PanelContainer containerClasses={
                                                    multi ? (question.textAnswer ? 'rubix-panel-container-with-bottom-shadow-inner-selected': 'rubix-panel-container-with-bottom-shadow-inner')
                                                    : ( textanswer ? 'rubix-panel-container-with-bottom-shadow-inner-selected' : 'rubix-panel-container-with-bottom-shadow-inner')
                                                    }>
                                                        <Panel>
                                                            <PanelBody className="radio-right-innerbox ">
                                                                <textarea 
                                                                name={'textareaCheckbox'+name+position+i}
                                                                id={'textarea'+name+position+i}
                                                                placeholder={question.placeholder || "Please describe"} 
                                                                rows="3"
                                                                value={ multi ? question.textAnswer : textanswer}
                                                                onChange={e => onChangeValue({questionIndex:position, index:i, textValue:true, value:e.target.value})}
                                                                className='required textarea-radio '
                                                                ></textarea>
                                                                </PanelBody>
                                                        </Panel>
                                                    </PanelContainer>
                                                </div>
                                            } */}
                          </PanelBody>

                          {/* { question.showSubItems && question.subItems && !question.textarea && question.hasOwnProperty("text1") && 
                                                <textarea 
                                                        name={'text1'+name+position+i}
                                                        id={'text1'+name+position+i}
                                                        placeholder="Please Specify Others" 
                                                        rows="1"
                                                        value={question.text1}
                                                        style={{border: "1px solid #079EDA", borderRadius: 20, width: '90%', padding: '5px 10px 5px 10px'}}
                                                        onChange={e => onTyping({questionIndex:position, index:i, value:e.target.value, field: "text1"})}
                                                        className='required textarea-modal'
                                                        >
                                                </textarea>} */}
                        </Panel>
                      </label>
                      {question.showSubItems &&
                        question.subItems &&
                        !question.textarea &&
                        question.hasOwnProperty("text1") && (
                          <textarea
                            name={"text1" + name + position + i}
                            id={"text1" + name + position + i}
                            placeholder={
                              question.placeholder1
                                ? question.placeholder1
                                : "Please Specify Other"
                            }
                            rows="3"
                            value={question.text1}
                            style={{
                              border: "1px solid black",
                              borderRadius: 20,
                              width: "90%",
                              marginTop: 3,
                              marginBottom: 10,
                              padding: "5px 10px 5px 10px",
                            }}
                            onChange={(e) =>
                              onTyping({
                                questionIndex: position,
                                index: i,
                                value: e.target.value,
                                field: "text1",
                              })
                            }
                            className="required textarea-modal"
                          ></textarea>
                        )}
                    </PanelContainer>
                  </div>
                </div>
              </div>
            ))}
          </PanelBody>
        </Panel>
      </PanelContainer>
    </div>
  );
}

export function RadioModal(props) {
  const {
    name,
    questions,
    position,
    onChangeValue,
    onTyping,
    toggleCalender,
    onUpdateRadioModal,
    cols,
    answer,
    textanswer,
    multi,
    height,
    placeholder,
    textarea,
    small,
    showCalender,
    showCalender2,
    showCalender3,
    hideModalTitle,
    errorMessageSub,
    bulkSubAnswer,
    onSetBulkSubAnswer
  } = props;
  const visibleQuestions = getIndexedVisibleExamItems(questions);
  let offset = "col-sm-";
  offset += 12 / cols;
  // let today = new Date();
  // let myDate1 = today.toISOString().substr(0, 10);

  return (
    <div key={props.position} className="show-with-ease">
      <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
        <Panel>
          <PanelBody className="radio-right-innerbox">
            {visibleQuestions[0] && visibleQuestions[0].item.note && (
              <span style={{ fontSize: 15 }}>
                <b style={{ color: "red" }}>Note:</b>{" "}
                {visibleQuestions[0].item.note}
              </span>
            )}
            {bulkSubAnswer && (
              <div
                className="text-right"
                style={{ marginTop: 10, marginBottom: 20 }}
              >
                <Button
                  type="button"
                  bsStyle="success"
                  className="btn-lg"
                  style={{ minWidth: 220, fontWeight: 600 }}
                  onClick={() =>
                    onSetBulkSubAnswer({
                      questionIndex: position,
                      value: bulkSubAnswer.value,
                    })
                  }
                >
                  <Icon glyph="glyphicon glyphicon-ok" />{" "}
                  {bulkSubAnswer.label}
                </Button>
              </div>
            )}
            {visibleQuestions.map(
              ({ item: question, index: i }, visibleIndex) => (
              <div
                key={"divMainRadioTilesField1" + position + i}
                className={
                  textarea && (visibleIndex + 1) % 2 === 0 ? "row" : ""
                }
              >
                <div
                  key={"divMainRadioTilesField" + position + i}
                  className={offset}
                >
                  <div
                    key={"divRadioTilesField" + position + i}
                    className="col-sm-12"
                    style={{ padding: "0" }}
                  >
                    <PanelContainer
                      containerClasses={
                        multi
                          ? question.main === question.answer
                            ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                            : "rubix-panel-container-with-bottom-shadow-inner"
                          : question.main === answer
                          ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                          : "rubix-panel-container-with-bottom-shadow-inner"
                      }
                    >
                      <div style={{ display: 'flex' }}>
                        <label style={{ width: "100%", marginBottom: 0 }}>
                          <Panel>
                            <PanelBody
                              className="radio-right-innerbox"
                              style={{
                                height:
                                  textarea || small
                                    ? "auto"
                                    : height
                                    ? "auto"
                                    : multi
                                    ? "222px"
                                    : "193px",
                                lineHeight: 0,

                              }}
                            >
                              <label className="text-center radio-right-innerbox-label" style={{ display: 'flex', justifyContent: question.disclaimer ? 'space-between' : 'start' }}>
                                <span className="text-left fg-black radio-right-innerbox-label-text">
                                  {question.heading ? (
                                    <div style={{fontSize: '28px',marginBottom: '20px',marginTop: '10px', lineHeight:'25px'}}>                              
                                      {question.heading}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {question.main}
                                  {question.sub ? (<ls>{question.sub}</ls>)
                                  : ("")}
                                  {question.redMain ? (
                                    <span style={{ color: "red" }}>
                                      {question.redMain}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </span>
                                <FormControl
                                  type="radio"
                                  className={"sun-radio-custom"}
                                  key={"radioFieldTiles" + name + position + i}
                                  name={
                                    multi ? name + position + i : name + position
                                  }
                                  checked={
                                    multi
                                      ? question.main === question.answer
                                      : question.main === answer
                                  }
                                  value={question.main}
                                  onClick={(e) =>
                                    onChangeValue({
                                      questionIndex: position,
                                      index: i,
                                      value: e.target.value,
                                    })
                                  }
                                  label={question.main}
                                />
                                <img className={"sun-img-custom"}></img>
                              </label>
                            </PanelBody>
                          </Panel>
                        </label>
                        {/* Adds disclaimer icon if it exists */}
                        {question.disclaimer && (
                          <div>
                            <QuestionDisclaimer
                              disclaimer={question.disclaimer}
                            />
                          </div>
                        )}
                      </div>
                    </PanelContainer>
                  </div>

                  {question.showSubItems && (
                    <div
                      className={
                        question.text1Dropdown || question.textOtherDropdown
                          ? "overlay-msg overlay-msg--dropdown"
                          : "overlay-msg"
                      }
                    >
                      <div
                        className="row overlay-box"
                        style={{ padding: "0 5% 2% 5%" }}
                      >
                        {hideModalTitle === true ? (
                          <h3> </h3>
                        ) : (
                          <h3>{question.main}</h3>
                        )}

                        {/* <div className="pull-right date-picker-d" tabIndex="-1" style={{marginTop: '22px', marginRight: '-5px', borderRadius: '10px'}}>
                                        
                                    </div> */}
                        {question.hasOwnProperty("date1") && (
                          <span
                            className={
                              question.hasOwnProperty("date3")
                                ? "col-sm-4"
                                : question.hasOwnProperty("date2")
                                ? "col-sm-6"
                                : "col-sm-12"
                            }
                            style={
                              {
                                ...(question.hasOwnProperty("date2")
                                ? { paddingLeft: 0, paddingRight: 0 }
                                : { padding: 0 }),
                                marginBottom: 10 ,
                              }                              
                            }
                          >
                            <label
                              style={{
                                textAlign: "left",
                                marginTop: 10,
                                marginBottom: 10,
                              }}
                            >
                              {question.placeholderDate1
                                ? question.placeholderDate1
                                : "Please select date"}
                            </label>

                            <input
                              type="date"
                              name={"date1" + name + position + i}
                              id={"date1" + name + position + i}
                              value={question.date1 ? question.date1 : ""}
                              style={{
                                border: "1px solid #079EDA",
                                borderRadius: 20,
                                padding: "5px 10px 5px 10px",
                              }}
                              max="2050-01-31"
                              onChange={(e) =>
                                onTyping({
                                  questionIndex: position,
                                  index: i,
                                  value: e.target.value,
                                  field: "date1",
                                })
                              }
                              className="required textarea-modal"
                            />
                            {/* <textarea 
                                        name={'date1'+name+position+i}
                                        id={'date1'+name+position+i}
                                        placeholder={question.placeholderDate1? question.placeholderDate1: "Please select date"} 
                                        rows="1"
                                        value={question.date1? question.date1: moment().format("MM/DD/YYYY")}
                                        style={{border: "1px solid #079EDA", borderRadius: 20, padding: '5px 10px 5px 10px'}}
                                        onClick={e => toggleCalender({questionIndex:position, index:i, value:e.target.value, ck:"date1"})}
                                        readOnly
                                        className='required textarea-modal'
                                        >
                                    </textarea> */}

                            {showCalender && (
                              <div className="date-picker-modal" tabIndex="-1">
                                <Calendar
                                  date=""
                                  onChange={(e) =>
                                    toggleCalender({
                                      questionIndex: position,
                                      index: i,
                                      value: e,
                                      ck: "date1",
                                    })
                                  }
                                />
                              </div>
                            )}
                          </span>
                        )}

                        {question.hasOwnProperty("date2") && (
                          <span
                            className={
                              question.hasOwnProperty("date3")
                                ? "col-sm-4"
                                : "col-sm-6"
                            }
                            style={{ paddingRight: 0, marginBottom: 10 }}
                          >
                            <label
                              style={{
                                textAlign: "left",
                                marginTop: 10,
                                marginBottom: 10,
                              }}
                            >
                              {question.placeholderDate2
                                ? question.placeholderDate2
                                : "Please select date"}
                            </label>
                            <input
                              type="date"
                              name={"date2" + name + position + i}
                              id={"date2" + name + position + i}
                              value={question.date2 ? question.date2 : ""}
                              style={{
                                border: "1px solid #079EDA",
                                borderRadius: 20,
                                padding: "5px 10px 5px 10px",
                              }}
                              max="2050-01-31"
                              onChange={(e) =>
                                onTyping({
                                  questionIndex: position,
                                  index: i,
                                  value: e.target.value,
                                  field: "date2",
                                })
                              }
                              className="required textarea-modal"
                            />
                            {/* <textarea 
                                        name={'date2'+name+position+i}
                                        id={'date2'+name+position+i}
                                        placeholder={question.placeholderDate1? question.placeholderDate1: "Please select date"} 
                                        rows="1"
                                        value={question.date2? question.date2: moment().format("MM/DD/YYYY")}
                                        style={{border: "1px solid #079EDA", borderRadius: 20, padding: '5px 10px 5px 10px'}}
                                        onClick={e => toggleCalender({questionIndex:position, index:i, value:e.target.value, ck:"date2"})}
                                        readOnly
                                        className='required textarea-modal'
                                        >
                                    </textarea> */}
                            {showCalender2 && (
                              <div className="date-picker-modal" tabIndex="-1">
                                <Calendar
                                  date=""
                                  onChange={(e) =>
                                    toggleCalender({
                                      questionIndex: position,
                                      index: i,
                                      value: e,
                                      ck: "date2",
                                    })
                                  }
                                />
                              </div>
                            )}{" "}
                          </span>
                        )}

                        {question.hasOwnProperty("date3") && (
                          <span
                            className={
                              question.hasOwnProperty("date3")
                                ? "col-sm-4"
                                : "col-sm-6"
                            }
                            style={{ paddingRight: 0, marginBottom: 10 }}
                          >
                            <label
                              style={{
                                textAlign: "left",
                                marginTop: 10,
                                marginBottom: 10,
                              }}
                            >
                              {question.placeholderDate3
                                ? question.placeholderDate3
                                : "Please select date"}
                            </label>

                            <input
                              type="date"
                              name={"date3" + name + position + i}
                              id={"date3" + name + position + i}
                              value={question.date3 ? question.date3 : ""}
                              style={{
                                border: "1px solid #079EDA",
                                borderRadius: 20,
                                padding: "5px 10px 5px 10px",
                              }}
                              max="2050-01-31"
                              onChange={(e) =>
                                onTyping({
                                  questionIndex: position,
                                  index: i,
                                  value: e.target.value,
                                  field: "date3",
                                })
                              }
                              className="required textarea-modal"
                            />
                            {/* <textarea 
                                        name={'date3'+name+position+i}
                                        id={'date3'+name+position+i}
                                        placeholder={question.placeholderDate1? question.placeholderDate1: "Please select date"} 
                                        rows="1"
                                        value={question.date3? question.date3: moment().format("MM/DD/YYYY")}
                                        style={{border: "1px solid #079EDA", borderRadius: 20, padding: '5px 10px 5px 10px'}}
                                        onClick={e => toggleCalender({questionIndex:position, index:i, value:e.target.value, ck:"date3"})}
                                        readOnly
                                        className='required textarea-modal'
                                        >
                                    </textarea> */}

                            {showCalender3 && (
                              <div className="date-picker-modal" tabIndex="-1">
                                <Calendar
                                  date=""
                                  onChange={(e) =>
                                    toggleCalender({
                                      questionIndex: position,
                                      index: i,
                                      value: e,
                                      ck: "date3",
                                    })
                                  }
                                />
                              </div>
                            )}
                          </span>
                        )}

                        {question.weightSymbol ? (
                          <WeightTextField
                            text={"text1"}
                            question={question}
                            name={name}
                            position={position}
                            i={i}
                            onTyping={onTyping}
                            placeholder={question.placeholder1}
                          />
                        ) : question.hasOwnProperty("text1") ? (
                          <div className={question.text1Label ? "textarea-label-wrapper" : ""}>
                            {question.text1Label &&
                              <label htmlFor={`text1${name}${position}${i}`} className="textarea-label">
                                {question.text1Label}
                              </label>
                            }
                            <DropdownTextField
                              question={question}
                              fieldName="text1"
                              name={name}
                              position={position}
                              index={i}
                              onTyping={onTyping}
                              placeholder={question.placeholder1}
                            />
                          </div>
                        ) : null}

                        {question.weightSymbol ? (
                          <WeightTextField
                            text={"text2"}
                            question={question}
                            name={name}
                            position={position}
                            i={i}
                            onTyping={onTyping}
                            placeholder={question.placeholder2}
                          />
                        ) : question.hasOwnProperty("text2") ? (
                          <div className={question.text2Label ? "textarea-label-wrapper" : ""}>
                            {question.text2Label &&
                              <label htmlFor={`text2${name}${position}${i}`} className="textarea-label">
                                {question.text2Label}
                              </label>
                            }
                            <textarea
                              name={"text2" + name + position + i}
                              id={"text2" + name + position + i}
                              placeholder={
                                question.placeholder2
                                  ? question.placeholder2
                                  : "Please specify"
                              }
                              rows={question.rows2 ? question.rows2 : "2"}
                              value={question.text2}
                              style={{
                                border: "1px solid #079EDA",
                                borderRadius: 20,
                                marginTop: 10,
                                padding: "5px 10px 5px 10px",
                              }}
                              onChange={(e) =>
                                onTyping({
                                  questionIndex: position,
                                  index: i,
                                  value: e.target.value,
                                  field: "text2",
                                })
                              }
                              className="required textarea-modal"
                            ></textarea>
                          </div>
                        ) : null}

                        {question.weightSymbol ? (
                          <WeightTextField
                            text={"text3"}
                            question={question}
                            name={name}
                            position={position}
                            i={i}
                            onTyping={onTyping}
                            placeholder={question.placeholder3}
                          />
                        ) : question.hasOwnProperty("text3") ? (
                          <div className={question.text3Label ? "textarea-label-wrapper" : ""}>
                            {question.text3Label &&
                              <label htmlFor={`text3${name}${position}${i}`} className="textarea-label">
                                {question.text3Label}
                              </label>
                            }
                            <textarea
                              name={"text3" + name + position + i}
                              id={"text3" + name + position + i}
                              placeholder={
                                question.placeholder3
                                  ? question.placeholder3
                                  : "Please specify"
                              }
                              rows={question.rows3 ? question.rows3 : "2"}
                              value={question.text3}
                              style={{
                                border: "1px solid #079EDA",
                                borderRadius: 20,
                                marginTop: 10,
                                padding: "5px 10px 5px 10px",
                              }}
                              onChange={(e) =>
                                onTyping({
                                  questionIndex: position,
                                  index: i,
                                  value: e.target.value,
                                  field: "text3",
                                })
                              }
                              className="required textarea-modal"
                            ></textarea>
                          </div>
                        ) : null}

                        <div
                          className="col-sm-12"
                          style={
                            question.subItems
                              ? {
                                  border: "1px solid #079EDA",
                                  borderRadius: 20,
                                  marginTop: 10,
                                  padding: "0 0 10px 0",
                                }
                              : {}
                          }
                        >                
                          {
                            question.subItemsLabel && (
                              <div >
                                <span
                                  style={{
                                    fontSize: "22px",
                                    paddingLeft: "0.5rem",
                                    paddingRight: "0.5rem",
                                  }}
                                >
                                  {question.subItemsLabel}
                                </span>
                                <br />
                             </div>
                            )
                          }
                          {question.subItems &&
                            question.subItems.map((subItem, j) => (
                              <div
                                key={"subItemDiv" + name + position + i + j}
                                className={
                                  subItem.colWidth
                                    ? `col-sm-${subItem.colWidth} testHover`
                                    : "col-sm-4 testHover"
                                }
                                style={{ borderRadius: "inherit" }}
                              >
                                <label
                                  style={{
                                    margin: "5px 0 5px 0",
                                    cursor: "pointer",
                                  }}
                                  className="text-center radio-right-innerbox-label"
                                >
                                  <span
                                    className="text-left fg-black radio-right-innerbox-label-text"
                                    style={{ width: "95%" }}
                                  >
                                    {subItem.heading ? (
                                      <div className="tiles-opt-heading">
                                        {subItem.heading}
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {subItem.label || subItem.main}
                                    {subItem.redMain ? (
                                      <span style={{ color: "red" }}>
                                        {subItem.redMain}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </span>

                                  <FormControl
                                    type="radio"
                                    className={"sun-radio-custom"}
                                    key={"radioModal" + name + position + i + j}
                                    name={
                                      question.multi
                                        ? "checkBox1" + name + position + i + j
                                        : "checkBox1" + name + position + i
                                    }
                                    checked={
                                      question.multi
                                        ? subItem.main === subItem.answer
                                        : subItem.main === question.subAnswer
                                    }
                                    value={subItem.main}
                                    onClick={(e) =>
                                      onChangeValue({
                                        questionIndex: position,
                                        index: i,
                                        indexSecond: j,
                                        value: e.target.value,
                                        ck: "inner",
                                        subAnswer: "subAnswer",
                                      })
                                    }
                                    label={subItem.label || subItem.main}
                                  />
                                  <img className={"sun-img-custom"}></img>
                                </label>
                              </div>
                            ))}
                        </div>

                        {question.hasOwnProperty("textOther") &&
                          question.subItemOther && (
                            <div>
                              {
                                question.subItemOtherLabel && (
                                  <span
                                    style={{
                                      fontSize: "18px",
                                      paddingLeft: "0.5rem",
                                      paddingRight: "0.5rem",
                                    }}
                                  >
                                    {question.subItemOtherLabel}
                                  </span>
                                )
                              }
                              {question.textOtherSub &&
                              (!getDropdownTextFieldConfig(question, "textOther") ||
                                isDropdownTextFieldOtherSelected(question, "textOther")) ? (
                                <div
                                  className="radio-modal-textarea-sub"
                                  style={{ whiteSpace: "pre-line" }}
                                >
                                  {question.textOtherSub}
                                </div>
                              ) : null}
                              <DropdownTextField
                                question={question}
                                fieldName="textOther"
                                name={name}
                                position={position}
                                index={i}
                                onTyping={onTyping}
                                placeholder={question.placeholderOther || "Please specify other"}
                              />
                            </div>
                          )
                        }

                        {question.hasOwnProperty("textOther2") &&
                          question.subItemOther2 && (
                            <div>
                             {question.subItemOther2Label && (<span
                            style={{
                              fontSize: "18px",
                              paddingLeft: "0.5rem",
                              paddingRight: "0.5rem",
                            }}
                          >
                            {question.subItemOther2Label}
                          </span>)}
                            <textarea
                              name={"textOther2" + name + position + i}
                              id={"textOther2" + name + position + i}
                              placeholder={
                                question.placeholderOther2
                                  ? question.placeholderOther2
                                  : "Please specify other"
                              }
                              rows={
                                question.rowsOther ? question.rowsOther : "2"
                              }
                              value={question.textOther2}
                              style={{
                                border: "1px solid #079EDA",
                                borderRadius: 20,
                                marginTop: 10,
                                padding: "5px 10px 5px 10px",
                              }}
                              // onChange={e => onChangeValue({questionIndex:position, index:i, textValue:true, value:e.target.value})}
                              onChange={(e) =>
                                onTyping({
                                  questionIndex: position,
                                  index: i,
                                  value: e.target.value,
                                  field: "textOther2",
                                })
                              }
                              className="required textarea-modal"
                            ></textarea></div>
                          )}

                        <div
                          className="col-sm-12"
                          style={
                              question.subItems2 ? {
                              border: "1px solid #079EDA",
                              borderRadius: 20,
                              marginTop: 10,
                              padding: "0 0 10px 0",
                            } : {}
                          }
                        >                        
                          {
                            question.subItems2Label && (
                              <div >
                                <span
                                  style={{
                                    fontSize: "22px",
                                    paddingLeft: "0.5rem",
                                    paddingRight: "0.5rem",
                                  }}
                                >
                                  {question.subItems2Label && question.subItems2Label}
                                </span>
                                <br />
                             </div>
                            )
                          }
                          {question.subItems2 &&
                            question.subItems2.map((subItem, j) => (
                              <div
                                key={"subItem1Div" + name + position + i + j}
                                className={
                                  subItem.colWidth
                                    ? `col-sm-${subItem.colWidth} testHover`
                                    : "col-sm-4 testHover"
                                }
                                style={{ borderRadius: "inherit" }}
                              >
                                <label
                                  style={{
                                    margin: "5px 0 5px 0",
                                    cursor: "pointer",
                                    justifyContent: 'space-between'
                                  }}
                                  className="text-center radio-right-innerbox-label"
                                >
                                  <span className="text-left fg-black radio-right-innerbox-label-text">
                                    {subItem.heading ? (
                                      <div className="tiles-opt-heading">
                                        {subItem.heading}
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {subItem.label || subItem.main}
                                    {subItem.redMain ? (
                                      <span style={{ color: "red" }}>
                                        {subItem.redMain}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </span>

                                  <FormControl
                                    type="radio"
                                    className={"sun-radio-custom"}
                                    key={"radioModal" + name + position + i + j}
                                    name={
                                      question.multi
                                        ? "checkBox2" + name + position + i + j
                                        : "checkBox2" + name + position + i
                                    }
                                    checked={
                                      question.multi
                                        ? subItem.main === subItem.answer
                                        : subItem.main === question.subAnswer2
                                    }
                                    value={subItem.main}
                                    onClick={(e) =>
                                      onChangeValue({
                                        questionIndex: position,
                                        index: i,
                                        indexSecond: j,
                                        value: e.target.value,
                                        ck: "inner",
                                        subAnswer: "subAnswer2",
                                      })
                                    }
                                    label={subItem.label || subItem.main}
                                  />
                                  <img className={"sun-img-custom"}></img>
                                </label>
                              </div>
                            ))}
                        </div>

                        <div
                          className="col-sm-12"
                          style={
                            question.showSubItems3 ? {
                              border: "1px solid #079EDA",
                              borderRadius: 20,
                              marginTop: 10,
                              padding: "0 0 10px 0",
                            } : {}
                          }
                        > 
                                                      {question.showSubItems3 &&
                            question.subItems3Label ? (
                              <div >
                                <span
                                  style={{
                                    fontSize: "22px",
                                    paddingLeft: "0.5rem",
                                    paddingRight: "0.5rem",
                                  }}
                                >
                                  {question.subItems3Label}
                                </span>
                                <br />
                             </div>
                            ) : null
                          }
                          {question.subItems3 &&
                            question.showSubItems3 &&
                            question.subItems3.map((subItem, j) => (
                              <div
                                key={"subItem3Div" + name + position + i + j}
                                className={
                                  subItem.colWidth
                                    ? `col-sm-${subItem.colWidth} testHover`
                                    : "col-sm-4 testHover"
                                }
                                style={{ borderRadius: "inherit" }}
                              >
                                <label
                                  style={{
                                    margin: "5px 0 5px 0",
                                    cursor: "pointer",
                                    justifyContent: 'space-between'
                                  }}
                                  className="text-center radio-right-innerbox-label"
                                >
                                  <span className="text-left fg-black radio-right-innerbox-label-text">
                                    {subItem.heading ? (
                                      <div className="tiles-opt-heading">
                                        {subItem.heading}
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {subItem.main}
                                    {subItem.redMain ? (
                                      <span style={{ color: "red" }}>
                                        {subItem.redMain}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </span>

                                  <FormControl
                                    type="radio"
                                    className={"sun-radio-custom"}
                                    key={
                                      "radioModal3" + name + position + i + j
                                    }
                                    name={
                                      (question.multi || question.multiSubItems3)
                                        ? "checkBox3" + name + position + i + j
                                        : "checkBox3" + name + position + i
                                    }
                                    checked={
                                      (question.multi || question.multiSubItems3)
                                        ? subItem.main === subItem.answer
                                        : subItem.main === question.subAnswer3
                                    }
                                    value={subItem.main}
                                    onClick={(e) =>
                                      onChangeValue({
                                        questionIndex: position,
                                        index: i,
                                        indexSecond: j,
                                        value: e.target.value,
                                        ck: "inner",
                                        subAnswer: "subAnswer3",
                                      })
                                    }
                                    label={subItem.main}
                                  />
                                  <img className={"sun-img-custom"}></img>
                                </label>
                              </div>
                            ))}
                        </div>
                        {question.hasOwnProperty("textOther3") &&
                          question.subItem3Other && question.showSubItems3 ? (
                            <div>
                            {question.subItemOther3Label && (<span
                              style={{
                                fontSize: "18px",
                                paddingLeft: "0.5rem",
                                paddingRight: "0.5rem",
                              }}
                            >
                              {question.subItemOther3Label}
                            </span>)}
                              {question.textOther3Sub ? (
                                <div
                                  className="radio-modal-textarea-sub"
                                  style={{ whiteSpace: "pre-line" }}
                                >
                                  {question.textOther3Sub}
                                </div>
                              ) : null}
                              <textarea
                                name={"textOther3" + name + position + i}
                                id={"textOther3" + name + position + i}
                                placeholder={
                                  question.placeholderOther3
                                    ? question.placeholderOther3
                                    : "Please specify other"
                                }
                                rows={
                                  question.rowsOther ? question.rowsOther : "2"
                                }
                                value={question.textOther3}
                                style={{
                                  border: "1px solid #079EDA",
                                  borderRadius: 20,
                                  marginTop: 10,
                                  padding: "5px 10px 5px 10px",
                                }}
                                // onChange={e => onChangeValue({questionIndex:position, index:i, textValue:true, value:e.target.value})}
                                onChange={(e) =>
                                  onTyping({
                                    questionIndex: position,
                                    index: i,
                                    value: e.target.value,
                                    field: "textOther3",
                                  })
                                }
                                className="required textarea-modal"
                              ></textarea>
                              </div>
                        ) : null}
                        {question.hasOwnProperty("altTextOther3") &&
                          question.subItem3Other2 && question.showSubItems3 ? (
                            <div>
                              {question.subItemOther3Label && (
                                <span
                                  style={{
                                    fontSize: "18px",
                                    paddingLeft: "0.5rem",
                                    paddingRight: "0.5rem",
                                  }}
                                >
                                  {question.subItemOther3Label}
                                </span>
                              )}
                              <textarea
                                name={"altTextOther3" + name + position + i}
                                id={"altTextOther3" + name + position + i}
                                placeholder={
                                  question.altPlaceholderOther3
                                    ? question.altPlaceholderOther3
                                    : "Please specify other"
                                }
                                rows={
                                  question.altRowsOther3 ? question.altRowsOther3 : "2"
                                }
                                value={question.altTextOther3}
                                style={{
                                  border: "1px solid #079EDA",
                                  borderRadius: 20,
                                  marginTop: 10,
                                  padding: "5px 10px 5px 10px",
                                }}
                                // onChange={e => onChangeValue({questionIndex:position, index:i, textValue:true, value:e.target.value})}
                                onChange={(e) =>
                                  onTyping({
                                    questionIndex: position,
                                    index: i,
                                    value: e.target.value,
                                    field: "altTextOther3",
                                  })
                                }
                                className="required textarea-modal"
                              ></textarea>
                            </div>
                          ): null}
                        {
                          question.hasOwnProperty("disclaimerLabel") &&
                          question.showDisclaimer && (
                            <div>
                              <span
                                style={{
                                  fontSize: "18px",
                                  paddingLeft: "0.5rem",
                                  paddingRight: "0.5rem",
                                }}
                              >
                                {question.disclaimerLabel}
                              </span>
                              <textarea
                                name={"disclaimer" + name + position + i}
                                id={"disclaimer" + name + position + i}
                                placeholder={question.disclaimerPlaceholder}
                                rows={'2'}
                                value={question.disclaimerResponse}
                                style={{
                                  border: "1px solid #079EDA",
                                  borderRadius: 20,
                                  marginTop: 10,
                                  padding: "5px 10px 5px 10px",
                                }}
                                // onChange={e => onChangeValue({questionIndex:position, index:i, textValue:true, value:e.target.value})}
                                onChange={(e) =>
                                  onTyping({
                                    questionIndex: position,
                                    index: i,
                                    value: e.target.value,
                                    field: "disclaimerResponse",
                                  })
                                }
                                className="required textarea-modal"
                              >
                              </textarea>
                            </div>
                          )
                        }

                        <div className="error-container col-sm-12">
                          {errorMessageSub && (
                            <p className="error-message">{ errorMessageSub }</p>
                          )}
                        </div>

                        <div className="col-sm-12 radio-modal-actions" style={{ marginTop: 15 }}>
                          <div className="col-sm-6">
                            <Button
                              // md
                              type="button"
                              bsStyle="default"
                              className="next-btn btn-lg"
                              onClick={(e) =>
                                onUpdateRadioModal({
                                  questionIndex: position,
                                  index: i,
                                  src: "close",
                                })
                              }
                            >
                              Cancel
                            </Button>
                          </div>
                          <div className="col-sm-6">
                            <Button
                              // md
                              type="button"
                              bsStyle="primary"
                              className="next-btn btn-lg"
                              onClick={(e) =>
                                onUpdateRadioModal({
                                  questionIndex: position,
                                  index: i,
                                  src: "save",
                                })
                              }
                            >
                              Select
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              )
            )}
          </PanelBody>
        </Panel>
      </PanelContainer>
    </div>
  );
}

export function MenuQuestions(props) {
  const { questions, onSelect } = props;
  return (
    <div>
      {getIndexedVisibleExamItems(props.questions).map(
        ({ item: question, index }) => (
          // <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
          // <Panel>
          //     <PanelBody>
          <Row
            className="exam-menu-card"
            style={question.show ? { cursor: "pointer", padding: 20 } : {}}
          >
            <Col
              onClick={(e) =>
                question.show && onSelect({ index, show: question.show })
              }
              sm={12}
              style={
                question.show ? { color: "#000", padding: 0 } : { padding: 0 }
              }
            >
              {question.question}
              {question.section && (
                <span className="pull-right">
                  <b>
                    {question.section.number}{" "}
                    {question.section.number ? " : " : ""}{" "}
                  </b>
                  {question.section.title.toUpperCase()}
                </span>
              )}
            </Col>
          </Row>
        )
        //     </PanelBody>
        // </Panel>
        // </PanelContainer>
      )}
    </div>
  );
}

class Exam extends Component {
  constructor(props) {
    super(props);
    console.log("EXAM PROPS: ", props);
    let currentDbq =
      this.props.location && this.props.location.currentDbq
        ? this.props.location.currentDbq
        : JSON.parse(sessionStorage.getItem("currentDbq"));
    let dbq = currentDbq && currentDbq.name ? currentDbq.name : "";

    let patient =
      this.props.location && this.props.location.patient
        ? this.props.location.patient
        : JSON.parse(sessionStorage.getItem("patient"));

    let questionState =
      this.props.location && this.props.location.questionState
        ? this.props.location.questionState
        : JSON.parse(sessionStorage.getItem("questionState"));

    let page =
      this.props.location && this.props.location.page
        ? this.props.location.page
        : sessionStorage.getItem("page");

    let questions = [];

    if (
      (page === "home" || page === "review") &&
      questionState &&
      questionState.length > 0
    ) {
      questions = questionState;
    }

    // else {

    //     if (dbq && dbq.toLowerCase() === 'back disabilities') {
    //         questions = _.cloneDeep(back_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'neck disabilities') {
    //         questions = _.cloneDeep(neck_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'ankle disabilities') {
    //         questions = _.cloneDeep(ankle_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'wrist conditions') {
    //         questions = _.cloneDeep(wrist_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'hip disabilities') {
    //         questions = _.cloneDeep(hip_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'knee disabilities') {
    //         questions = _.cloneDeep(knee_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'shoulder disabilities') {
    //         questions = _.cloneDeep(shoulder_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'elbow disabilities') {
    //         questions = _.cloneDeep(elbow_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'mental disorders other than ptsd') {
    //         questions = _.cloneDeep(mental_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'ptsd') {
    //         questions = _.cloneDeep(ptsd_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'kidney disease, kidney stones, etc') {
    //         questions = this.getConditionalQuestions(_.cloneDeep(kidney_questions), patient, currentDbq.id, 'kidney');
    //     } else if (dbq && dbq.toLowerCase() === 'ibs') {
    //         questions = _.cloneDeep(ibs_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'nerve disabilities') {
    //         questions = _.cloneDeep(nerves_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'sinusitis') {
    //         questions = _.cloneDeep(sinusitis_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'heart disabilities') {
    //         questions = _.cloneDeep(heart_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'varicose veins, peripheral vascular disease, etc.') {
    //         questions = _.cloneDeep(veins_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'tmj') {
    //         questions = _.cloneDeep(tmj_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'migraines, tension headaches, etc.') {
    //         questions = _.cloneDeep(headache_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'sleep apnea') {
    //         questions = _.cloneDeep(sleep_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'hepatitis') {
    //         questions = _.cloneDeep(hepatitis_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'prostate cancer') {
    //         questions = this.getConditionalQuestions(_.cloneDeep(prostateCancer_questions), patient, currentDbq.id, 'prostate');
    //     } else if (dbq && dbq.toLowerCase() === 'seizure disorders') {
    //         questions = _.cloneDeep(seizure_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'skin diseases') {
    //         questions = _.cloneDeep(skin_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'pes planus or plantar fasciitis') {
    //         //questions = this.getConditionalQuestions(_.cloneDeep(foot_questions), patient, currentDbq.id, 'foot');
    //         questions = this.loadExamQuestions(foot_questions, currentDbq.id, currentDbq.name, foot_questions_v1)
    //     } else if (dbq && dbq.toLowerCase() === 'asthma, sarcoidosis, etc.') {
    //         questions = _.cloneDeep(asthma_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'hand and fingers') {
    //         questions = _.cloneDeep(handFingers_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'bladder disabilities, urinary tract infection, etc.') {
    //         questions = _.cloneDeep(bladder_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'fibromyalgia') {
    //         questions = _.cloneDeep(fibromyalgia_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'gout') {
    //         questions = _.cloneDeep(arthritis_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'gerd, hiatal hernia, etc.') {
    //         questions = _.cloneDeep(gerd_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'hemorrhoids') {
    //         questions = _.cloneDeep(hemorrhoids_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'diabetic neuropathy') {
    //         questions = _.cloneDeep(diabeticNeuro_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'diabetes') {
    //         questions = _.cloneDeep(diabetes_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'erectile dysfunction, prostatitis, etc.') {
    //         questions = _.cloneDeep(ed_questions);
    //     } else if (dbq && dbq.toLowerCase() === 'scars') {
    //         questions = _.cloneDeep(scars_questions);
    //     } else {
    //         console.log("admin/dashboard")
    //         props.history.push("admin/dashboard")
    //     }

    //     // for (let i=0; i<questions.length; i++) {
    //     //     questions[i].question = questions[i].question.replace("##name##", patient && patient.name)
    //     //     if (questions[i].question.includes("##redHeading##")) {
    //     //         questions[i].question = questions[i].question.replace("##redHeading##", questions[i].redHeading)
    //     //     }
    //     // }
    // }

    // else if (this.props.location.page === "widget") {
    //     console.log("location.page === widget")
    //     let obj = {
    //         pId : patient && patient.id ? patient.id : "",
    //         dbqName : currentDbq && currentDbq.name ? currentDbq.name.toLowerCase() : ""
    //     }
    //     let token = localStorage.getItem('login_token');
    //     let headers = {"Content-Type": "application/json"};
    //     headers["Authorization"] = `Bearer ${token}`
    //     fetch(process.env.API_URL+"/dbq/exam", {method: "post", headers, body: JSON.stringify(obj)} )
    //     .then(response => response.json())
    //     .then(data => {
    //         if (data && data.questions && data.questions.length>0) {
    //             questions = data.questions
    //         }
    //     })
    //     .catch((error) => {
    //     console.error('Error:', error);
    //     });

    // }
    questions = initializeDiagnosisRemarksTracking(
      normalizeExamQuestions(questions)
    );

    let currentIndex =
      props.location && props.location.current
        ? props.location.current
        : sessionStorage.getItem("current")
        ? Number(sessionStorage.getItem("current"))
        : 0;

    const diagnosesAndExtremitiesFromLocalStorage = sessionStorage.getItem(
      "currentDiagnosesAndExtremities"
    );
    let diagnosesAndExtremities =
      this.props.location &&
      Object.prototype.hasOwnProperty.call(
        this.props.location,
        "diagnosesAndExtremities"
      )
        ? this.props.location.diagnosesAndExtremities
        : getDiagnosesAndExtremities(currentDbq, patient);

    if (!diagnosesAndExtremities && diagnosesAndExtremitiesFromLocalStorage) {
      diagnosesAndExtremities = JSON.parse(
        diagnosesAndExtremitiesFromLocalStorage
      );
    }

    this.state = {
      page: page,
      dbqSrc: currentDbq.src,
      currentDbq: currentDbq,
      patient: patient,
      current: currentIndex,
      totalQuestion: questions && questions.length > 0 ? questions.length : 0,
      questions: questions && questions.length > 0 ? questions : [],
      singleQuestion: {},
      yesnocurrent: 0,
      yesnoRef:
        questions && questions[currentIndex] && questions[currentIndex].ref
          ? questions[currentIndex].ref
          : 0,
      yesnoRefOuter:
        questions &&
        questions[currentIndex] &&
        questions[currentIndex].outer_ref
          ? questions[currentIndex].outer_ref
          : 0,
      isPlayingVideo: false,
      isLegendViewing: false,
      videoUrl: "",
      videoValue: "",
      videoFirstColumn: false,
      videoSecondColumn: false,
      selectedVideo: "",
      selectedValue: "",
      showCalender: false,
      showCalender2: false,
      showCalender3: false,
      showExamMenu: false,
      showMiniDoc: false,
      blockedNavigation: false,
      errorFlag: false, // remove error flag if you don't want to show error msg line on previous question
      diagnosesAndExtremities,
      showDiagnosesAndExtremities: false,
      errorMessage: "",
      errorMessageSub: "",
      unansweredConfirmation: null
    };
    this.setDiagnosesAndExtremitiesRef =
      this.setDiagnosesAndExtremitiesRef.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.setAdditionalResponse = this.setAdditionalResponse.bind(this);
    this.stepperRef = null;
    this.setStepperRef = this.setStepperRef.bind(this);
    console.log("Exam questions set in state: ", questions);
  }

  setStepperRef(element) {
    this.stepperRef = element;
  }

  setDiagnosesAndExtremitiesRef(node) {
    this.diagnosesAndExtremitiesRef = node;
  }

  setAdditionalResponse(fieldName, response, isButton, showDisclaimer, removeComment) {
    const updatedQuestions = this.state.questions;

    for (let i = 0; i < updatedQuestions.length; i++) {
      if (
        updatedQuestions[i].dbqName === fieldName ||
        updatedQuestions[i].textdbqName === fieldName
      ) {
        updatedQuestions[i].additionalResponse = response;
        if (isButton && removeComment === true) {
          updatedQuestions[i].hasAdditionalResponse = false;
          updatedQuestions[i].isOverwritten = false;
          updatedQuestions[i].showDisclaimer = false;
        } else if (isButton && removeComment !== true) {
          updatedQuestions[i].hasAdditionalResponse = true;
          // disclaimer shows up for overwrite comment, if overwrite comment is true, showDisclaimer is true, hence isOverwritten is true
          // isOverwritten flag is used on the review page
          if(showDisclaimer === true) {
            updatedQuestions[i].isOverwritten = true;
            updatedQuestions[i].showDisclaimer = true;
          } else {
            updatedQuestions[i].isOverwritten = false;
            updatedQuestions[i].showDisclaimer = false;          }
        }
        break;
      }
    }

    this.setState({
      questions: updatedQuestions,
    });
  }

  getQuestionsFromFile = (dbq) => {
    let questions = [];
    let ssn = "";
    if (dbq && dbq.toLowerCase() === "back disabilities") {
      questions = _.cloneDeep(back_questions);
      ssn = back_ssn;
    } else if (dbq && dbq.toLowerCase() === "neck disabilities") {
      questions = _.cloneDeep(neck_questions);
      ssn = neck_ssn;
    } else if (dbq && dbq.toLowerCase() === "ankle disabilities") {
      questions = _.cloneDeep(ankle_questions);
      ssn = ankle_ssn;
    } else if (dbq && dbq.toLowerCase() === "wrist conditions") {
      questions = _.cloneDeep(wrist_questions);
      ssn = wrist_ssn;
    } else if (dbq && dbq.toLowerCase() === "hip disabilities") {
      questions = _.cloneDeep(hip_questions);
      ssn = hip_ssn;
    } else if (dbq && dbq.toLowerCase() === "knee disabilities") {
      questions = _.cloneDeep(knee_questions);
      ssn = knee_ssn;
    } else if (dbq && dbq.toLowerCase() === "shoulder disabilities") {
      questions = _.cloneDeep(shoulder_questions);
      ssn = shoulder_ssn;
    } else if (dbq && dbq.toLowerCase() === "elbow disabilities") {
      questions = _.cloneDeep(elbow_questions);
      ssn = elbow_ssn;
    } else if (
      dbq &&
      dbq.toLowerCase() === "mental disorders other than ptsd"
    ) {
      questions = _.cloneDeep(mental_questions);
      ssn = mental_ssn;
    } else if (dbq && dbq.toLowerCase() === "ptsd") {
      questions = _.cloneDeep(ptsd_questions);
      ssn = ptsd_ssn;
    } else if (
      dbq &&
      dbq.toLowerCase() === "kidney disease, kidney stones, etc"
    ) {
      questions = _.cloneDeep(kidney_questions);
      ssn = kidney_ssn;
    } else if (dbq && dbq.toLowerCase() === "ibs") {
      questions = _.cloneDeep(ibs_questions);
      ssn = ibs_ssn;
    } else if (dbq && dbq.toLowerCase() === "nerve disabilities") {
      questions = _.cloneDeep(nerves_questions);
      ssn = nerves_ssn;
    } else if (dbq && dbq.toLowerCase() === "sinusitis") {
      questions = _.cloneDeep(sinusitis_questions);
      ssn = sinusitis_ssn;
    } else if (dbq && dbq.toLowerCase() === "heart disabilities") {
      questions = _.cloneDeep(heart_questions);
      ssn = heart_ssn;
    } else if (
      dbq &&
      dbq.toLowerCase() === "varicose veins, peripheral vascular disease, etc."
    ) {
      questions = _.cloneDeep(veins_questions);
      ssn = veins_ssn;
    } else if (dbq && dbq.toLowerCase() === "tmj") {
      questions = _.cloneDeep(tmj_questions);
      ssn = tmj_ssn;
    } else if (
      dbq &&
      dbq.toLowerCase() === "migraines, tension headaches, etc."
    ) {
      questions = _.cloneDeep(headache_questions);
      ssn = headache_ssn;
    } else if (dbq && dbq.toLowerCase() === "sleep apnea") {
      questions = _.cloneDeep(sleep_questions);
      ssn = sleep_ssn;
    } else if (dbq && dbq.toLowerCase() === "hepatitis") {
      questions = _.cloneDeep(hepatitis_questions);
      ssn = hepatitis_ssn;
    } else if (dbq && dbq.toLowerCase() === "prostate cancer") {
      questions = _.cloneDeep(prostateCancer_questions);
      ssn = prostateCancer_ssn;
    } else if (dbq && dbq.toLowerCase() === "seizure disorders") {
      questions = _.cloneDeep(seizure_questions);
      ssn = seizure_ssn;
    } else if (dbq && dbq.toLowerCase() === "skin diseases") {
      questions = _.cloneDeep(skin_questions);
      ssn = skin_ssn;
    }  else if (dbq && dbq.toLowerCase() === "asthma, sarcoidosis, etc.") {
      questions = _.cloneDeep(asthma_questions);
      ssn = asthma_ssn;
    } else if (dbq && dbq.toLowerCase() === "hand and fingers") {
      questions = _.cloneDeep(handFingers_questions);
      ssn = handFingers_ssn;
    } else if (
      dbq &&
      dbq.toLowerCase() ===
        "bladder disabilities, urinary tract infection, etc."
    ) {
      questions = _.cloneDeep(bladder_questions);
      ssn = bladder_ssn;
    } else if (dbq && dbq.toLowerCase() === "fibromyalgia") {
      questions = _.cloneDeep(fibromyalgia_questions);
      ssn = fibromyalgia_ssn;
    } else if (dbq && dbq.toLowerCase() === "gout") {
      questions = _.cloneDeep(arthritis_questions);
      ssn = arthritis_ssn;
    } else if (dbq && dbq.toLowerCase() === "gerd, hiatal hernia, etc.") {
      questions = _.cloneDeep(gerd_questions);
      ssn = gerd_ssn;
    } else if (dbq && dbq.toLowerCase() === "hemorrhoids") {
      questions = _.cloneDeep(hemorrhoids_questions);
      ssn = hemorrhoids_ssn;
    } else if (dbq && dbq.toLowerCase() === "diabetic neuropathy") {
      questions = _.cloneDeep(diabeticNeuro_questions);
      ssn = diabeticNeuro_ssn;
    } else if (dbq && dbq.toLowerCase() === "diabetes") {
      questions = _.cloneDeep(diabetes_questions);
      ssn = diabetes_ssn;
    } else if (
      dbq &&
      dbq.toLowerCase() === "erectile dysfunction, prostatitis, etc."
    ) {
      questions = _.cloneDeep(ed_questions);
      ssn = ed_ssn;
    } else if (dbq && dbq.toLowerCase() === "scars") {
      questions = _.cloneDeep(scars_questions);
      ssn = scars_ssn;
    } else if (dbq && dbq.toLowerCase() === "multiple sclerosis") {
      questions = _.cloneDeep(ms_questions);
      ssn = ms_ssn;
    } else if (dbq && dbq.toLowerCase() === "hiv") {
      questions = _.cloneDeep(hiv_questions);
      ssn = hiv_ssn;
    } else if (dbq && dbq.toLowerCase() === "eating") {
      questions = _.cloneDeep(eat_questions);
      ssn = eat_ssn;
    }

    let pt = this.state.patient;
    pt.ssn = ssn;
    this.setState({ patient: pt });
    sessionStorage.setItem("patient", JSON.stringify(this.state.patient));
    return initializeDiagnosisRemarksTracking(normalizeExamQuestions(questions));
  };

  getConditionalQuestions = () => {
    //let questions =  _.cloneDeep(foot_questions);
    let { questions, patient, currentDbq } = this.state;
    console.log("getConditionalQuestions", questions);
    if (questions && questions.length === 0) {
      questions = this.getQuestionsFromFile(currentDbq.name);
      console.log("Got Questions from getQuestionsFromFile: ", questions);
    }
    let currentDbqId = currentDbq.id;
    let src = getDbqSrc(currentDbq);
    let found = false;
    let dbqCondition = "";

    if (patient.disabilities) {
      // this should run only first time loading the exam
      for (let disab of patient.disabilities) {
        if (disab.dbqId === currentDbqId) {
          dbqCondition = disab.dbqCondition;
          found = true;
          break;
        }
      }
    }

    if (found || src === "knee") {
      if (found && src === "foot") {
        if (dbqCondition === "Pes Planus") {
          questions = questions.filter((q) => {
            return q.section.number[0] !== "4";
          });
        } else if (dbqCondition === "Plantar Fasciitis") {
          questions = questions.filter((q) => {
            return q.section.number[0] !== "3";
          });
        }
      }
      else if (src === "knee") {

        questions = filterByRelatedExtremity(questions, this.state.diagnosesAndExtremities)

      }
      else if (found && src === "kidney") {
        if (dbqCondition === "Kidney Disease") {
          questions = questions.filter((q) => {
            return q.section && q.section.number && q.section.number[0] !== "4";
          });
        } else if (dbqCondition === "Kidney Stones") {
          questions = questions.filter((q) => {
            console.log(
              "🚀 ~ file: Exam.js:3814 ~ questions=questions.filter ~ q:",
              q
            );
            return q.section && q.section.number && q.section.number[0] !== "3";
          });
        }
        let isafter = moment(patient.itfExpire).isAfter("2021-11-01");
        if (!isafter) {
          let questions_2 = [questions[questions.length - 1]];
          let questions_1 = questions.splice(0, questions.length - 1);
          questions = [...questions_1, ...kidney_old_questions, ...questions_2];
        }
      } else if (found && src === "prostate") {
        if (dbqCondition === "Prostate Cancer") {
          questions = questions.filter((q) => {
            return q.section.number[0] !== "4";
          });
        } else if (dbqCondition === "Prostatitis") {
          questions = questions.filter((q) => {
            return q.section.number[0] !== "3";
          });
        }
      }
    }
    if (questions) {
      for (let i = 0; i < questions.length; i++) {
        questions[i].question = questions[i].question.replace(
          "##name##",
          patient && patient.name
        );
        if (questions[i].question.includes("##redHeading##")) {
          questions[i].question = questions[i].question.replace(
            "##redHeading##",
            questions[i].redHeading
          );
        }
      }
    }
    return normalizeExamQuestions(questions);
  };
  // loadExamQuestions = (questions, id, name, questions_v1) => {
  //     if (!questions_v1) {
  //         return questions
  //     } else {
  //         let token = localStorage.getItem('login_token');
  //         let headers = {"Content-Type": "application/json"};
  //         headers["Authorization"] = `Bearer ${token}`
  //         fetch(process.env.API_URL+"/patients/version/"+id+"/"+name, {headers})
  //         .then(response => response.json())
  //         .then(data => {
  //             this.setState({questions: data.questions})
  //         })
  //         .catch((error) => {
  //         console.error('Error:', error);
  //         });
  //        }
  //     //    return questions
  // }

  clearObject = (subOption) => {
    console.log("clearObject: ", subOption.main);
    subOption.answer = "";
    subOption.showSubItems ? (subOption.showSubItems = false) : "";
    subOption.showSubItems3 ? (subOption.showSubItems3 = false) : "";
    subOption.subAnswer ? (subOption.subAnswer = "") : "";
    subOption.subAnswer2 ? (subOption.subAnswer2 = "") : "";
    subOption.subAnswer3 ? (subOption.subAnswer3 = "") : "";

    subOption.text1 ? (subOption.text1 = "") : "";
    subOption.text2 ? (subOption.text2 = "") : "";
    subOption.text3 ? (subOption.text3 = "") : "";
    subOption.textOther ? (subOption.textOther = "") : "";
    subOption.textOther3 ? (subOption.textOther3 = "") : "";
    subOption.altTextOther3 ? (subOption.altTextOther3 = "") : "";
    clearDropdownTextFields(subOption);
    subOption.date1 ? (subOption.date1 = "") : "";
    subOption.date2 ? (subOption.date2 = "") : "";
    subOption.date3 ? (subOption.date3 = "") : "";

    subOption.subItemOther ? (subOption.subItemOther = false) : "";
    subOption.subItem3Other ? (subOption.subItem3Other = false) : "";
    subOption.subItem3Other2 ? (subOption.subItem3Other2 = false) : "";

    subOption.showDisclaimer ? (subOption.showDisclaimer = false): "";

    subOption.subItems && subOption.subItems.map((item) => (item.answer = ""));
    subOption.subItems2 &&
      subOption.subItems2.map((item) => (item.answer = ""));
    subOption.subItems3 &&
      subOption.subItems3.map((item) => (item.answer = ""));
  };

  setRadioModalBulkSubAnswer = (e) => {
    let { questions } = this.state;
    const question = questions[e.questionIndex];

    question.questions.forEach((subOption) => {
      if (!isExamItemVisible(subOption)) return;
      if (!Array.isArray(subOption.subItems)) return;

      const matchingSubItem = subOption.subItems.find(
        (item) => item.main === e.value
      );

      if (!matchingSubItem) return;

      this.clearObject(subOption);
      subOption.answer = subOption.main;
      subOption.subAnswer = matchingSubItem.main;
    });

    questions = sanitizeBlockedResponses(questions);
    questions = syncControlledSelectQuestions(questions);
    questions = syncConditionalTextQuestions(questions);
    this.setState({ questions: questions, errorFlag: false });
  };

  toggleCalender = (e) => {
    console.log(JSON.stringify(e));
    let {
      showCalender = false,
      showCalender2 = false,
      showCalender3 = false,
      questions,
    } = this.state;
    if (e.ck === "date1") {
      questions[e.questionIndex].questions[e.index]["date1"] = moment(
        e.value
      ).format("MM/DD/YYYY");
      this.setState({ showCalender: !showCalender });
    } else if (e.ck === "date2") {
      questions[e.questionIndex].questions[e.index]["date2"] = moment(
        e.value
      ).format("MM/DD/YYYY");
      this.setState({ showCalender2: !showCalender2 });
    } else if (e.ck === "date3") {
      questions[e.questionIndex].questions[e.index]["date3"] = moment(
        e.value
      ).format("MM/DD/YYYY");
      this.setState({ showCalender3: !showCalender3 });
    }
  };

  setTextModal = (e) => {
    console.log(JSON.stringify(e), e.value, " and length: ", e.value.length);
    let { questions } = this.state;
    questions[e.questionIndex].questions[e.index][e.field] = e.value;
    if (e.dropdownTextField) {
      syncDropdownTextFieldValue(
        questions[e.questionIndex].questions[e.index],
        e.dropdownTextField
      );
    }
    questions = syncClonedSelectAnswers(questions);
    questions = sanitizeBlockedResponses(questions);
    questions = syncControlledSelectQuestions(questions);
    questions = syncConditionalTextQuestions(questions);
    this.setState({ questions: questions });
  };

  updateRadioModal = (e) => {
    let { questions } = this.state;
    console.log("questions", questions);
    let subOption = questions[e.questionIndex].questions[e.index];

    if (e.src === "save") {
      let valid = false;
      try {
        if (subOption.hasOwnProperty("date1") && subOption.date1.length === 0) {
          subOption.date1 = moment().format("MM/DD/YYYY");
          throw "Enter date in the field";
        }
        if (subOption.hasOwnProperty("date2") && subOption.date2.length === 0) {
          subOption.date2 = moment().format("MM/DD/YYYY");
          // throw "Enter date in the field";
        }
        if (subOption.hasOwnProperty("date3") && subOption.date3.length === 0) {
          subOption.date3 = moment().format("MM/DD/YYYY");
          // throw "Enter date in the field";
        }
        const dropdownTextFieldError = validateDropdownTextFields(subOption);
        if (dropdownTextFieldError) throw dropdownTextFieldError;
        if (
          subOption.hasOwnProperty("text1") &&
          !subOption.text1Optional &&
          subOption.text1.length === 0
        )
          throw "Enter value of text field";
        else if (
          subOption.hasOwnProperty("text2") &&
          !subOption.text2Optional &&
          subOption.text2.length === 0
        )
          throw "Enter value of text field";
        else if (
          subOption.hasOwnProperty("text3") &&
          !subOption.text3Optional &&
          subOption.text3.length === 0
        )
          throw "Enter value of text field";
        else if (
          subOption.hasOwnProperty("textOther") &&
          subOption.subItemOther &&
          subOption.textOther.length === 0
        ) {
          if(subOption.requireOther !== false) {
            throw "Enter value of text field";
          }
        }
        else if (subOption.multi) {
          if (subOption.hasOwnProperty("subAnswer")) {
            for (let sub of subOption.subItems) {
              if (sub.answer.length > 0) {
                valid = true;
              }
            }
            if (!valid) {
              throw "Please select all values";
            }
          } else if (subOption.hasOwnProperty("subAnswer2")) {
            for (let sub of subOption.subItems) {
              if (sub.answer.length > 0) {
                valid = true;
              }
            }
            if (!valid) {
              throw "Please select all values";
            }
          } else if (
            subOption.hasOwnProperty("subAnswer3") &&
            subOption.showSubItems3
          ) {
            for (let sub of subOption.subItems) {
              if (sub.answer.length > 0) {
                valid = true;
              }
            }
            if (!valid) {
              throw "Please select all values";
            }
          }
        } else {
          if (
            subOption.hasOwnProperty("subAnswer") &&
            subOption.subAnswer.length === 0 &&
            !subOption.subItemsOptional
          )
            throw "Please select all values";
          else if (
            subOption.hasOwnProperty("subAnswer2") &&
            subOption.subAnswer2.length === 0
          )
            throw "Please select all values";
          else if (
            subOption.hasOwnProperty("subAnswer3") &&
            subOption.showSubItems3 &&
            subOption.subAnswer3.length === 0
          )
            throw "Please select all values";
        }
        subOption.showSubItems = false;
      } catch (err) {
        this._addNotification(err, "sub");
      }
    } else {
      if (questions[e.questionIndex].answer) {
        // incase outer multi is false
        questions[e.questionIndex].answer = "";
      }
      this.clearObject(subOption);
    }
    questions = sanitizeBlockedResponses(questions);
    questions = syncControlledSelectQuestions(questions);
    questions = syncConditionalTextQuestions(questions);
    this.setState({ questions: questions });
  };

  addMore = (e) => {
    let { questions } = this.state;
    questions[e.questionIndex].questions.scars.push({
      main: questions[e.questionIndex].questions.scars.length + 1,
      answerLength: "",
      answerWidth: "",
    });
    console.log(questions);
    this.setState({ questions: questions });
  };
  deleteScar = (e) => {
    let { questions } = this.state;
    if (questions[e.questionIndex].questions.scars.length > 1) {
      questions[e.questionIndex].questions.scars.pop();
      this.setState({ questions: questions });
    }
  };

  addMoreDisfigurement = (e) => {
    let { questions } = this.state;
    questions[e.questionIndex].questions.scars.push({
      main: questions[e.questionIndex].questions.scars.length + 1,
      answerLength: "",
      answerWidth: "",
      options: [
        {
          main: "Scar",
        },
        {
          main: "Disfigurement",
        },
      ],
      answer: "Scar",
      text1: "",
      textLabel1: "Location of the Scar/Disfigurement",
    });
    this.setState({ questions: questions });
  };
  deleteDisfigurement = (e) => {
    let { questions } = this.state;
    if (questions[e.questionIndex].questions.scars.length > 1) {
      questions[e.questionIndex].questions.scars.pop();
      this.setState({ questions: questions });
    }
  };

  loadScarOptions = (e) => {
    // alert(JSON.stringify(e))
    let { questions } = this.state;
    return questions[e.questionIndex - e.scarsIndex];
  };

  showLegend = (e) => {
    this.setState({ isLegendViewing: !this.state.isLegendViewing });
  };

  handleChangeValue = (e) => {
    let { questions, errorFlag } = this.state;
    this.validationErrorMessage = "";
    this.setState({errorMessageSub: ""})
    // this is for back exam
    if(questions[e.questionIndex].dbqName_no === "form1[0].#subform[13].YesNo13A[0]" && questions[e.questionIndex].section.title === "OTHER NEUROLOGIC ABNORMALITIES"){
      if(e.value === "No") {
        questions[e.questionIndex].textanswer = ""
        questions[questions.length -1].answer = ""
      } else {
        if(questions[e.questionIndex].textanswer === "") {
          questions[e.questionIndex].textanswer = questions[e.questionIndex].defaulttextanswer
        }
        if(questions[questions.length - 1].answer === "") {
          questions[questions.length - 1].answer = questions[questions.length -1].defaultanswer
        }
      }
    }
    //console.log(e);  
    if (e.questionIndex === 0 || e.questionIndex) {
      if (
        questions[e.questionIndex].type === "text" ||
        questions[e.questionIndex].type === "radio"
      ) {
        questions[e.questionIndex].questions[e.index].answer = e.value;
        if (questions[e.questionIndex].type === "text") {
          clearInvalidDependentSelectAnswers(
            { options: questions[e.questionIndex].questions },
            e.index
          );
        }
        if (
          questions[e.questionIndex].type === "text" &&
          questions[e.questionIndex].questions[e.index].video
        ) {
          if (e.col === "first") {
            this.setState({
              videoSecondColumn: true,
              selectedVideo:
                questions[e.questionIndex].questions[e.index].video,
              selectedValue:
                questions[e.questionIndex].questions[e.index].answer,
            });
          } else {
            this.setState({
              videoFirstColumn: true,
              selectedVideo:
                questions[e.questionIndex].questions[e.index].video,
              selectedValue:
                questions[e.questionIndex].questions[e.index].answer,
            });
          }
          if (e.videoTag) {
            e.videoTag.src =
              questions[e.questionIndex].questions[e.index].video;
            let pauseTime = 590;
            pauseTime =
              pauseTime *
              (questions[e.questionIndex].questions[e.index].answer / 5);
            e.videoTag.play();
            setTimeout(() => {
              e.videoTag && e.videoTag.pause();
            }, pauseTime);
          }
          // if(e.videoTagLeft){
          //     e.videoTagLeft.src = questions[e.questionIndex].questions[e.index].video;
          //     let pauseTime = 590;
          //     pauseTime = pauseTime * (questions[e.questionIndex].questions[e.index].answer/5);
          //     e.videoTagLeft.play();
          //     setTimeout(() => {
          //         e.videoTagLeft && e.videoTagLeft.pause();
          //     }, pauseTime);
          // }
        }
        if (questions[e.questionIndex].type === "radio") {
          if (questions[e.questionIndex].ref) {
            for (let i = 1; i <= questions[e.questionIndex].ref; i++) {
              questions[e.questionIndex + i].refValue = e.value;
            }
          }
          if (questions[e.questionIndex].questions[e.index].association) {
            for (let opt of questions[e.questionIndex].questions[e.index - 1]
              .options) {
              if (
                opt.target &&
                questions[e.questionIndex].questions[e.index - 1].answer ===
                  opt.main
              ) {
                let targets = opt.target.split(",");
                for (let i = 0; i < targets.length; i++) {
                  questions[e.questionIndex].questions[e.index].options[
                    i
                  ].dbqName = targets[i];
                }
              }
            }
          }
          if (
            questions[e.questionIndex].questions[e.index].associationBy &&
            questions[e.questionIndex].questions[e.index].answer !=
              questions[e.questionIndex].questions[e.index].defaultVal
          ) {
            questions[e.questionIndex].questions[
              questions[e.questionIndex].questions[e.index].associationBy
            ].answer = "";
          }
          if (
            questions[e.questionIndex].questions[e.index].associationBy &&
            questions[e.questionIndex].questions[e.index].answer ===
              questions[e.questionIndex].questions[e.index].defaultVal
          ) {
            questions[e.questionIndex].questions[
              questions[e.questionIndex].questions[e.index].associationBy
            ].answer =
              questions[e.questionIndex].questions[
                questions[e.questionIndex].questions[e.index].associationBy
              ].defaultVal;
          }
        }
      }

      if (questions[e.questionIndex].type === "radioTiles") {
        console.log(e.value)
        if (e.textValue) {
          if (questions[e.questionIndex].multi) {
            questions[e.questionIndex].questions[e.index].textAnswer = e.value;
          } else {
            questions[e.questionIndex].textAnswer = e.value;
          }
        } else {
          if (questions[e.questionIndex].multi) {
            if (questions[e.questionIndex].questions[e.index].answer) {
              if (questions[e.questionIndex].questions[e.index].isLinked) {
                if (
                  window.confirm(
                    questions[e.questionIndex].questions[e.index].destMapMessage
                      ? questions[e.questionIndex].questions[e.index]
                          .destMapMessage
                      : "This Option is pre-selected based on your response of a previous question!!"
                  ) == true
                ) {
                  questions[e.questionIndex].questions[e.index].answer = "";
                  if (questions[e.questionIndex].textarea) {
                    questions[e.questionIndex].questions[e.index].textAnswer =
                      "";
                  }
                }
              } else {
                questions[e.questionIndex].questions[e.index].answer = "";
                if (questions[e.questionIndex].textarea) {
                  questions[e.questionIndex].questions[e.index].textAnswer = "";
                }
              }
            } else {
              questions[e.questionIndex].questions[e.index].answer = e.value;
              if (questions[e.questionIndex].partial) {
                for (let option of questions[e.questionIndex].questions) {
                  if (
                    questions[e.questionIndex].questions[e.index].partialField
                  ) {
                    if (!option.partialField) {
                      option.answer = "";
                      if (option.textAnswer) {
                        option.textAnswer = "";
                      }
                    }
                  } else {
                    if (option.partialField) {
                      option.answer = "";
                    }
                  }
                }
              }
            }
          } else {
            questions[e.questionIndex].answer = e.value;
            questions[e.questionIndex].textAnswer = "";
          }
        }
      }

      if (questions[e.questionIndex].type === "radioModal") {
        // hasSubItems3 is tested on Foot DBQ only
        if (
          questions[e.questionIndex].multi ||
          questions[e.questionIndex].hasSubItems3
        ) {
          if (e.indexSecond >= 0) {
            if (questions[e.questionIndex].questions[e.index].multi) {
              if (e.subAnswer === "subAnswer") {
                if (
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].answer
                ) {
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].answer = "";
                } else {
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].answer = e.value;
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].subItemLinked
                ) {
                  if (questions[e.questionIndex].questions[e.index].hasOwnProperty("textOther2")) {
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItemOther2 = true;
                  }
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItemOther = true;
                } else {
                  if (questions[e.questionIndex].questions[e.index].hasOwnProperty("textOther2")) {
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItemOther2 = false;
                  }
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItemOther = false;
                }
                // below is the newly added code for question where new set of radio options are to show on selection on subAnswer
                if (
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].subItem3Linked
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].showSubItems3 = true;
                } else {
                  // Only set to false if no subItems with subItem3Linked are selected
                  questions[e.questionIndex].questions[
                    e.index
                  ].showSubItems3 = questions[e.questionIndex].questions[e.index].subItems.some(
                    (subItem) => subItem.subItem3Linked && subItem.answer === subItem.main
                  );
                }
              }
              if (e.subAnswer === "subAnswer2") {
                if (
                  questions[e.questionIndex].questions[e.index].subItems2[
                    e.indexSecond
                  ].answer
                ) {
                  questions[e.questionIndex].questions[e.index].subItems2[
                    e.indexSecond
                  ].answer = "";
                } else {
                  questions[e.questionIndex].questions[e.index].subItems2[
                    e.indexSecond
                  ].answer = e.value;
                }
              }
              if (e.subAnswer === "subAnswer3") {
                if (questions[e.questionIndex].questions[e.index].singleSubItem3) {
                  questions[e.questionIndex].questions[e.index].subItems3.forEach(
                    (subItem) => subItem.answer = "",
                  );
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].answer
                ) {
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].answer = "";
                } else {
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].answer = e.value;
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].subItem3OtherLinked
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other = true;

                  if (
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other2
                  ) {
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other2 = false;

                    questions[e.questionIndex].questions[
                      e.index
                    ].altTextOther3 = "";
                  }
                } else {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other = false;
                  questions[e.questionIndex].questions[
                    e.index
                  ].textOther3 = "";
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].subItem3Other2Linked
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other2 = true;

                  if (
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other
                  ) {
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other = false;
                  }                 
                } else {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other2 = false;
                  questions[e.questionIndex].questions[
                    e.index
                  ].altTextOther3 = "";
                }
              }
            } else {
              console.log(
                JSON.stringify(
                  "e.indexSecond >= 0 && questions[e.questionIndex].questions[e.index].multi is false"
                )
              );
              questions[e.questionIndex].questions[e.index][e.subAnswer] =
                e.value;
              if (e.subAnswer === "subAnswer") {
                if (
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].subItemLinked
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItemOther = true;
                } else {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItemOther = false;
                  if (
                    questions[e.questionIndex].questions[e.index]
                      .clearTextOtherWhenSubItemOtherHidden
                  ) {
                    questions[e.questionIndex].questions[e.index].textOther = "";
                    clearDropdownTextFields(
                      questions[e.questionIndex].questions[e.index],
                      ["textOther"]
                    );
                  }
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].subItemLinked2
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItemOther2 = true;
                } else {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItemOther2 = false;
                }
                // below is the newly added code for question where new set of radio options are to show on selection on subAnswer
                if (
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].subItem3Linked
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].showSubItems3 = true;
                } else {
                  // Only set to false if no subItems with subItem3Linked are selected
                  questions[e.questionIndex].questions[
                    e.index
                  ].showSubItems3 = questions[e.questionIndex].questions[e.index].subItems.some(
                    (subItem) => subItem.subItem3Linked && subItem.answer === subItem.main
                  );
                }
                if(questions[e.questionIndex].questions[e.index].subItems[e.indexSecond].deselect){
                  questions[e.questionIndex].questions[e.index].answer= "";
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItem3Other
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other = false;
                  questions[e.questionIndex].questions[
                    e.index
                  ].textOther3 = "";
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItem3Other2
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other2 = false;
                  questions[e.questionIndex].questions[
                    e.index
                  ].altTextOther3 = "";
                }
              }
              if (e.subAnswer === "subAnswer3") {
                if (
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].answer
                ) {
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].answer = "";
                } else {
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].answer = e.value;
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].subItem3OtherLinked
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other = questions[e.questionIndex].questions[e.index].multiSubItems3
                    ? !questions[e.questionIndex].questions[e.index].subItem3Other
                    : true;

                  if (
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other2
                  ) {
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other2 = false;

                    questions[e.questionIndex].questions[
                      e.index
                    ].altTextOther3 = "";
                  }
                } else {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other = questions[e.questionIndex].questions[e.index].multiSubItems3
                    ? questions[e.questionIndex].questions[e.index].subItems3.some(
                      (subItem) => subItem.subItem3OtherLinked && subItem.answer === subItem.main
                    )
                    : false;
                  questions[e.questionIndex].questions[
                    e.index
                  ].textOther3 = "";
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].subItem3Other2Linked
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other2 = true;

                  if (
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other
                  ) {
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other = false;
                  }                 
                } else {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other2 = false;
                  questions[e.questionIndex].questions[
                    e.index
                  ].altTextOther3 = "";
                }
              }
              console.log(
                "questions[e.questionIndex].questions[e.index]: ",
                questions[e.questionIndex].questions[e.index]
              );
            }
          } else {
            if (questions[e.questionIndex].questions[e.index].answer) {
              this.clearObject(questions[e.questionIndex].questions[e.index]);
              // questions[e.questionIndex].questions[e.index].answer = "";
              // questions[e.questionIndex].questions[e.index].showSubItems = false;
              // questions[e.questionIndex].questions[e.index].subAnswer = "";
              // questions[e.questionIndex].questions[e.index].subItems &&
              // questions[e.questionIndex].questions[e.index].subItems.map((item) => item.answer = "");
            } else {
              questions[e.questionIndex].questions[e.index].answer = e.value;
              if (
                (questions[e.questionIndex].questions[e.index].subItems &&
                  questions[e.questionIndex].questions[e.index].subItems[0]) ||
                questions[e.questionIndex].questions[e.index].dbqDate1 ||
                questions[e.questionIndex].questions[e.index].dbqName1
              ) {
                questions[e.questionIndex].questions[
                  e.index
                ].showSubItems = true;
              }
            }
          }
          if (
            questions[e.questionIndex].partial &&
            questions[e.questionIndex].questions[e.index].partialField
          ) {
            for (const [i, question] of Object.values(
              questions[e.questionIndex].questions
            ).entries()) {
              if (e.index !== i) {
                this.clearObject(question);
              }
            }
          }
        } else {
          if (e.indexSecond >= 0) {
            if (questions[e.questionIndex].questions[e.index].multi) {
              if (e.subAnswer === "subAnswer2") {
                if (questions[e.questionIndex].questions[e.index].subItems2RadioGroup) {
                  questions[e.questionIndex].questions[e.index].subItems2.forEach((question) => {
                    question.answer = "";
                  });
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems2[
                    e.indexSecond
                  ].answer
                ) {
                  questions[e.questionIndex].questions[e.index].subItems2[
                    e.indexSecond
                  ].answer = "";
                } else {
                  questions[e.questionIndex].questions[e.index].subItems2[
                    e.indexSecond
                  ].answer = e.value;
                }
              } else if (e.subAnswer === "subAnswer3") {
                if (questions[e.questionIndex].questions[e.index].singleSubItem3) {
                  questions[e.questionIndex].questions[e.index].subItems3.forEach(
                    (subItem) => subItem.answer = "",
                  );
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].answer
                ) {
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].answer = "";
                } else {
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].answer = e.value;
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].subItem3OtherLinked
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other = true;

                  if (
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other2
                  ) {
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other2 = false;

                    questions[e.questionIndex].questions[
                      e.index
                    ].altTextOther3 = "";
                  }
                } else {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other = false;
                  questions[e.questionIndex].questions[
                    e.index
                  ].textOther3 = "";
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems3[
                    e.indexSecond
                  ].subItem3Other2Linked
                ) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other2 = true;

                  if (
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other
                  ) {
                    questions[e.questionIndex].questions[
                      e.index
                    ].subItem3Other = false;
                  }                 
                } else {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItem3Other2 = false;
                  questions[e.questionIndex].questions[
                    e.index
                  ].altTextOther3 = "";
                }
              } else {
                if (
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].answer
                ) {
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].answer = "";
                } else {
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].answer = e.value;
                }
                if (
                  questions[e.questionIndex].questions[e.index].subItems[
                    e.indexSecond
                  ].subItem3Linked
                ) {
                  // If this subItem is linked to subItems3, set showSubItems3 to true
                  questions[e.questionIndex].questions[e.index].showSubItems3 = true;
                } else {
                  // Only set to false if no subItems with subItem3Linked are selected
                  questions[e.questionIndex].questions[
                    e.index
                  ].showSubItems3 = questions[e.questionIndex].questions[e.index].subItems.some(
                    (subItem) => subItem.subItem3Linked && subItem.answer === subItem.main
                  );
                }
              }
            } else {
              //questions[e.questionIndex].questions[e.index].subAnswer = e.value;
              questions[e.questionIndex].questions[e.index][e.subAnswer] =
                e.value;



              if (e.subAnswer === "subAnswer3") {
                if (questions[e.questionIndex].questions[e.index].subItems3[e.indexSecond].subItem3OtherLinked) {
                  questions[e.questionIndex].questions[e.index].subItem3Other =
                    questions[e.questionIndex].questions[e.index].multiSubItems3
                      ? !questions[e.questionIndex].questions[e.index].multiSubItems3
                      : true;
                } else {
                  questions[e.questionIndex].questions[e.index].subItem3Other =
                    questions[e.questionIndex].questions[e.index].multiSubItems3
                      ? questions[e.questionIndex].questions[e.index].subItems3.some(
                        (subItem) => subItem.subItem3OtherLinked && subItem.answer === subItem.main
                      )
                      : false;
                }
              }
            }
            if (e.subAnswer === "subAnswer") {
              if (
                questions[e.questionIndex].questions[e.index].subItems[
                  e.indexSecond
                ].subItemLinked
              ) {
                questions[e.questionIndex].questions[
                  e.index
                ].subItemOther = !questions[e.questionIndex].questions[
                                    e.index
                                  ].subItemOther;
              }
              else {
                if (questions[e.questionIndex].questions[e.index].multi) {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItemOther = questions[e.questionIndex].questions[e.index].subItems.some(
                    (subItem) => subItem.subItemLinked && subItem.answer === subItem.main
                  );
                } else {
                  questions[e.questionIndex].questions[
                    e.index
                  ].subItemOther = false;
                }
              }
              //if the disclaimer should show
              if (questions[e.questionIndex].questions[e.index].subItems[
                e.indexSecond
              ].disclaimerLinked){
                questions[e.questionIndex].questions[e.index].showDisclaimer = true;
                questions[e.questionIndex].questions[e.index].subItems[e.indexSecond].disclaimerChosen = true;
              } 
              else {
                questions[e.questionIndex].questions[e.index].showDisclaimer = false;
              }
            }
            if(e.subAnswer === "subAnswer2"){
              if (questions[e.questionIndex].questions[e.index].subItems2[
                e.indexSecond
              ].disclaimerLinked){
                questions[e.questionIndex].questions[e.index].showDisclaimer = true;
                questions[e.questionIndex].questions[e.index].subItems[e.indexSecond].disclaimerChosen = true;
                  
                
              } 
              else {
                if(e.indexSecond > 0){
                  //If eiher answer to the subAnswers is Yes, then the disclaimer will show, 
                  //used in foot DBQ for 3F, 3I, and 3M applicable to other exams. 
                  questions[e.questionIndex].questions[e.index].showDisclaimer = 
                  questions[e.questionIndex].questions[e.index].subAnswer === "Yes" ||
                  questions[e.questionIndex].questions[e.index].subAnswer2 === "Yes"
                  
                }
                else{
                questions[e.questionIndex].questions[e.index].showDisclaimer = false;
                }
              }
              if (
                questions[e.questionIndex].questions[e.index].subItems2.some(
                  (si) => si.hasOwnProperty("subItem3Linked")
                )
              ) {
                if (questions[e.questionIndex].questions[e.index].subItems2[e.indexSecond].subItem3Linked) {
                  questions[e.questionIndex].questions[e.index].showSubItems3 = true;
                } else {
                  // Only set to false if no subItems2 with subItem3Linked are selected
                  questions[e.questionIndex].questions[e.index].showSubItems3 = questions[e.questionIndex].questions[e.index].subItems2.some(
                    (subItem) => subItem.subItem3Linked && subItem.answer === subItem.main
                  );
                }
              }
            }
          } else {
            questions[e.questionIndex].answer = e.value;
            for (const [i, question] of Object.values(
              questions[e.questionIndex].questions
            ).entries()) {
              if (e.index === i) {
              } else {
                if (questions[e.questionIndex].answer) {
                  console.log(
                    "questions[e.questionIndex].answer:" +
                      questions[e.questionIndex].answer +
                      ""
                  );
                  this.clearObject(question);
                }
              }
            }
            if (
              (questions[e.questionIndex].questions[e.index].subItems &&
                questions[e.questionIndex].questions[e.index].subItems[0]) ||
              questions[e.questionIndex].questions[e.index].dbqDate1 ||
              questions[e.questionIndex].questions[e.index].hasOwnProperty("text1")
            ) {
              questions[e.questionIndex].questions[e.index].showSubItems = true;
            }
            // Also check if subItems3 should be shown
            if (
              questions[e.questionIndex].questions[e.index].subItems3 &&
              questions[e.questionIndex].questions[e.index].subItems3[0]
            ) {
              questions[e.questionIndex].questions[e.index].showSubItems3 = true;
            }
          }
        }
      }

      if (questions[e.questionIndex].type === "scarsLoad") {
        if (e.field === "options") {
          questions[e.questionIndex].questions.answer = e.value;
        } else if (e.field === "text1") {
          questions[e.questionIndex].questions.text1 = e.value;
        } else if (e.field === "length") {
          questions[e.questionIndex].questions.scars[e.index].answerLength =
            e.value;
        } else if (e.field === "width") {
          questions[e.questionIndex].questions.scars[e.index].answerWidth =
            e.value;
        }
      }

      if (questions[e.questionIndex].type === "scarQuestions") {
        updateScarQuestionSelection(questions[e.questionIndex], e);
      }

      if (questions[e.questionIndex].type === "disfigurementLoad") {
        if (e.field === "options") {
          questions[e.questionIndex].questions.scars[e.index].answer = e.value;
        } else if (e.field === "text1") {
          questions[e.questionIndex].questions.scars[e.index].text1 = e.value;
        } else if (e.field === "length") {
          questions[e.questionIndex].questions.scars[e.index].answerLength =
            e.value;
        } else if (e.field === "width") {
          questions[e.questionIndex].questions.scars[e.index].answerWidth =
            e.value;
        }
      }

      if (questions[e.questionIndex].type === "disfigureQuestions") {
        console.log(JSON.stringify(e));
        questions[e.questionIndex].questions[e.index].scars[e.indexSecond]
          .answer === "X"
          ? (questions[e.questionIndex].questions[e.index].scars[
              e.indexSecond
            ].answer = "")
          : (questions[e.questionIndex].questions[e.index].scars[
              e.indexSecond
            ].answer = "X");

        let scars = e.scars;
        let len = scars[e.indexSecond].answerLength;
        let width = scars[e.indexSecond].answerWidth;

        let lengthTimesWidth = (len * width)
        if(!Number.isInteger(lengthTimesWidth)) {
          lengthTimesWidth = lengthTimesWidth.toFixed(2)
        }
        // let totalArea = 0;
        // for (let scar of scars) {
        //     totalArea += scar.answerLength*scar.answerWidth
        // }
        if (questions[e.questionIndex].questions[e.index].isUnderlying) {
          questions[e.questionIndex].underlying = questions[e.questionIndex]
          .underlying
          ? questions[e.questionIndex].underlying
          : 0;

          if(questions[e.questionIndex].questions[e.index].scars[e.indexSecond].answer === "X") {
            questions[e.questionIndex].underlying = Number(questions[e.questionIndex].underlying) + Number(lengthTimesWidth)
          } else {
            questions[e.questionIndex].underlying = Number(questions[e.questionIndex].underlying) - Number(lengthTimesWidth)
          }
          questions[e.questionIndex].underlying = questions[e.questionIndex].underlying.toFixed(2)
        }

        if (questions[e.questionIndex].questions[e.index].isAbnormalTexture) {
          questions[e.questionIndex].abnormalTexture = questions[
            e.questionIndex
          ].abnormalTexture
            ? questions[e.questionIndex].abnormalTexture
            : 0;
          
          if(questions[e.questionIndex].questions[e.index].scars[e.indexSecond].answer === "X") {
            questions[e.questionIndex].abnormalTexture = Number(questions[e.questionIndex].abnormalTexture) + Number(lengthTimesWidth)
          } else {
            questions[e.questionIndex].abnormalTexture = Number(questions[e.questionIndex].abnormalTexture) - Number(lengthTimesWidth)
          }

          questions[e.questionIndex].abnormalTexture = questions[e.questionIndex].abnormalTexture.toFixed(2)
        }

        if (questions[e.questionIndex].questions[e.index].isInflexible) {
          questions[e.questionIndex].inflexible = questions[e.questionIndex]
            .inflexible
            ? questions[e.questionIndex].inflexible
            : 0;

          if(questions[e.questionIndex].questions[e.index].scars[e.indexSecond].answer === "X") {
            questions[e.questionIndex].inflexible = Number(questions[e.questionIndex].inflexible) + Number(lengthTimesWidth)
          } else {
            questions[e.questionIndex].inflexible = Number(questions[e.questionIndex].inflexible) - Number(lengthTimesWidth)
          }

          questions[e.questionIndex].inflexible = questions[e.questionIndex].inflexible.toFixed(2)
        }
        
        if (questions[e.questionIndex].questions[e.index].isHypoPigmentation) {
          if (
            questions[e.questionIndex].questions[e.index].scars[e.indexSecond]
              .answer === "X"
          ) {
            questions[e.questionIndex].pigmentation.hypo.push(
              scars[e.indexSecond]
            );
          } else {
            let index = questions[e.questionIndex].pigmentation.hypo.indexOf(
              scars[e.indexSecond]
            );
            if (index > -1) {
              questions[e.questionIndex].pigmentation.hypo.splice(index, 1);
            }
          }
        }
        if (questions[e.questionIndex].questions[e.index].isHyperPigmentation) {
          if (
            questions[e.questionIndex].questions[e.index].scars[e.indexSecond]
              .answer === "X"
          ) {
            questions[e.questionIndex].pigmentation.hyper.push(
              scars[e.indexSecond]
            );
          } else {
            let index = questions[e.questionIndex].pigmentation.hyper.indexOf(
              scars[e.indexSecond]
            );
            if (index > -1) {
              questions[e.questionIndex].pigmentation.hyper.splice(index, 1);
            }
          }
        }
      }

      if (questions[e.questionIndex].type === "multicheckbox") {
        //questionIndex is the question number in the exam
        //index is the column the question is in
        //indexSecond is the answerchoice

        const currentQuestion = questions[e.questionIndex];
        const currentSubQuestion = currentQuestion.questions[e.index];
        const subQuestionAnswer =
          currentSubQuestion.subItems[e.indexSecond].answer;

        if (e.indexSecond >= 0) {
          if (currentSubQuestion.multi) {
            if (subQuestionAnswer) {
              //subQuestionAnswer = "";
              questions[e.questionIndex].questions[e.index].subItems[
                e.indexSecond
              ].answer = "";
            } else {
              //subQuestionAnswer = e.value;
              questions[e.questionIndex].questions[e.index].subItems[
                e.indexSecond
              ].answer = e.value;
            }
          } else {
            //currentSubQuestion.subAnswer = e.value;
            questions[e.questionIndex].questions[e.index].subAnswer = e.value;
          }
        } else {
          if (currentSubQuestion.answer) {
            //currentSubQuestion.answer = "";
            questions[e.questionIndex].questions[e.index].subAnswer = "";
            //currentSubQuestion.showSubItems = false;
            currentSubQuestion.subAnswer = "";
            currentSubQuestion.subItems &&
              currentSubQuestion.subItems.map((item) => (item.answer = ""));
          } else {
            currentSubQuestion.answer = e.value;
            if (currentSubQuestion.subItems && currentSubQuestion.subItems[0]) {
              currentSubQuestion.showSubItems = true;
            }
            // Also check if subItems3 should be shown
            if (currentSubQuestion.subItems3 && currentSubQuestion.subItems3[0]) {
              currentSubQuestion.showSubItems3 = true;
            }
          }
        }
        console.log(currentQuestion);
      }

      if (questions[e.questionIndex].type === "checkbox") {
        if (questions[e.questionIndex].multi) {
          if (e.indexSecond >= 0) {
            if (questions[e.questionIndex].questions[e.index].multi) {
              if (
                questions[e.questionIndex].questions[e.index].subItems[
                  e.indexSecond
                ].answer
              ) {
                questions[e.questionIndex].questions[e.index].subItems[
                  e.indexSecond
                ].answer = "";
              } else {
                questions[e.questionIndex].questions[e.index].subItems[
                  e.indexSecond
                ].answer = e.value;
              }
            } else {
              // if(questions[e.questionIndex].questions[e.index].subAnswer){
              //     questions[e.questionIndex].questions[e.index].subAnswer = "";
              //     questions[e.questionIndex].questions[e.index].subAnswer = e.value;
              // } else {
              questions[e.questionIndex].questions[e.index].subAnswer = e.value;
              // }
            }
          } else {
            if (questions[e.questionIndex].questions[e.index].answer) {
              questions[e.questionIndex].questions[e.index].answer = "";
              questions[e.questionIndex].questions[
                e.index
              ].showSubItems = false;
              questions[e.questionIndex].questions[e.index].subAnswer = "";
              questions[e.questionIndex].questions[e.index].subItems &&
                questions[e.questionIndex].questions[e.index].subItems.map(
                  (item) => (item.answer = "")
                );
            } else {
              questions[e.questionIndex].questions[e.index].answer = e.value;
              if (
                questions[e.questionIndex].questions[e.index].subItems &&
                questions[e.questionIndex].questions[e.index].subItems[0]
              ) {
                questions[e.questionIndex].questions[
                  e.index
                ].showSubItems = true;
              }
              // Also check if subItems3 should be shown
              if (
                questions[e.questionIndex].questions[e.index].subItems3 &&
                questions[e.questionIndex].questions[e.index].subItems3[0]
              ) {
                questions[e.questionIndex].questions[e.index].showSubItems3 = true;
              }
            }
          }
          if (questions[e.questionIndex].partial) {
            for (let option of questions[e.questionIndex].questions) {
              if (questions[e.questionIndex].questions[e.index].partialField) {
                if (!option.partialField) {
                  option.answer = "";
                  if (option.subItems) {
                    option.subAnswer = "";
                    option.showSubItems = false;
                    if (option.text1) {
                      option.text1 = "";
                    }
                  }
                }
              } else {
                if (option.partialField) {
                  option.answer = "";
                  if (option.subItems) {
                    option.subAnswer = "";
                    option.showSubItems = false;
                  }
                }
              }
            }
          }
        } else {
          if (e.indexSecond >= 0) {
            if (questions[e.questionIndex].questions[e.index].multi) {
              if (
                questions[e.questionIndex].questions[e.index].subItems[
                  e.indexSecond
                ].answer
              ) {
                questions[e.questionIndex].questions[e.index].subItems[
                  e.indexSecond
                ].answer = "";
              } else {
                questions[e.questionIndex].questions[e.index].subItems[
                  e.indexSecond
                ].answer = e.value;
              }
            } else {
              // if(questions[e.questionIndex].questions[e.index].subAnswer){
              //     questions[e.questionIndex].questions[e.index].subAnswer = "";
              // } else {
              questions[e.questionIndex].questions[e.index].subAnswer = e.value;
              // }
            }
          } else {
            questions[e.questionIndex].answer = e.value;
            for (const [i, question] of Object.values(
              questions[e.questionIndex].questions
            ).entries()) {
              if (e.index === i) {
              } else {
                if (question.showSubItems) {
                  question.showSubItems = false;
                  question.subAnswer = "";
                  question.subItems.map((item) => (item.answer = ""));
                  if(question.text1) question.text1 = ""
                }
              }
            }
            if (
              questions[e.questionIndex].questions[e.index].subItems &&
              questions[e.questionIndex].questions[e.index].subItems[0]
            ) {
              questions[e.questionIndex].questions[e.index].showSubItems = true;
            }
            // Also check if subItems3 should be shown
            if (
              questions[e.questionIndex].questions[e.index].subItems3 &&
              questions[e.questionIndex].questions[e.index].subItems3[0]
            ) {
              questions[e.questionIndex].questions[e.index].showSubItems3 = true;
            }
          }
        }
      }

      if (questions[e.questionIndex].type === "select") {
        const selectQuestion = questions[e.questionIndex].questions[e.index];
        selectQuestion.options[e.indexSecond].answer = e.value;
        clearInvalidDependentSelectAnswers(selectQuestion, e.indexSecond);
      }

      if (questions[e.questionIndex].type === "calendar") {
        questions[e.questionIndex].questions[e.index].options[
          e.indexSecond
        ].answer = e.value;
        if (
          e.index === 0 &&
          questions[e.questionIndex].questions[e.index + 1].day
        ) {
          let values = [];
          let limit = 0;
          let month = e.value;
          if (
            month === "September" ||
            month === "April" ||
            month === "June" ||
            month === "November"
          ) {
            limit = 30;
          } else if (
            month === "January" ||
            month === "March" ||
            month === "May" ||
            month === "July" ||
            month === "August" ||
            month === "October" ||
            month === "December"
          ) {
            limit = 31;
          } else {
            limit = 28;
          }
          for (let i = 1; i <= limit; i++) {
            values.push(i.toString());
          }
          questions[e.questionIndex].questions[e.index + 1].options[0].values =
            values;
          questions[e.questionIndex].questions[e.index + 1].options[0].answer =
            values[values.length - 1];
        }
      }

      if (
        questions[e.questionIndex].type === "textarea" ||
        questions[e.questionIndex].type === "yesno"
      ) {
        if (questions[e.questionIndex].type === "textarea" && e.field) {
          questions[e.questionIndex][e.field] = e.value;
          if (e.field === "diagnosisRemarksPrefillSelection") {
            syncDiagnosisRemarksPrefillSelection(questions[e.questionIndex]);
          }
          if (e.dropdownTextField) {
            syncDropdownTextFieldValue(
              questions[e.questionIndex],
              e.dropdownTextField
            );
          }
        } else {
        // if (questions && e.questionIndex < questions.length -1 && questions[e.questionIndex].answer && questions[e.questionIndex].answer.length>0) {
        //     console.log("if")
        //     // questions[e.questionIndex].maxLength = 340
        //     if (questions[e.questionIndex].answer.length<=questions[e.questionIndex].maxLength) {
        //         questions[e.questionIndex].answer = e.value;
        //     }
        //     if (questions[e.questionIndex].answer.length>questions[e.questionIndex].maxLength) {
        //         questions[e.questionIndex].answer = e.value.substring(0, e.value.length-1)
        //     }
        // } else if (questions && e.questionIndex === questions.length -1 && questions[e.questionIndex].maxLength) {
        //     console.log("else - if")
        //     // this condition to enable char count on remarks of mental and ptsd
        //     if (questions[e.questionIndex].answer.length<=questions[e.questionIndex].maxLength) {
        //         questions[e.questionIndex].answer = e.value;
        //     }
        //     if (questions[e.questionIndex].answer.length>questions[e.questionIndex].maxLength) {
        //         questions[e.questionIndex].answer = e.value.substring(0, e.value.length-1)
        //     }
        // }
        if (
          questions &&
          e.questionIndex &&
          questions[e.questionIndex].maxLength
        ) {
          if (
            questions[e.questionIndex].answer.length <
            questions[e.questionIndex].maxLength
          ) {
            questions[e.questionIndex].answer = e.value;
          } else {
            questions[e.questionIndex].answer = e.value.substring(
              0,
              questions[e.questionIndex].maxLength
            );
          }
        } else {
          console.log("else");
          questions[e.questionIndex].answer = e.value;
        }
        }
        if (questions[e.questionIndex].type === "yesno") {
          const textareaPresidence = getTextareaPresidence(
            questions[e.questionIndex]
          );
          const shouldShowTextarea =
            questions[e.questionIndex].answer === textareaPresidence &&
            questions[e.questionIndex].istext;
          questions[e.questionIndex].textarea =
            shouldShowTextarea ? true : false;
          if (questions[e.questionIndex].ref) {
            for (let i = 1; i <= questions[e.questionIndex].ref; i++) {
              questions[e.questionIndex + i].show =
                questions[e.questionIndex].answer !==
                questions[e.questionIndex].presidence
                  ? false
                  : true;
            }
          }
          if (
            shouldShowTextarea &&
            questions[e.questionIndex].textarea
          ) {
            if (
              !e.textValue &&
              questions[e.questionIndex].textanswer &&
              questions[e.questionIndex].textanswer.length > 1
            ) {
              questions[e.questionIndex].textanswer =
                questions[e.questionIndex].textanswer;
            } else {
              //questions[e.questionIndex].textanswer = e.textValue;
              // commented above line and changed it below code to show max length if sent
              // questions[e.questionIndex].maxLength ? questions[e.questionIndex].maxLength : 340
              if (
                questions[e.questionIndex].maxLength &&
                questions[e.questionIndex].textanswer &&
                questions[e.questionIndex].textanswer.length > 0
              ) {
                if (
                  questions[e.questionIndex].textanswer.length <
                  questions[e.questionIndex].maxLength
                ) {
                  questions[e.questionIndex].textanswer = e.textValue;
                } else {
                  questions[e.questionIndex].textanswer = e.textValue.substring(
                    0,
                    questions[e.questionIndex].maxLength
                  );
                }
              } else {
                questions[e.questionIndex].textanswer = e.textValue;
              }
            }
          } else {
            if (questions[e.questionIndex].istext) {
              questions[e.questionIndex].textanswer = "";
            }
            if(questions[e.questionIndex].answer !== questions[e.questionIndex].presidence && questions[e.questionIndex].ref > 0) {
              // if the object has multiple levels, this won't work perfectly
              for (let i=1; i<=questions[e.questionIndex].ref; i++) {
                const nextObject = questions[e.questionIndex+i]
                for (let key in nextObject) {
                  if (key === "answer") {
                    questions[e.questionIndex+i][key] = ""
                  }
                }
              }
            }

            const answerConsistencyValidation = validateAnswerConsistency(
              questions,
              questions[e.questionIndex]
            );
            if (answerConsistencyValidation) {
              this.validationErrorMessage = answerConsistencyValidation.message;
              questions = sanitizeBlockedResponses(questions);
              questions = syncClonedSelectAnswers(questions);
              questions = syncControlledSelectQuestions(questions);
              questions = syncConditionalTextQuestions(questions);
              this.setState({ questions: questions }, this.showError);
              return;
            }

            if (this.state.page === "review") {
              if (questions[e.questionIndex].textanswer) {
                questions[e.questionIndex].textanswer = "";
              }
              this.goToReview();
            } else {
              this.next();
            }
          }
        }
      }

      if (questions[e.questionIndex].type === "yesnoouter") {
        questions[e.questionIndex].answer = e.value;
        if (questions[e.questionIndex].outer_ref) {
          for (let i = 1; i <= questions[e.questionIndex].outer_ref; i++) {
            questions[e.questionIndex + i].show =
              questions[e.questionIndex].answer !==
              questions[e.questionIndex].presidence
                ? false
                : true;
          }
        }
        if (this.state.page === "review") {
          this.goToReview();
        } else {
          this.next();
        }
      }
    }
    questions = sanitizeBlockedResponses(questions);
    questions = syncClonedSelectAnswers(questions);
    questions = syncControlledSelectQuestions(questions);
    questions = syncConditionalTextQuestions(questions);
    this.setState({ questions: questions });
    console.log(
      "========================= > ",
      questions[e.questionIndex].srcMap
    );
    (questions[e.questionIndex].hasOwnProperty("srcMap") ||
      questions[e.questionIndex].hasOwnProperty("srcMapYes") ||
      questions[e.questionIndex].hasOwnProperty("srcMapNo")) &&
      this.checkMapping(e);
  };

  // majorly for HIV logic
  checkMapping = (e) => {
    console.log("eeeee ", e);
    const { questions } = this.state;
    let srcMap,
      srcMapAnswer = "";
    let isUnselect = false;

    //############## HIV symptoms logic
    if (this.state.currentDbq.name.toLowerCase() === "hiv") {
      if (questions[e.questionIndex].type === "yesno") {
        srcMap = questions[e.questionIndex].srcMap;
        srcMapAnswer = questions[e.questionIndex].srcMapAnswer;
        isUnselect = questions[e.questionIndex].answer === "Yes";
        for (let question of questions) {
          if (question.destMap === srcMap) {
            if (question.type === "radioTiles") {
              for (let q of question.questions) {
                if (q.destMapAnswer === srcMapAnswer) {
                  q.answer = isUnselect ? q.main : "";
                  q.isLinked = isUnselect;
                  break;
                }
              }
            }
            // other types will be here in future
            break;
          }
        }
      }
      if (questions[e.questionIndex].type === "radioTiles") {
        srcMap = questions[e.questionIndex].srcMap;
        let srcMapAnswers = [];
        let srcMapAnswersAll = [];
        let options = questions[e.questionIndex].questions;

        for (let option of options) {
          if (questions[e.questionIndex].multi) {
            if (!srcMapAnswersAll.includes(option.srcMapAnswer)) {
              srcMapAnswersAll.push(option.srcMapAnswer);
            }
            if (option.srcMapAnswer && option.main === option.answer) {
              if (!srcMapAnswers.includes(option.srcMapAnswer)) {
                srcMapAnswers.push(option.srcMapAnswer);
              }
            }
          } else {
            // If radioTiles with multi false
          }
        }
        console.log("srcMapAnswers: ", srcMapAnswers);

        if (srcMapAnswersAll && srcMapAnswersAll.length > 0) {
          for (let question of questions) {
            if (question.destMap === srcMap) {
              if (question.type === "radioTiles") {
                for (let q of question.questions) {
                  if (q.destMapAnswer) {
                    if (srcMapAnswers.includes(q.destMapAnswer)) {
                      q.answer = q.main;
                      q.isLinked = true;
                    } else {
                      if (srcMapAnswersAll.includes(q.destMapAnswer)) {
                        q.answer = "";
                        q.isLinked = false;
                      }
                    }
                  }
                }
              }
              break;
            }
          }
        }
      }
      if (questions[e.questionIndex].type === "radioModal") {
        srcMap = questions[e.questionIndex].srcMap;
        if (e.indexSecond >= 0 && !e.field) {
          for (let subItem of questions[e.questionIndex].questions[e.index]
            .subItems) {
            if (subItem.srcMapAnswer) {
              if (questions[e.questionIndex].questions[e.index].multi) {
                // if subItems allow multiple
              } else {
                let subAnswer =
                  questions[e.questionIndex].questions[e.index].subAnswer;
                for (let question of questions) {
                  if (question.destMap === srcMap) {
                    if (question.type === "radioTiles") {
                      for (let q of question.questions) {
                        if (q.destMapAnswer === subItem.srcMapAnswer) {
                          q.answer = subAnswer === subItem.main ? q.main : "";
                          q.isLinked = subAnswer === subItem.main;
                        }
                      }
                    }
                    break;
                  }
                }
              }
            }
          }
        } else {
          // outer questions
        }
      }
    }

    //############## Back DBQ radiculopathy question for nerve root
    if (
      this.state.currentDbq.name.toLowerCase() === "back disabilities" &&
      questions[e.questionIndex].srcMap === "radiculopathy1"
    ) {
      let isNone = true;
      for (let question of questions) {
        if (question.srcMap && question.srcMap === "radiculopathy1") {
          console.log("Found question with srcMap=radiclupathy");
          for (let ques of question.questions) {
            if (ques.answer !== "None") {
              isNone = false;
              console.log("Done and going to break inner");
              break;
            }
          }
        }
        if (!isNone) {
          console.log("Done and going to break outer");
          break;
        }
      }
      for (let question of questions) {
        if (question.destMap && question.destMap === "radiculopathy1") {
          console.log("radiculopathy1 dest Map");

          console.log(
            "found the option ",
            question.questions[question.questions.length - 1]
          );
          question.questions[question.questions.length - 1].answer = !isNone
            ? ""
            : "N/A";
        }
      }
    }

    this.setState({ questions: questions });

    // for (let question of questions) {
    //   if (question.destMap === currentQuestion.srcMap) {
    //     console.log("question destMap: ", question.question);
    //   }
    // }
  };

  playVideoOverlay = (url, value) => {
    this.setState({
      isPlayingVideo: true,
      videoUrl: url,
      videoValue: value,
    });
  };

  closeVideoView = (e) => {
    if (e.side === "left") {
      this.setState({
        videoFirstColumn: false,
        selectedVideo: "",
        selectedValue: "",
      });
    } else {
      this.setState({
        videoSecondColumn: false,
        selectedVideo: "",
        selectedValue: "",
      });
    }
  };
  handleShowQuestion = (e) => {
    e.show && this.setState({ current: e.index });
  };
  checkFieldValue = (index) => {
    let { questions, flag = true } = this.state;
    this.validationErrorMessage = "";
    questions = syncClonedSelectAnswers(questions);
    questions = syncControlledSelectQuestions(questions);
    questions = syncConditionalTextQuestions(questions);
    if (questions && questions.length > 0 && (index === 0 || index)) {
      if (
        questions[index].type === "text" ||
        questions[index].type === "radio"
      ) {
        if (questions[index].type === "text" && questions[index].optional) {
          return true;
        }
        const itemsToValidate =
          questions[index].type === "text"
            ? getVisibleTextItems(questions[index])
            : getVisibleExamItems(questions[index].questions);
        itemsToValidate.forEach((item, i) => {
          if (item.optional) {
            return;
          }
          flag = item.answer && flag ? true : false;
        });
        if (
          questions[index].type === "radio" &&
          (questions[index].refValue === "Right" ||
            questions[index].refValue === "Left")
        ) {
          if (questions[index].refValue === "Right") {
            getVisibleExamItems(questions[index].questions).forEach((item, i) => {
              if (item.right) {
                flag = item.answer ? true : false;
              }
            });
          }
          if (questions[index].refValue === "Left") {
            getVisibleExamItems(questions[index].questions).forEach((item, i) => {
              if (!item.right) {
                flag = item.answer ? true : false;
              }
            });
          }
        }
      }

      if (questions[index].type === "radioTiles") {
        if (questions[index].required) {
          const selectedOptions = questions[index].questions.filter(
            (item) => item.answer !== ""
          );
          flag = selectedOptions.length > 0 && flag ? true : false;
        }
        return flag;
        // if (questions[index].optional) {
        //   return true;
        // }
        // if (questions[index].textarea) {
        //   if (questions[index].multi) {
        //     let result = questions[index].questions.filter(
        //       (item) => item.answer !== "" && item.textAnswer !== ""
        //     );
        //     flag = result && result[0] ? true : false;
        //   } else {
        //     flag = questions[index].textAnswer && flag ? true : false;
        //   }
        // } else {
        //   if (questions[index].multi) {
        //     let result = questions[index].questions.filter(
        //       (item) => item.answer !== ""
        //     );
        //     flag = result && result[0] ? true : false;
        //     let result1 = questions[index].questions.filter(
        //       (item) =>
        //         (item.answer === item.dbqName && !item.textarea) ||
        //         (item.textarea && item.textAnswer !== "")
        //     );
        //     flag = result1 && result1[0] && flag ? true : false;
        //     // minimum answers are required
        //     if (questions[index].minRequiredAns) {
        //       flag =
        //         result && result.length >= questions[index].minRequiredAns
        //           ? true
        //           : false;
        //     }
        //   } else {
        //     flag = questions[index].answer && flag ? true : false;
        //     let result1 = questions[index].questions.filter(
        //       (item) =>
        //         (questions[index].answer === item.dbqName && !item.textarea) ||
        //         (item.textarea && questions[index].textAnswer !== "")
        //     );
        //     flag = result1 && result1[0] && flag ? true : false;
        //   }
        // }
      }

      if (questions[index].type === "checkbox") {
        if (questions[index].multi) {
          let result = questions[index].questions.filter(
            (item) => item.answer !== ""
          );
          flag = result && result[0] ? true : false;
          questions[index].questions.map((obj) => {
            if (obj.showSubItems) {
              if (obj.multi) {
                let resultObj = obj.subItems.filter(
                  (item) => item.answer !== ""
                );
                flag = resultObj && resultObj[0] && flag ? true : false;
              } else {
                flag = obj.subAnswer && flag ? true : false;
              }
              if (obj.hasOwnProperty("text1")) {
                flag = obj.text1.length > 0 && flag ? true : false;
              }
            }
          });
        } else {
          flag = questions[index].answer && flag ? true : false;
          questions[index].questions.map((obj) => {
            if (obj.showSubItems) {
              if (obj.multi) {
                let result = obj.subItems.filter((item) => item.answer !== "");
                flag = result && result[0] && flag ? true : false;
              } else {
                flag = obj.subAnswer && flag ? true : false;
              }
              if (obj.hasOwnProperty("text1")) {
                flag = obj.text1.length > 0 && flag ? true : false;
              }
            }
          });
        }
      }

      if (questions[index].type === "radioModal") {
        if (questions[index].optional) {
          return true;
        }

        if (!questions[index].useAnswerValueRulesForRequiredSelection) {
          const visibleItems = getVisibleExamItems(
            questions[index].questions
          );
          if (questions[index].multi) {
            flag = questions[index].requireAll
              ? visibleItems.every((item) => item.answer !== "")
              : visibleItems.some((item) => item.answer !== "");
            visibleItems.map((obj) => {
              if (obj.showSubItems) {
                if (obj.multi) {
                  let resultObj = obj.subItems.filter(
                    (item) => item.answer !== ""
                  );
                  flag = resultObj && resultObj[0] && flag ? true : false;
                } else {
                  flag = obj.subAnswer && flag ? true : false;
                }
              }
            });
          } else {
            flag = questions[index].answer && flag ? true : false;
            visibleItems.map((obj) => {
              if (obj.showSubItems) {
                if (obj.multi) {
                  let result = obj.subItems.filter((item) => item.answer !== "");
                  flag = result && result[0] && flag ? true : false;
                } else {
                  flag = obj.subAnswer && flag ? true : false;
                }
              }
            });
          }
        }
      }

      if (questions[index].type === "scarsLoad") {
        if (questions[index].questions.answer === "Not affected") {
          questions[index + 1].show = false;
          flag = true;
        } else {
          questions[index + 1].show = true;
          if (
            questions[index].questions.text1 &&
            questions[index].questions.text1.length > 0
          ) {
            flag = true;
            for (let scar of questions[index].questions.scars) {
              if (scar.answerLength === "" || scar.answerWidth === "") {
                flag = false;
              }
            }
          } else {
            flag = false;
          }
        }

        if (
          questions[index + 1] &&
          questions[index + 1].type === "scarQuestions"
        ) {
          syncScarQuestionSummary(
            questions[index + 1],
            questions[index].questions.scars
          );
        }
      }

      if (questions[index].type === "scarQuestions") {
        const scarsLoadQuestion = questions[index - questions[index].scarsIndex];
        syncScarQuestionSummary(
          questions[index],
          scarsLoadQuestion && scarsLoadQuestion.questions.scars
        );
      }

      if (questions[index].type === "disfigurementLoad") {
        for (let scar of questions[index].questions.scars) {
          if (
            scar.answerLength === "" ||
            scar.answerWidth === "" ||
            scar.text1 === ""
          ) {
            flag = false;
          }
        }
      }

      if (questions[index].type === "select") {
        if (isCloneOnlySelectQuestion(questions[index])) {
          return true;
        }

        questions[index].questions.forEach((question) => {
          question.options.forEach((item, i) => {
            if (item.values) {
              const availableValues = getSelectOptionValues(question, item);
              flag =
                hasSelectAnswer(item.answer) &&
                availableValues.map(String).indexOf(String(item.answer)) !== -1 &&
                flag
                  ? true
                  : false;
            }
          });
        });
      }

      if (questions[index].type === "calendar") {
        questions[index].questions.forEach((question) => {
          question.options.forEach((item, i) => {
            if (item.values) {
              flag = item.answer && flag ? true : false;
            }
          });
        });
      }

      if (
        questions[index].type === "textarea" ||
        questions[index].type === "yesno"
      ) {
        flag =
          questions[index].optional || questions[index].answer ? true : false;
        if (
          questions[index].type === "yesno" &&
          questions[index].istext &&
          questions[index].answer === getTextareaPresidence(questions[index]) &&
          questions[index].textarea === true
        ) {
          flag = questions[index].textanswer ? true : false;
        }

        // if(questions[index].type === "yesno"
        // && questions[index].istext
        // && (!questions[index].textanswer)) {
        //     this._addNotification("Please enter a description", 'error', 'Error Message: ');
        // }
      }
      if(questions[index].type === "yesnoouter"){
        if(questions[index].notOptional){
          flag = questions[index].answer === "" ? false : true;
        }
      }

      const linkedSelectionValidation = validateLinkedSelectionDependency(
        questions,
        questions[index]
      );
      if (linkedSelectionValidation) {
        this.validationErrorMessage = linkedSelectionValidation.message;
        return false;
      }

      const answerValueValidation = validateAnswerValueRules(questions[index]);
      if (answerValueValidation) {
        this.validationErrorMessage = answerValueValidation.message;
        return false;
      }

      const dropdownTextFieldValidation = validateDropdownTextFields(
        questions[index]
      );
      if (dropdownTextFieldValidation) {
        this.validationErrorMessage = dropdownTextFieldValidation;
        return false;
      }

      const answerConsistencyValidation = validateAnswerConsistency(
        questions,
        questions[index]
      );
      if (answerConsistencyValidation) {
        this.validationErrorMessage = answerConsistencyValidation.message;
        return false;
      }

      const crossQuestionValueValidation = validateCrossQuestionValues(
        questions,
        questions[index]
      );
      if (crossQuestionValueValidation) {
        this.validationErrorMessage = crossQuestionValueValidation.message;
        return false;
      }

      const addedDiagnosisRemarksValidation =
        validateRequiredRemarksForAddedDiagnoses({
          question: questions[index],
          questions,
        });
      if (addedDiagnosisRemarksValidation) {
        this.validationErrorMessage = addedDiagnosisRemarksValidation.message;
        return false;
      }

      markDiagnosisRemarksCompleted(questions, questions[index]);
    }
    return flag;
  };

  actions = (link, disbaility) => {
    const { history, location } = this.props;
    const { questions, current, totalQuestion, currentDbq } = this.state;
    let patient = JSON.parse(sessionStorage.getItem("patient"));

    let token = localStorage.getItem("login_token");
    let headers = { "Content-Type": "application/json" };
    headers["Authorization"] = `Bearer ${token}`;
    let url = process.env.API_URL + "/patients/" + patient.id;
    let method = "PUT";

    let body = {
      id: patient.id,
      dbq: currentDbq.name,
      questions: questions,
      ssn: patient.ssn ? patient.ssn : null,
      diagnosesAndExtremities: this.state.diagnosesAndExtremities,
      status: "exam",
      patientName: patient.name,
      dbqId: currentDbq.id,
      apptId: patient.apptId,
    };

    fetch(url, { method: method, body: JSON.stringify(body), headers })
      .then((response) => response.json())
      .then((data) => {
        history.push({
          pathname: link,
          currentDbq: this.state.currentDbq,
          patient: this.state.patient,
          questionState: this.state.questions,
        });
      })
      .catch((err) => {
        this.setState({ fetching: false });
        console.error(err);
      });
  };

  goBack = (link) => {
    const { history, location } = this.props;
    history.push({
      pathname: link,
      state: this.state.disabilityState,
      patient: location.patient,
    });
  };

  redirectToDiagnosisRemarksIfNeeded = (questions) => {
    if (this.state.page !== "review") {
      return false;
    }

    const diagnosisRemarksSync =
      syncDiagnosisRemarksForAddedDiagnoses(questions);

    if (
      !diagnosisRemarksSync.shouldCompleteRemarks ||
      diagnosisRemarksSync.remarksIndex < 0
    ) {
      return false;
    }

    const diagnosisNames = diagnosisRemarksSync.addedDiagnoses.map(
      (diagnosis) => diagnosis.name
    );
    let message = "Please update the additional remarks before completing the review.";
    if (diagnosisNames.length) {
      message = `Diagnosis selections changed during review. Please update the diagnosis remarks for: ${diagnosisNames.join(
        ", "
      )}.`;
    } else if (diagnosisRemarksSync.additionalRemarksLabels.length) {
      message = `Exam selections changed during review. Please update the additional remarks for: ${diagnosisRemarksSync.additionalRemarksLabels.join(
        ", "
      )}.`;
    }

    sessionStorage.setItem(
      "questionState",
      JSON.stringify(diagnosisRemarksSync.questions)
    );
    sessionStorage.setItem(
      "current",
      diagnosisRemarksSync.remarksIndex.toString()
    );

    this.setState(
      {
        questions: diagnosisRemarksSync.questions,
        current: diagnosisRemarksSync.remarksIndex,
        yesnoRef: 0,
        yesnoRefOuter: 0,
      },
      () => this._addNotification(message)
    );

    return true;
  };

  goToReview = () => {
    let { questions, current, totalQuestion } = this.state;
    questions = syncClonedSelectAnswers(questions);
    questions = syncControlledSelectQuestions(questions);
    questions = syncConditionalTextQuestions(questions);
    const { history, location } = this.props;
    let { yesnoRef, yesnoRefOuter } = this.state;
    let scarRef = 1;
    let skip = 1;
    let count = yesnoRefOuter > 0 ? yesnoRefOuter : yesnoRef > 0 ? yesnoRef : 1;

    if (questions[current].type === "yesnoouter" && questions[current].answer) {
      if (questions[current].answer !== questions[current].presidence) {
        // this.setState({yesnoRefOuter: questions[current].outer_ref})
        // yesnoRefOuter = questions[current].outer_ref
        //} else {
        count = 0;
      }
    }

    if (
      questions[current].type === "yesno" &&
      questions[current].answer &&
      questions[current].ref > 0
    ) {
      //yesnocurrent = questions[current].answer === questions[current].presidence ? 0 : questions[current].ref;
      if (questions[current].answer !== questions[current].presidence) {
        // this.setState({yesnoRef: questions[current].ref})
        // yesnoRef = questions[current].ref;
        //count =1
        // } else {
        if (yesnoRefOuter > 0) {
          // if it is inside an outer yes/no and answer is not matching then we will just skip outer steps
          yesnoRefOuter = yesnoRefOuter - questions[current].ref;
          if (yesnoRefOuter === 0) {
            count = 0;
          }
          skip = questions[current].ref + 1;
        } else {
          // if not in outer yes/no and answer is not matching with presidence so immediately redirecting to review page
          count = 0;
        }
      }
    }
    if (
      questions[current].type === "scarsLoad" &&
      questions[current].questions.answer
    ) {
      if (questions[current].questions.answer === "Not affected") {
        skip += 1;
        yesnoRef -= 1;
        if (yesnoRef === 0) {
          count = 0;
        }
      }
    }
    // added again for Prostate Cancer Specific logic
    if (
      questions[totalQuestion - 1] &&
      questions[totalQuestion - 1].optional &&
      questions[totalQuestion - 1].checkQuestion
    ) {
      if (
        questions[questions[totalQuestion - 1].checkQuestion].answer === "Yes"
      ) {
        if (!questions[totalQuestion - 1].answer.includes("see Kidney DBQ")) {
          questions[totalQuestion - 1].answer =
            questions[totalQuestion - 1].answer;
        }
      } else {
        if (questions[totalQuestion - 1].answer.includes("see Kidney DBQ")) {
          questions[totalQuestion - 1].answer = questions[
            totalQuestion - 1
          ].answer.replace("Please see Kidney DBQ.", "");
        }
      }
    }

    console.log("yesnoRefOuter: ", this.state.yesnoRefOuter);
    console.log("yesnoRef: ", yesnoRef);
    // console.log("scarRef: ", scarRef)
    console.log("count: ", count);
    console.log("skip: ", skip);
    console.log("current: ", current);

    if (this.state.yesnoRefOuter === 0 && this.state.yesnoRef === 0) {
      count = 0;
    }
    if (count > 0) {
      sessionStorage.setItem(
        "questionState",
        JSON.stringify(questions)
      );
      this.setState({
        questions,
        current: current + skip,
        yesnoRef: yesnoRef > 0 ? yesnoRef - 1 : 0,
        yesnoRefOuter: yesnoRefOuter > 0 ? yesnoRefOuter - 1 : 0,
      });
      //this.setState({ current: current+yesnoRef+1, yesnoRef: yesnoRef>0? yesnoRef - scarRef: 0, yesnoRefOuter: yesnoRefOuter>0 ? yesnoRefOuter - 1 : 0 });
    } else {
      if (this.redirectToDiagnosisRemarksIfNeeded(questions)) {
        return;
      }

      questions = applyFinalAnswerDefaults(questions);
      this.setState({ questions }, () => {
        sessionStorage.setItem("questionState", JSON.stringify(questions));
        sessionStorage.removeItem("page");
        sessionStorage.removeItem("current");

        history.push({
          pathname: "/admin/review",
          currentDbq: this.state.currentDbq,
          patient: this.state.patient,
          questionState: questions,
        });
      });
    }
  };

  calculateLeftScroll = (currentRects, count) => {
    return count ? currentRects.width * count : currentRects.width;
  };

  getStepperClientRects = () => {
    const stepperRects = this.stepperRef.getClientRects().item(0);
    const visibleCurrentIndex = this.state.questions
      .slice(0, this.state.current + 1)
      .filter(isExamItemVisible).length - 1;
    const currentRects = [...this.stepperRef.children][
      visibleCurrentIndex
    ].getClientRects().item(0);

    return { stepperRects, currentRects };
  };

  next = () => {
    let yesnocurrent = 0;
    this.setState({
      errorMessage: "",
      errorMessageSub: ""
    })

    let { questions, current, totalQuestion, currentDbq, patient } =
      this.state;
    questions = syncClonedSelectAnswers(questions);
    questions = syncControlledSelectQuestions(questions);
    questions = syncConditionalTextQuestions(questions);

    if (
      questions[current].type === "yesno" &&
      questions[current].answer &&
      questions[current].ref > 0
    ) {
      yesnocurrent =
        questions[current].answer === questions[current].presidence
          ? 0
          : questions[current].ref;
      console.log("Inside yesno => yesnocurrent", yesnocurrent);
    }

    if (
      questions[current].type === "checkbox" && questions[current].skipIfAnswer === "Symptoms wax and wane" && questions[current].skipIfAnswer === questions[current].answer
    ) {
      yesnocurrent = questions[current].skip;

      for (let i = 1; i <= yesnocurrent; i++) {
        questions[current + i].show = false;
      }
    }

    // this is for skin exam
    if(questions[current].type === "yesno" && questions[current].dbqName_yes === "F[0].Page_5[0].Papa[0]") {

      let showQuestion4B = false

      for(let i = 0; i < questions[current-1].questions.length; i++) {
        if(questions[current-1].questions[i].subAnswer !== "" && questions[current-1].questions[i].subAnswer !== "None") {
          showQuestion4B = true
          break
        }
        if(questions[current-1].questions[i].subAnswer2 !== "" && questions[current-1].questions[i].subAnswer2 !== "None") {
          showQuestion4B = true
          break
        }
      }
      
      if(!showQuestion4B) {
        yesnocurrent = 1
        questions[current+1].show = false
      } else {
        questions[current+1].show = true
      }                  
    }

    if (questions[current].type === "yesnoouter" && questions[current].answer) {
      yesnocurrent =
        questions[current].answer === questions[current].presidence
          ? 0
          : questions[current].outer_ref;
    }

    //##################################################
    if (
      questions[current].type === "scarsLoad" &&
      questions[current].questions.answer
    ) {
      yesnocurrent = questions[current].questions.answer === "Affected" ? 0 : 1;
    }

    // SPECIFIC TO SECTION 14D OF THE FOOT EXAM
    if (questions[current].identifier === "functional-loss-from-pain") {
      // locate the "No" option in the array of questions
      let noneOption = questions[current].questions.find(question => question.subIdentifier === "noneSelected")
      if (noneOption) {
        // If found, check if the user selected that option
        let numberOfQuestionsToSkip = noneOption.skip || 1
        if (noneOption.answer === "No") {
            //User selected "No", skip next question 
            yesnocurrent = numberOfQuestionsToSkip // skip the next question
            questions[current+numberOfQuestionsToSkip].show = false
        } else {
          // If user previously selected "No" but changes their answer, we'll display the next question
          questions[current+numberOfQuestionsToSkip].show = true
        }
      }
    }  

    /* --- 6B/6C KNEE --- */
    if (questions[current].identifier === "knee-ligament-skip") {
      const { skipRef, nextQuestions } =  kneeLigamentSkip(questions[current].questions, questions[current + 1].questions) 
      yesnocurrent = skipRef
      questions[current + 1].questions = nextQuestions
    }

    /* CURRENTLY SHOULDER EXAM SPECIFIC */
    if (questions[current].type === "radio" && questions[current].extremityIndependent && questions[current].prevExtemityRef >= 0 && questions[current + 1].type === "yesno") {

      let prevRef = questions[current].prevExtemityRef
      let showRight = false
      let showLeft = false
      questions[current + 1].showNext = true

      for (let i = current - prevRef; i <= current; i++) {
        
        if (showRight && showLeft ) { break }

        let rightShoulderAnswer = questions[i].questions[0].answer
        let leftShoulderAnswer = questions[i].questions[1].answer

        if ( rightShoulderAnswer === "Unable to test" ) { showRight = true }
        if ( leftShoulderAnswer === "Unable to test" ) {showLeft = true } 
      }

      if ( !showRight && !showLeft ) { 
        yesnocurrent = 2 //Skips following right/left shoulder questions
      } else if ( !showRight && showLeft ) {
        yesnocurrent = 1 //Skips following right shoulder question
      } else if ( showRight && !showLeft ) {
        questions[current + 1].showNext = false //We cannot skip left and show right from the above logic so the flag is set
      }

    }

    if (questions[current].type === "yesno" && questions[current].showNext === false) {
      yesnocurrent = 1 //Allows us to skip the left shoulder question based on the flag being set above
    }
    /* CURRENTLY SHOULDER EXAM SPECIFIC */

    let count = current + 1 + yesnocurrent;
    while (count < totalQuestion && questions[count].show === false) {
      count++;
    }

    console.log("yesnocurrent", yesnocurrent);
    console.log("count", count);

    if (count >= totalQuestion) {
      // below code is for Prostate cancer
      if (
        questions[totalQuestion - 1].optional &&
        questions[totalQuestion - 1].checkQuestion
      ) {
        if (
          questions[questions[totalQuestion - 1].checkQuestion].answer ===
            "Yes" &&
          !questions[totalQuestion - 1].answer.includes("see Kidney DBQ")
        ) {
          questions[totalQuestion - 1].answer =
            questions[totalQuestion - 1].answer;
        }
      }
      questions = applyFinalAnswerDefaults(questions);
      this.setState({ questions }, () => {
        sessionStorage.setItem("questionState", JSON.stringify(questions));
        sessionStorage.removeItem("current");
        this.actions("/admin/confirm-license", this.state);
      });
      return;
    } else {
      this.props.updatePatientDoc(
        patient && patient.id,
        patient.apptDate,
        currentDbq.name,
        currentDbq.name_fv,
        questions,
        patient.ssn ? patient.ssn : null,
        "exam",
        patient.name,
        currentDbq.id,
        patient.isPreviousVersion,
        patient.apptId,
        count - 1
      );
      this.setState({ questions, current: count });
      sessionStorage.setItem(
        "questionState",
        JSON.stringify(questions)
      );

      sessionStorage.setItem("current", count.toString());
    }

    window.focus();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    const { stepperRects, currentRects } = this.getStepperClientRects();
    const skippedQuestionCount = Math.max(count - current - 1, yesnocurrent);
    const scrollLeft = this.calculateLeftScroll(
      currentRects,
      skippedQuestionCount
    );

    if ((currentRects.right - stepperRects.left) > (stepperRects.width / 2))
      this.stepperRef.scrollBy({ left: scrollLeft, behavior: "smooth" });
  };

  back = () => {
    this.setState({
      errorMessage: "",
      errorMessageSub: ""
    })
    const { current, questions } = this.state;
    if (current === 0) {
      sessionStorage.removeItem("current");
      sessionStorage.removeItem("questionState");
      sessionStorage.removeItem("currentDbq");
      this.goBack("/admin/dashboard");
    } else {
      //let count = current && questions[current-1].show ? 1 : questions[current-1].refId + 1
      let count = 0;
      if (current && questions[current - 1].show) {
        count = 1;
      } else {
        for (let i = 1; i <= current; i++) {
          count = i;
          if (questions[current - i].show) {
            break;
          }
        }
      }
      console.log("BACK Count is: ", count);
      sessionStorage.setItem("current", (current - count).toString());
      this.setState({ current: current - count, errorFlag: false }); // remove error flag if you don't want to show error msg line on previous question

      const { stepperRects, currentRects } = this.getStepperClientRects();
      const scrollLeft = this.calculateLeftScroll(currentRects, count);

      if ((currentRects.left - stepperRects.right) < (stepperRects.width / 2))
        this.stepperRef.scrollBy({ left: -scrollLeft, behavior: "smooth" });
    }

    window.focus();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  showError = () => {
    const { questions, current, errorFlag } = this.state;
    const currentQuestion = questions[current];

    if (this.validationErrorMessage) {
        this._addNotification(this.validationErrorMessage);
    } else if (
        !errorFlag &&
        currentQuestion.type === "yesno" &&
        currentQuestion.istext &&
        currentQuestion.answer === getTextareaPresidence(currentQuestion) &&
        currentQuestion.textarea === true
    ) {
        if (!currentQuestion.textanswer) {
            this._addNotification("Please enter a description");
        }
    } else {
        let msg = "Please provide your answer before moving forward.";
        if (["radio", "radioTiles", "checkbox"].includes(currentQuestion.type)) {
            msg = "Please select from the provided options";
        }
        if (currentQuestion.type === "radioModal" && currentQuestion.requireAll) {
          msg = "Please select all required answers before proceeding."
        }
        this._addNotification(msg);
    }
};

  showUnansweredConfirmation = (current, action = "next") => {
    const { questions } = this.state;
    const confirmation = getQuestionConfirmation(questions[current]);
    this.setState({
      unansweredConfirmation: {
        questionIndex: current,
        action,
        title: confirmation.title,
        message: confirmation.message,
      },
    });
  };

  closeUnansweredConfirmation = () => {
    this.setState({ unansweredConfirmation: null });
  };

  confirmUnansweredQuestion = () => {
    const action =
      this.state.unansweredConfirmation &&
      this.state.unansweredConfirmation.action;

    this.setState({ unansweredConfirmation: null }, () => {
      if (action === "review") {
        this.goToReview();
        return;
      }

      this.next();
    });
  };

  shouldShowUnansweredConfirmation = (current) => {
    const { questions } = this.state;
    return !!getQuestionConfirmation(questions[current]);
  };

  nextBtn = (current) => {
    if (!this.checkFieldValue(current)) {
      this.showError();
      return;
    }

    if (this.shouldShowUnansweredConfirmation(current)) {
      this.showUnansweredConfirmation(current, "next");
      return;
    }

    this.next();
  };

  reviewDoneBtn = (current) => {
    if (!this.checkFieldValue(current)) {
      this.showError();
      return;
    }

    if (this.shouldShowUnansweredConfirmation(current)) {
      this.showUnansweredConfirmation(current, "review");
      return;
    }

    this.goToReview();
  };

  checkStepperQuestionsOverflow() {
    const questionWidth = this.stepperRef.children[0].offsetWidth;
    const { stepperRects } = this.getStepperClientRects();
    if ((questionWidth * this.stepperRef.children.length) > stepperRects.width) {
      this.stepperRef.classList.add("stepper-wrapper-overflow");
    }
  }

  componentDidMount() {
    let questions = this.getConditionalQuestions();
    sessionStorage.setItem("questionState", JSON.stringify(questions));
    questions && this.setState({ questions, totalQuestion: questions.length });
    this.checkStepperQuestionsOverflow();
    this._notificationSystem = this.refs.notificationSystem;
    document.addEventListener("mousedown", this.handleOutsideClick);
  }
  componentWillMount() {
    // this.unlisten = this.props.history.listen((location, action) => {
    //     let ans = window.confirm("on route change");
    //     alert(ans)
    // });
  }
  componentWillUnmount() {
    //const { questions, current, totalQuestion, currentDbq, patient} = this.state;
    // if (current < (totalQuestion-1)) {
    //this.props.updatePatientDoc(patient && patient.id, patient.apptDate, currentDbq.name, currentDbq.name_fv, questions, null, 'exam_pause', patient.name, currentDbq.id); // this "exam_pause" is just for single sugar call this will be converted to "exam"
    // }
    document.removeEventListener("mousedown", this.handleOutsideClick);
    const { questions, current, totalQuestion, currentDbq } = this.state;

    if (current > 1 && current < totalQuestion - 1) {
      let patient = JSON.parse(sessionStorage.getItem("patient"));
      let body = {
        id: patient.id,
        dbq: currentDbq.name,
        questions: questions,
        ssn: patient.ssn ? patient.ssn : null,
        status: "exam_paused",
        patientName: patient.name,
        dbqId: currentDbq.id,
        apptId: patient.apptId,
      };

      let token = localStorage.getItem("login_token");
      let headers = { "Content-Type": "application/json" };
      headers["Authorization"] = `Bearer ${token}`;
      let url = process.env.API_URL + "/patients/" + patient.id;

      let method = "PUT";
      fetch(url, { method: method, body: JSON.stringify(body), headers })
        .then((response) => response.json())
        .then((data) => {
          //history.push({pathname:link, currentDbq:this.state.currentDbq, patient:this.state.patient, questionState:this.state.questions})
        })
        .catch((err) => {
          this.setState({ fetching: false });
          console.error(err);
        });
    }
  }

  //getInprogressExam () {
  // let currentDbq = JSON.parse(localStorage.getItem('currentDbq'));
  // let patient = JSON.parse(localStorage.getItem('patient'));
  // let obj = {
  //     pId : patient.id,
  //     dbqName : currentDbq.name.toLowerCase()
  // }
  // let token = localStorage.getItem('login_token');
  // let headers = {"Content-Type": "application/json"};
  // headers["Authorization"] = `Bearer ${token}`
  // fetch(process.env.API_URL+"/dbq/exam", {method: "post", headers, body: JSON.stringify(obj)} )
  // .then(response => response.json())
  // .then(data => {
  //     if (data && data.questions && data.questions.length>0) {
  //         this.setState({questions: data.questions})
  //     }
  // })
  // .catch((error) => {
  // console.error('Error:', error);
  // });
  //}

  componentWillReceiveProps(newProps) {
    // console.log("this is here receiving")
    // let {patientInfo, fetching, isPatientUpdate, error} = newProps
    // if (isPatientUpdate && !fetching) {
    //     let yesnocurrent = 0;
    //     const { questions, current, totalQuestion } = this.state;
    //     if(questions[current].type === "yesno" && questions[current].answer){
    //         yesnocurrent = questions[current].answer === questions[current].presidence ? 0 : questions[current].ref;
    //     }
    //     let count = current + 1 + yesnocurrent;
    // }
  }
  _addNotification = (message, errorType) => {
    if (errorType === "sub") {
        this.setState({errorMessageSub: message})
    } else {
        this.setState({errorMessage: message})
    }
  }

  getVideoPlayer = (question) => {
    if (question.type === "text" && question.questions[0].video) {
      return (
        <div id="romVideo" style={{ height: "330px" }}>
          {" "}
          <video
            ref="video"
            style={{ width: "300px" }}
            src=""
            type="video/mp4"
          />
        </div>
      );
    }
  };
  getFormElement = (question, index) => {
    const props = {
      name: "name" + index,
      label: "question",
      left: question.left,
      right: question.right,
      options: question.options,
      questions: question.questions,
      rules: question.rules,
      answer: question.answer,
      cols: question.cols,
      istext: question.istext,
      textarea: question.textarea,
      small: question.small,
      textanswer: question.textanswer,
      textAnswer: question.textAnswer,
      refValue: question.refValue,
      multi: question.multi,
      height: question.height,
      position: index,
      placeholder: question.placeholder,
      scarsIndex: question.scarsIndex,
      maxLength: question.maxLength,
      optional: question.optional,
      bulkSubAnswer: question.bulkSubAnswer,
      sectionTitle: question.section ? question.section.title : undefined,
      hasVeteranResponse: question.hasVeteranResponse,
      hasAdditionalResponse: question.hasAdditionalResponse,
      fieldName: question.dbqName || question.textdbqName,
      hideModalTitle: question.hideModalTitle,
      blockedResponses: question.blockedResponses,
      controlledSelectNote: question.controlledSelectNote,
    };

    if (question.type === "text") {
      return (
        <TextField
          onChangeValue={this.handleChangeValue}
          onClickPlayVideo={this.playVideoOverlay}
          videoFirstColumn={this.state.videoFirstColumn}
          videoSecondColumn={this.state.videoSecondColumn}
          onClickCloseVideo={this.closeVideoView}
          selectedVideo={this.state.selectedVideo}
          selectedValue={this.state.selectedValue}
          {...props}
        />
      );
    }

    if (question.type === "select") {
      return (
        <SelectField
          onChangeValue={this.handleChangeValue}
          onClickLegend={this.showLegend}
          isLegendViewing={this.state.isLegendViewing}
          {...props}
        />
      );
    }

    if (question.type === "radio") {
      return <RadioField onChangeValue={this.handleChangeValue} {...props} diagnosesAndExtremities={this.state.diagnosesAndExtremities} />;
    }

    if (question.type === "checkbox") {
      return (
        <CheckBoxField
          onChangeValue={this.handleChangeValue}
          onTyping={this.setTextModal}
          {...props}
        />
      );
    }

    if (question.type === "multicheckbox") {
      return (
        <MultiCheckBoxField
          onChangeValue={this.handleChangeValue}
          onTyping={this.setTextModal}
          {...props}
        />
      );
    }

    if (question.type === "radioTiles") {
      return (
        <RadioTilesField onChangeValue={this.handleChangeValue} {...props} />
      );
    }

    if (question.type === "scarsLoad") {
      return (
        <ScarsLoad
          onChangeValue={this.handleChangeValue}
          addMore={this.addMore}
          deleteScar={this.deleteScar}
          {...props}
        />
      );
    }

    if (question.type === "scarQuestions") {
      let { questions } = this.state;
      let scars = questions[index - question.scarsIndex].questions.scars;
      props.scars = scars;
      //if (scars && scars.length != props.questions[0].scars.length) {
      if (scars && scars.length > props.questions[0].scars.length) {
        let count = scars.length - props.questions[0].scars.length;
        for (let i = 0; i < props.questions.length; i++) {
          for (let j = 1; j <= count; j++) {
            props.questions[i].scars.push({ isAdditional: true, answer: "" });
          }
        }
      }
      return (
        <ScarQuestions
          onChangeValue={this.handleChangeValue}
          loadScarOptions={this.loadScarOptions}
          {...props}
        />
      );
    }

    if (question.type === "disfigurementLoad") {
      return (
        <DisfigurementLoad
          onChangeValue={this.handleChangeValue}
          addMoreDisfigurement={this.addMoreDisfigurement}
          deleteDisfigurement={this.deleteDisfigurement}
          {...props}
        />
      );
    }

    if (question.type === "disfigureQuestions") {
      let { questions } = this.state;
      let scars = questions[index - question.scarsIndex].questions.scars;
      props.scars = scars;
      //if (scars && scars.length != props.questions[0].scars.length) {
      if (scars && scars.length > props.questions[0].scars.length) {
        let count = scars.length - props.questions[0].scars.length;
        for (let i = 0; i < props.questions.length; i++) {
          for (let j = 1; j <= count; j++) {
            props.questions[i].scars.push({ isAdditional: true, answer: "" });
          }
        }
      }
      return (
        <DisfigureQuestions
          onChangeValue={this.handleChangeValue}
          loadScarOptions={this.loadScarOptions}
          {...props}
        />
      );
    }

    if (question.type === "radioModal") {
      return (
        <RadioModal
          onChangeValue={this.handleChangeValue}
          onTyping={this.setTextModal}
          onUpdateRadioModal={this.updateRadioModal}
          onSetBulkSubAnswer={this.setRadioModalBulkSubAnswer}
          toggleCalender={this.toggleCalender}
          showCalender={this.state.showCalender}
          showCalender2={this.state.showCalender2}
          showCalender3={this.state.showCalender3}
          errorMessageSub={this.state.errorMessageSub}
          {...props}
        />
      );
    }

    if (question.type === "textarea") {
      return (
        <TextArea
          onChangeValue={this.handleChangeValue}
          {...props}
          setAdditionalResponse={this.setAdditionalResponse}
          questions={this.state.questions}
        />
      );
    }

    if (question.type === "yesno") {
      return (
        <YesNo
          onChangeValue={this.handleChangeValue}
          {...props}
          setAdditionalResponse={this.setAdditionalResponse}
          questions={this.state.questions}
        />
      );
    }

    if (question.type === "yesnoouter") {
      return <YesNoOuter onChangeValue={this.handleChangeValue} {...props} />;
    }

    if (question.type === "calendar") {
      return (
        <CalendarField
          onChangeValue={this.handleChangeValue}
          onClickLegend={this.showLegend}
          isLegendViewing={this.state.isLegendViewing}
          {...props}
        />
      );
    }
  };

  showQuestions = (questions) => {
    return (
      <MenuQuestions onSelect={this.handleShowQuestion} questions={questions} />
    );
  };

  showMini = () => {
    this.setState({ showMiniDoc: true });
  };

  // getRedHeading = (question) => {
  //     if (question && question.redHeading && !question.question.includes("##redHeading##"))
  //     {
  //         return question.redHeading;
  //     } else {
  //         return ''
  //     }
  // }

  // isRedHeading  = (question) => {
  //     if (question && question.redHeading && !question.question.includes("##redHeading##"))
  //     {
  //         return '-';
  //     } else {
  //         return ''
  //     }
  // }

  withInfoIcon = (question) => {
    if (!this.state.diagnosesAndExtremities) return question;

    const words = question.split(" ");
    const lastWord = words.pop();

    return (
      <span>
        {words.join(" ")}
        <span style={{ whiteSpace: "nowrap" }}>
          {lastWord.length === 1 ? lastWord : ` ${lastWord}`}
          <sup>
            <img
              src="/imgs/app/info-circle.svg"
              alt="More info"
              width="18"
              height="18"
              style={{ cursor: "pointer", marginLeft: "4px" }}
              onClick={this.handleDiagnosesAndExtremitiesView.bind(
                this
              )}
            />
          </sup>
        </span>
      </span>
    );
  };

  getHeading = (question, patient) => {
    let qheading = question.question;

    if (question.redHeading && question.redHeading.length > 0) {
      qheading = qheading.split(question.redHeading);
      return (
        <span>
          {" "}
          {qheading[0]}{" "}
          <span style={{ color: "#079EDA" }}>
            {!qheading[1] ? this.withInfoIcon(question.redHeading) : question.redHeading}
          </span>
          {qheading[1] ? this.withInfoIcon(qheading[1]) : qheading[1]}
          {question.rule && <span className="rule-text">{question.rule}</span>}
        </span>
      );
    }

    return this.withInfoIcon(qheading);
  };

  modelClose = (e) => {
    this.setState({
      isPlayingVideo: false,
      showMiniDoc: false,
    });
  };

  clickExamMenu = (src) => {
    if (src === "btn") {
      this.setState({ showExamMenu: !this.state.showExamMenu });
    }
    if (src === "body" && this.state.showExamMenu) {
      this.setState({ showExamMenu: !this.state.showExamMenu });
    }
  };

  getSteps = (current, count) => {
    let steps = [];
    for (let i = 1; i <= count; i++) {
      if (i <= current) {
        steps.push(
          <div key={i} className="stepper-item completed">
            <div className="step-counter">{i}</div>
          </div>
        );
      } else if (i == current + 1) {
        steps.push(
          <div key={i} className="stepper-item active">
            <div className="step-counter">{i}</div>
          </div>
        );
      } else {
        steps.push(
          <div key={i} className="stepper-item">
            <div className="step-counter">{i}</div>
          </div>
        );
      }
    }
    return steps;
  };

  handleDateSelect = () => {
    alert("handleDateSelect");
  };

  handleDateChange = () => {
    alert("handleDateChange");
  };

  handleDiagnosesAndExtremitiesView() {
    this.setState({
      showDiagnosesAndExtremities: !this.state.showDiagnosesAndExtremities,
    });
  }

  handleOutsideClick(event) {
    if (
      this.diagnosesAndExtremitiesRef &&
      !this.diagnosesAndExtremitiesRef.contains(event.target)
    ) {
      this.setState({ showDiagnosesAndExtremities: false });
    }
  }

  render() {
    const {
      patient = undefined,
      questions,
      current,
      isPlayingVideo,
      errorFlag,
      showMiniDoc,
      unansweredConfirmation,
    } = this.state;
    const question = questions[current];
    const questionNumber = (question.section && question.section.number) ? parseInt(question.section.number, 10) : 0;
    const romanNumber = intToRoman(questionNumber);

    const visibleStepQuestions = getVisibleExamItems(questions);
    const visibleCurrent = visibleStepQuestions.indexOf(question);
    let length = visibleStepQuestions.length;

    // let menuQuestions = this.showQuestions(questions)
    return (
      <div onClick={(e) => this.clickExamMenu("body")}>
        <NotificationSystem ref="notificationSystem" />
        {unansweredConfirmation && (
          <div
            className={unansweredConfirmation.title ? "overlay-msg overlay-msg--detailed" : "overlay-msg"}
            style={{ color: "#333" }}
          >
            <div className="overlay-box">
              <h1>
                <b>{unansweredConfirmation.title || "Confirm Selection"}</b>
              </h1>
              <h4 style={{ lineHeight: 1.45, margin: "25px 0", whiteSpace: "pre-line" }}>
                {unansweredConfirmation.message}
              </h4>
              <Row className="backnext-btn-div">
                <Col xs={6} className="text-center">
                  <Button
                    lg
                    type="button"
                    bsStyle="primary"
                    className="back-btn ripple"
                    onClick={this.closeUnansweredConfirmation}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col xs={6} className="text-center">
                  <Button
                    lg
                    type="button"
                    bsStyle="primary"
                    className="next-btn ripple"
                    onClick={this.confirmUnansweredQuestion}
                  >
                    Confirm
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        )}

        <Prompt
          when={true}
          message={(params) =>
            params.pathname == "/admin/dashboard"
              ? "Are you sure you want to leave the exam?"
              : true
          }
        />

        <div
          ref={this.setStepperRef}
          className="stepper-wrapper"
        >
          {this.getSteps(visibleCurrent, length)}
        </div>
        <Row>
          {/* <Col sm={12} className="text-center paddingLR-90"> */}

          <Col sm={12} style={{ position: "relative" }} className="text-center">
            <div /*className='heading-card' */>
              {/* <span className="col-sm-1" onClick={e => this.clickExamMenu("btn")} style={{fontSize: 20, textAlign: 'left', marginTop: 8, paddingLeft: 10, cursor: 'pointer'}}><Icon glyph={this.state.showExamMenu? 'glyphicon glyphicon-list':'glyphicon glyphicon-align-justify'}/></span> */}
                <span className="section-info">
                  {(question.section && question.section.title) && <p className="slide-info-text section-name"><span className="slide-info-text-bold">DBQ Section: </span>{question.section.title.includes('SECTION') || romanNumber === '0' ? question.section.title : `SECTION ${romanNumber} - ${question.section.title}`}</p>}
                  
                  {(question.section && question.section.number) && <p className="slide-info-text question-name"><span className="slide-info-text-bold">DBQ Question: </span>{question.section.number}</p>}
                </span>

              <span className="col-sm-10">
                <h1 className="heading-main" style={{ marginTop: 0 }}>
                  {/* <strong>{question.question.replace("##name##", patient && patient.name).replace("##redHeading##", question && question.redHeading)} {this.isRedHeading(question)} <span style={{color: "#079EDA"}}> {this.getRedHeading(question) } </span> </strong> */}
                  {/* <strong>{this.getHeading(question, patient)} {this.isRedHeading(question)} <span style={{color: "#079EDA"}}> {this.getRedHeading(question) } </span> </strong> */}
                  {question && (
                    <span>
                      {this.getHeading(question, patient)}{" "}
                      {this.state.diagnosesAndExtremities && (
                        <span ref={this.setDiagnosesAndExtremitiesRef}>
                          <span
                            style={{
                              position: "absolute",
                              zIndex: 100,
                              background: "whitesmoke",
                              border: "1.5px solid black",
                              borderRadius: "10px",
                              padding: "10px 5px 5px 5px",
                              marginLeft: "10px",
                              textAlign: "left",
                              lineHeight: "8px",
                              display: this.state.showDiagnosesAndExtremities
                                ? "inline"
                                : "none",
                            }}
                          >
                            {this.state.diagnosesAndExtremities.length !== 0 ? (
                              this.state.diagnosesAndExtremities.map(
                                (moreInfo, index) => (
                                  <span key={moreInfo.diagnosis + index}>
                                    <h1
                                      style={{
                                        fontSize: "15px",
                                        margin: "8px",
                                      }}
                                    >
                                      Diagnosis: {moreInfo.diagnosis}
                                    </h1>
                                    {moreInfo.extremity && (
                                      <h1
                                        style={{
                                          fontSize: "15px",
                                          margin: "8px",
                                        }}
                                      >
                                        Extremity: {moreInfo.extremity}
                                      </h1>
                                    )}
                                    {this.state.diagnosesAndExtremities.length -
                                      1 ===
                                    index ? null : (
                                      <br />
                                    )}
                                  </span>
                                )
                              )
                            ) : (
                              <h1 style={{ fontSize: "15px", margin: "8px" }}>
                                Not available
                              </h1>
                            )}
                          </span>
                        </span>
                      )}
                    </span>
                  )}
                </h1>
                <h3 className="heading-main-sub" style={{ whiteSpace: "pre-line" }}>
                  {question &&
                    question.sub.replace("##name##", patient && patient.name)}
                  {question && question.rule && (
                    <span className="rule-text">{question.rule}</span>
                  )}
                </h3>

                {/* {current+1} of {length} */}
                {/* <div className="stepper-wrapper">
                            {this.getSteps(current, length)}
                        </div> */}
                {question && question.note && (
                  <Row>
                    <Col
                      sm={12}
                      className="text-center"
                      style={{
                        color: "#F12F39",
                        marginBottom: 20,
                        marginTop: -10,
                      }}
                    >
                      <div>
                        <b style={{ fontSize: 18 }}>Note: </b>
                        {question.note}
                      </div>
                    </Col>
                  </Row>
                )}
                {isPlayingVideo && (
                  <PlayRomVideo
                    onClose={(e) => this.modelClose(e)}
                    url={this.state.videoUrl}
                    value={this.state.videoValue}
                  />
                )}
                {showMiniDoc && (
                  <MiniDocumentViewer
                    onClose={(e) => this.modelClose(e)}
                    url={`user-mini-${this.state.patient.id}-${this.state.currentDbq.id}`}
                  />
                  )}
                {question.image && <img style={{ marginBottom: 20, width: 180 }} alt="DBQ Exam" src={question.image} />}
              </span>

              <span className="col-sm-12">
                {question && this.getFormElement(question, current)}
              </span>
            </div>

            <div
              className={
                this.state.showExamMenu ? "exam-menu-open" : "exam-menu"
              }
            >
              {this.state.showExamMenu && (
                <div>
                  <div>
                    <h3
                      onClick={this.showMini}
                      style={{ color: "#079EDA", cursor: "pointer" }}
                    >
                      View Patient's Mini document{" "}
                    </h3>
                  </div>
                  <div>
                    <h3>Questions </h3>
                  </div>
                  <div>
                    {/* <div sm={3}></div>
                                    <div sm={9}></div> */}
                    {this.state.showExamMenu && this.showQuestions(questions)}
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
        {/* {errorFlag && <Row>
                    <Col sm={8}>Field is required</Col>
                </Row>
                } */}
        <div className="error-container">
          {this.state.errorMessage && (
            <p className="error-message">{this.state.errorMessage}</p>
          )}
        </div>
        <Row className="backnext-btn-div">
          <Col className="text-center btn-back">
            <Button
              lg
              type="button"
              bsStyle="primary"
              className="back-btn big-btn"
              onClick={this.back.bind(this)}
            >
              <span className="backiconspan">
                <svg
                  width="17"
                  height="20"
                  viewBox="0 0 17 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.48866 0L9.97699 1.7625L4.08699 8.75H16.9331V11.25H4.08699L9.97699 18.2375L8.48866 20L0.0442162 10L8.48866 0Z"
                    fill="#797979"
                  />
                </svg>
              </span>
              Back
            </Button>
          </Col>

          {(question.section && question.section.page) && <p className="page-number slide-info-text"><span className="slide-info-text-bold">DBQ Page: </span>{question.section.page}</p>}

          <Col className="text-center btn-next">
            {this.state.page === "review" ? (
              <Button
                lg
                type="button"
                bsStyle="primary"
                className="review-btn big-btn m-r-20"
                onClick={this.reviewDoneBtn.bind(this, current)}
              >
                Done
              </Button>
            ) : (
              <Button
                lg
                type="button"
                bsStyle="primary"
                className="next-btn big-btn"
                onClick={this.nextBtn.bind(this, current)}
              >
                Next{" "}
                {this.checkFieldValue(current) ? (
                  <span className="nexticonspan arrow-animate">
                    <svg
                      width="18"
                      height="20"
                      viewBox="0 0 18 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.82237 0L7.33404 1.7625L13.224 8.75H0.37793V11.25H13.224L7.33404 18.2375L8.82237 20L17.2668 10L8.82237 0Z"
                        fill="#fff"
                      />
                    </svg>
                  </span>
                ) : (
                  ""
                )}
              </Button>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps =
  (state) =>
  ({
    patient: {
      specific: { patientInfo, fetching, error, isPatientUpdate },
    },
  }) => {
    return {
      patientInfo,
      fetching,
      error,
      isPatientUpdate,
    };
  };

const mapDispatchToProps = (dispatch) => ({
  updatePatientDoc: (
    id,
    apptDate,
    dbq,
    name_fv,
    questions,
    ssn,
    status,
    patientName,
    dbqId,
    isPreviousVersion,
    apptId,
    questionIndex
  ) => {
    dispatch(
      PatientActions.updateSpecificPatientRequest({
        id,
        apptDate,
        dbq,
        name_fv,
        questions,
        ssn,
        status,
        patientName,
        dbqId,
        isPreviousVersion,
        apptId,
        questionIndex,
      })
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Exam);
